<template>
  <div>
    <modern-loader :loading="loadingStuff" :message="loadIngStuffText" />
    <app-template />
    <div
      v-if="adminNavigationSelectedTeam === false && showallTeams === true"
      class="uk-container uk-container-large container"
    >
      <div class="sessons-header">
        <div class="header-buttons">
          <h2>Teams overview</h2>
        </div>

        <section class="teams-overview-wrapper">
          <ul class="tabs headding-space">
            <li class="tab-item">
              <a
                :class="
                  selectedTabTeamsOverview === 'teams-over-view-tab'
                    ? 'tab-link active'
                    : 'tab-link'
                "
                @click="
                  tabChange('selectedTabTeamsOverview', 'teams-over-view-tab')
                "
                href="javascript:;"
                >Teams</a
              >
            </li>
          </ul>

          <div class="tabs-wrapper">
            <div
              class="team-over-veiw-tab tab-content"
              v-if="selectedTabTeamsOverview === 'teams-over-view-tab'"
            >
              <div class="number-of-results">
                <p>Number of teams: {{ clubTeams.length }}</p>
              </div>

              <div class="button-wrapper-top filters-sort">
                <b-button
                  @click="toggleFilters = !toggleFilters"
                  variant="outline-success filter-small"
                >
                  <i class="bi bi-filter" aria-hidden="true"></i>
                  Filters</b-button
                >

                <div class="filters" v-if="toggleFilters === true">
                  <b-form-select
                    class="mb-3"
                    @change="
                      filterBy('allTeamDataBeforFilterApplied', 'teamName')
                    "
                    v-model="selectedFilterData"
                  >
                    <b-form-select-option :value="null" disabled
                      >Select a team</b-form-select-option
                    >
                    <b-form-select-option
                      v-for="(team, index) in clubTeams"
                      :key="team.id + index"
                      :value="team.teamName"
                      >{{ team.teamName }}</b-form-select-option
                    >
                  </b-form-select>
                  <a
                    @click="removeFilter()"
                    v-if="hideRemoveTeamFilterButton === false"
                    href="javascript:;"
                    class="remove-icon-button"
                    ><i class="bi bi-x" font-scale="2" aria-hidden="true"></i
                  ></a>
                </div>
              </div>
              <div class="tab-content">
                <template v-if="clubTeams.length > 0">
                  <div
                    v-for="(team, index) in clubTeams"
                    :value="team.id + index"
                    :key="team.id"
                    class="team-profile-details"
                    @click="setSelectedTeam(team)"
                  >
                    <div class="user-photo-info">
                      <TenantLogo logo-class="login-logo" />
                    </div>
                    <div class="team-info">
                      <h2>{{ team.teamName }}</h2>
                      <p>Age group: {{ team.age_group }}</p>
                      <p>Coach: {{ team.name }}</p>
                    </div>
                    <span
                      class="team-form-results"
                      v-if="
                        allTeamsGameResultsData.length > 0 &&
                        userData.userType !== 'User'
                      "
                    >
                      <span
                        v-for="(pastGame, i) in allTeamsGameResultsData"
                        :key="i"
                      >
                        <span
                          v-if="team.teamId == pastGame.teamId"
                          :class="`result-${checkGameResult(pastGame)}`"
                          >{{ checkGameResult(pastGame) }}</span
                        >
                      </span>
                    </span>
                    <span v-else>No game results</span>
                  </div>
                </template>
                <div class="empty-state" v-else>
                  <img src="../img/emptyStateIllustration.svg" />
                  <p>No Team information</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div
      v-else
      class="uk-container uk-container-large container team-page with-drawer"
      :class="{ 'nav-collapsed': navCollapsed }"
    >
      <div class="sessons-header">
        <div class="select-user">
          <template v-if="clubTeams.length > 1">
            <label class="form__label" for="userSelect">Select team </label>
            <select
              v-model="selectedTeamName"
              @change="setSelectedTeam(selectedTeamName)"
              id="userSelect"
            >
              <option
                v-for="(clubTeam, index) in clubTeams"
                :value="clubTeam.teamName"
                :key="clubTeam.id + index"
              >
                {{ clubTeam.teamName }}
              </option>
            </select>
          </template>

          <div class="season_info">
            <h1>{{ selectedTeam.teamName }}</h1>
            <p>Age group: {{ selectedTeam.age_group }}</p>
            <p v-if="userData.userType === 'Coach'">
              Coach: {{ userData.name }}
            </p>
            <p v-else>Coach: {{ selectedTeam.name }}</p>
            <p v-if="selectedTeam.season_start_date">
              Season: {{ dayMonthYear(selectedTeam.season_start_date) }} -
              {{ dayMonthYear(selectedTeam.season_end_date) }}
            </p>
          </div>
        </div>
        <!--<div v-if="userData.userType === 'User'" class="header-buttons">
          <span class="week-selected-dates-text">
            <div class="season_info">
              <h1>{{ selectedTeam.teamName }}</h1>
              <p>Age group: {{ selectedTeam.age_group }}</p>
              <p>Coach: {{ selectedTeam.name }}</p>
              <p>
                Season: {{ dayMonthYear(selectedTeam.season_start_date) }} -
                {{ dayMonthYear(selectedTeam.season_end_date) }}
              </p>
            </div>
            <span class="week-selected-dates-text">
              Week number: {{ weekSelectedNumber }} |
              {{ selectedWeekMonSunday }}</span
            ></span
          >
        </div>-->
      </div>
      <button
        @click="showEditAddGamesModal()"
        v-if="userData.userType === 'Admin' || userData.userType === 'Coach'"
        class="green-button add-new-programme"
      >
        Add new event
      </button>
      <SectionNav
        title="Team"
        :items="teamNavItems"
        :active="selectedTab"
        v-model:collapsed="navCollapsed"
        @select="(k) => tabChange('selectedTab', k)"
      />
      <div class="tabs-wrapper">
        <div
          class="current-week-tab tab-content"
          v-if="selectedTab === 'games-tab'"
        >
          <div class="lead-tabs-filters">
            <div class="lead-filters">
              <div class="filter-group games-date-range-group">
                <label class="filter-label">Date range</label>
                <VueDatePicker
                  ref="picker"
                  :locale="'en-GB'"
                  :locale-data="dateRangePickerLocaleData"
                  :range="{ autoRange: false }"
                  @update:model-value="dateRangeSelected"
                  :model-value="dateRange"
                  :enable-time-picker="false"
                  format="dd/MM/yyyy"
                >
                  <template v-slot:input="picker">
                    <i class="bi bi-calendar3"></i>
                    {{ formatMatchDate(picker.startDate) }} -
                    <i class="bi bi-calendar3"></i>
                    {{ formatMatchDate(picker.endDate) }}
                  </template>
                </VueDatePicker>
              </div>
              <div class="filter-group">
                <label class="filter-label">Window</label>
                <b-form-checkbox
                  id="checkbox-full-season"
                  v-model="fullSeasonCheckBoxData"
                  @change="fullSeasonCheckBox()"
                  name="checkbox-full-season"
                  class="filter-checkbox-inline"
                >
                  Full Season
                </b-form-checkbox>
              </div>
              <button
                type="button"
                class="filter-reset"
                @click="dateRangeReset()"
                v-b-tooltip.hover
                title="Reset date range"
              >
                <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
                Reset
              </button>
            </div>
          </div>

          <div
            v-if="
              (userData.userType === 'Admin' ||
                userData.userType === 'Coach') &&
              hasFeature('cometExplorer')
            "
            class="cas-buttons"
            style="width: 100%"
          >
            <button @click="CASfixturesModal = true">
              view all CAS fixtures
            </button>
            <button @click="createNewGameFromCASdata">
              Populate CAS fixtures
            </button>
          </div>

          <div class="games" v-if="thisWeeksGames.length > 0">
            <p class="games-section-heading">
              Upcoming games
              <span class="games-count-badge">{{ thisWeeksGames.length }}</span>
            </p>
            <sorting-by-created-date
              :arrayDataForSorting="thisWeeksGames"
              sortingByValue="matchDate"
              @sorted-data-call="
                (data) => sortedDataCall(data, 'thisWeeksGames')
              "
            />
            <div
              v-for="(game, index) in thisWeeksGames"
              :key="index"
              class="game"
              :id="game.id + index"
            >
              <div
                class="game-wrapper"
                @click="showGameDetails(game, 'viewGameDetails')"
              >
                <div class="match-details">
                  <span>{{ game.gameType }}</span>
                  <p v-if="game.result_added == '0'" class="teams">
                    {{ selectedTeam.teamName }} <span>v</span>
                    {{ game.opposition }}
                  </p>
                  <p class="game-info">
                    <span
                      ><i class="bi bi-calendar3"></i
                      >{{ getDayAndDate(game.matchDate) }}</span
                    >
                    <span
                      ><i class="bi bi-stopwatch"></i
                      >{{ formatISOStringDateAndTime(game.kickOffTime) }}</span
                    >
                  </p>
                </div>
              </div>
              <div
                v-if="
                  userData.userType === 'Admin' || userData.userType === 'Coach'
                "
                class="player-game-responce"
              >
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Edit',
                    )
                  "
                  variant="outline-warning"
                  v-b-tooltip.hover
                  title="Edit"
                  ><i class="bi bi-pencil" aria-hidden="true"></i
                ></b-button>
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Delete',
                    )
                  "
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete"
                  ><i class="bi bi-trash" aria-hidden="true"></i
                ></b-button>

                <b-button
                  v-if="
                    userData.userType === 'Admin' ||
                    (userData.userType === 'Coach' &&
                      currentTeam.length > 0 &&
                      !$store.getters.isReadOnlySeason)
                  "
                  @click="addNewGameresultModal(game, 'addNewGameresultModal')"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Add game result"
                  ><i class="bi bi-file-text"></i
                ></b-button>

                <template
                  v-if="
                    userData.userType === 'Admin' ||
                    (userData.userType === 'Coach' && currentTeam.length > 0)
                  "
                >
                  <b-button
                    v-if="!isGrassrootsTier() && checkIfGameHasAnalysis(game.id) === true"
                    @click="gameAnalysisModal(game, 'gameAnalysisModal')"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="View / Edit Game analysis"
                    ><i class="bi bi-eye"></i
                  ></b-button>

                  <b-button
                    v-else-if="!isGrassrootsTier()"
                    @click="gameAnalysisModal(game, 'gameAnalysisModal')"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="Add Game analysis"
                    ><i class="bi bi-book"></i
                  ></b-button>

                  <b-button
                    v-if="hasFeature('gpsReports')"
                    @click="openImportCSVModal(game.id)"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="Add Game GPS data"
                    ><i class="bi bi-smartwatch"></i
                  ></b-button>
                </template>

                <b-button
                  v-if="
                    !isGrassrootsTier() &&
                    (userData.userType === 'Admin' ||
                      (userData.userType === 'Coach' && currentTeam.length > 0))
                  "
                  @click="openMatchReportModal(game)"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Match report"
                  ><i class="bi bi-journal-text"></i
                ></b-button>
                <span
                  class="recurring-event-icon"
                  v-if="game.recurringEventType !== null"
                  v-b-tooltip.hover
                  title="This is a recurring event"
                  ><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="games">
              <div class="empty-state">
                <img src="../img/emptyStateIllustration.svg" />
                <p>No upcoming games</p>
              </div>
            </div>
          </template>

          <div class="games" v-if="pastGames.length > 0">
            <div class="games-section-heading">
              <span>Past games / results</span>
              <span class="games-count-badge">{{ pastGames.length }}</span>
              <button
                v-if="eyeBallTeamsGames.length > 0"
                @click="openEyeballLinkingModal()"
                class="eyeball-action-btn ml-2"
                v-b-tooltip.hover
                title="Link Eyeball players to app players"
              >
                <i class="bi bi-link-45deg"></i> Manage Eyeball Player Links
              </button>
            </div>
            <div class="team-form-results">
              <sorting-by-created-date
                :arrayDataForSorting="pastGames"
                sortingByValue="matchDate"
                @sorted-data-call="(data) => sortedDataCall(data, 'pastGames')"
              />
              <p class="highlighted-text">
                <i class="bi bi-info-circle" aria-hidden="true"></i>
                Results will be displayed only for games where the outcome has
                been recorded.
              </p>
              <span v-for="(pastGame, i) in pastGames" :key="i">
                <span
                  v-if="
                    pastGame.result_added == '1' && userData.userType !== 'User'
                  "
                  :class="`result-${checkGameResult(pastGame)}`"
                  >{{ checkGameResult(pastGame) }}</span
                >
              </span>
            </div>
            <div
              v-for="(game, index) in pastGames"
              :key="index"
              class="game"
              :id="game.id"
            >
              <div
                class="game-wrapper"
                @click="showGameDetails(game, 'viewGameDetails')"
              >
                <div class="match-details">
                  <span>{{ game.gameType }}</span>
                  <p v-if="game.result_added == '0'" class="teams">
                    {{ selectedTeam.teamName }} <span>v</span>
                    {{ game.opposition }}
                  </p>
                  <div class="with-results" v-else>
                    <p class="teams">
                      {{ selectedTeam.teamName }}
                      <span class="goal-number">{{
                        game.home_team_goals
                      }}</span>
                      <span>v</span>
                      <span class="goal-number">{{
                        game.away_team_goals
                      }}</span>
                      {{ game.opposition }}
                    </p>

                    <div
                      v-if="game.result_added != '0'"
                      class="goal-and-game-events"
                    >
                      <span
                        class="goal-scorers-text"
                        v-for="goal in allGameGoalScorersData"
                        :key="goal.id"
                      >
                        <span v-if="goal.game_id === game.id">
                          <img src="./img/goal-icon.svg" /><span
                            v-if="
                              goal.goal_time &&
                              goal.goal_time !== '0' &&
                              goal.goal_time !== ''
                            "
                            >{{ goal.goal_time }}'</span
                          >
                          {{ getPlayerFromId(goal.userId)
                          }}<span v-if="parseInt(goal.goal) > 1">
                            x{{ goal.goal }}</span
                          >
                          <span v-if="goal.goal_type === 'Fee kick'">(FK)</span>
                          <span v-if="goal.goal_type === 'Pentaly'">(P)</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <p class="game-info">
                    <span
                      ><i class="bi bi-calendar3"></i
                      >{{ getDayAndDate(game.matchDate) }}</span
                    >
                    <span
                      ><i class="bi bi-stopwatch"></i
                      >{{ formatISOStringDateAndTime(game.kickOffTime) }}</span
                    >
                  </p>
                </div>
              </div>
              <div
                v-if="
                  userData.userType === 'Admin' || userData.userType === 'Coach'
                "
                class="player-game-responce"
              >
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Edit',
                    )
                  "
                  variant="outline-warning"
                  v-b-tooltip.hover
                  title="Edit"
                  ><i class="bi bi-pencil" aria-hidden="true"></i
                ></b-button>
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Delete',
                    )
                  "
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete"
                  ><i class="bi bi-trash" aria-hidden="true"></i
                ></b-button>
                <b-button
                  v-if="
                    userData.userType === 'Admin' ||
                    (userData.userType === 'Coach' &&
                      currentTeam.length > 0 &&
                      !$store.getters.isReadOnlySeason)
                  "
                  @click="addNewGameresultModal(game, 'addNewGameresultModal')"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Add game result"
                  ><i class="bi bi-file-text"></i
                ></b-button>

                <template
                  v-if="
                    userData.userType === 'Admin' ||
                    (userData.userType === 'Coach' && currentTeam.length > 0)
                  "
                >
                  <b-button
                    v-if="!isGrassrootsTier() && checkIfGameHasAnalysis(game.id) === true"
                    @click="gameAnalysisModal(game, 'gameAnalysisModal')"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="View / Edit Game analysis"
                    ><i class="bi bi-eye"></i
                  ></b-button>

                  <b-button
                    v-else-if="!isGrassrootsTier()"
                    @click="gameAnalysisModal(game, 'gameAnalysisModal')"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="Add Game analysis"
                    ><i class="bi bi-book"></i
                  ></b-button>
                  <b-button
                    v-if="hasFeature('gpsReports')"
                    @click="openImportCSVModal(game)"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="Add Game GPS data"
                    ><i class="bi bi-smartwatch"></i
                  ></b-button>
                </template>
                <b-button
                  v-if="
                    !isGrassrootsTier() &&
                    (userData.userType === 'Admin' ||
                      (userData.userType === 'Coach' && currentTeam.length > 0))
                  "
                  @click="openMatchReportModal(game)"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Match report"
                  ><i class="bi bi-journal-text"></i></b-button
                ><span
                  class="recurring-event-icon"
                  v-if="game.recurringEventType !== null"
                  v-b-tooltip.hover
                  title="This is a recurring event"
                  ><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                </span>

                <b-button
                  v-if="checkEyeBallMatchData(game) !== undefined"
                  @click="openEyeballMatchDataModal(game)"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Eyeball Match Data"
                  ><i class="bi bi-person-video"></i
                ></b-button>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="games">
              <div class="empty-state">
                <img src="../img/emptyStateIllustration.svg" />
                <p>No past games</p>
              </div>
            </div>
          </template>
        </div>

        <div
          class="current-week-tab tab-content"
          v-if="selectedTab === 'training-tab'"
        >
          <div class="lead-tabs-filters">
            <div class="lead-filters">
              <div class="filter-group games-date-range-group">
                <label class="filter-label">Date range</label>
                <VueDatePicker
                  ref="picker"
                  :locale="'en-GB'"
                  :locale-data="dateRangePickerLocaleData"
                  :range="{ autoRange: false }"
                  @update:model-value="dateRangeSelected"
                  :model-value="dateRange"
                  :enable-time-picker="false"
                  format="dd/MM/yyyy"
                >
                  <template v-slot:input="picker">
                    <i class="bi bi-calendar3"></i>
                    {{ formatMatchDate(picker.startDate) }} -
                    <i class="bi bi-calendar3"></i>
                    {{ formatMatchDate(picker.endDate) }}
                  </template>
                </VueDatePicker>
              </div>
              <div class="filter-group">
                <label class="filter-label">Window</label>
                <b-form-checkbox
                  id="checkbox-full-season-training"
                  v-model="fullSeasonCheckBoxData"
                  @change="fullSeasonCheckBox()"
                  name="checkbox-full-season-training"
                  class="filter-checkbox-inline"
                >
                  Full Season
                </b-form-checkbox>
              </div>
              <button
                type="button"
                class="filter-reset"
                @click="dateRangeReset()"
                v-b-tooltip.hover
                title="Reset date range"
              >
                <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
                Reset
              </button>
            </div>
          </div>

          <!-- Bulk Actions Bar for Training -->
          <div
            v-if="
              userData.userType === 'Admin' || userData.userType === 'Coach'
            "
            class="bulk-actions-bar"
          >
            <div class="bulk-mode-toggle">
              <b-form-checkbox
                v-model="bulkTrainingMode"
                @change="toggleBulkTrainingMode"
                switch
              >
                Bulk Edit Mode
              </b-form-checkbox>
            </div>
            <div v-if="bulkTrainingMode" class="bulk-actions-buttons">
              <span class="selected-count"
                >{{ selectedTrainingSessions.length }} selected</span
              >
              <b-button
                @click="selectAllTrainingSessions"
                variant="outline-primary"
                size="sm"
              >
                <i class="bi bi-check-all"></i> Select All
              </b-button>
              <b-button
                @click="clearTrainingSelection"
                variant="outline-secondary"
                size="sm"
                :disabled="selectedTrainingSessions.length === 0"
              >
                <i class="bi bi-x-lg"></i> Clear
              </b-button>
              <b-button
                @click="openBulkEditTrainingModal"
                variant="outline-warning"
                size="sm"
                :disabled="selectedTrainingSessions.length === 0"
              >
                <i class="bi bi-pencil"></i> Edit Selected
              </b-button>
              <b-button
                @click="openBulkDeleteTrainingModal"
                variant="outline-danger"
                size="sm"
                :disabled="selectedTrainingSessions.length === 0"
              >
                <i class="bi bi-trash"></i> Delete Selected
              </b-button>
            </div>
          </div>

          <div class="games" v-if="thisWeeksTraining.length > 0">
            <p class="games-section-heading">
              Upcoming training
              <span class="games-count-badge">{{
                thisWeeksTraining.length
              }}</span>
            </p>
            <sorting-by-created-date
              :arrayDataForSorting="thisWeeksTraining"
              sortingByValue="matchDate"
              @sorted-data-call="
                (data) => sortedDataCall(data, 'thisWeeksTraining')
              "
            />
            <div
              v-for="(game, index) in thisWeeksTraining"
              :key="index"
              class="game"
              :class="{ 'selected-training': isTrainingSelected(game) }"
              :id="game.id"
            >
              <div
                v-if="bulkTrainingMode"
                class="bulk-checkbox-wrapper"
                @click.stop
              >
                <b-form-checkbox
                  :checked="isTrainingSelected(game)"
                  @change="toggleTrainingSelection(game)"
                  class="bulk-select-checkbox"
                />
              </div>
              <div
                class="game-wrapper"
                @click="
                  bulkTrainingMode
                    ? toggleTrainingSelection(game)
                    : showGameDetails(game, 'viewGameDetails')
                "
              >
                <div class="match-details">
                  <p class="teams">
                    {{ game.gameType }}
                    <span class="small-text">{{ setPitchZoneText(game) }}</span>
                  </p>
                  <p class="game-info">
                    <span
                      ><i class="bi bi-calendar3"></i
                      >{{ getDayAndDate(game.matchDate) }}</span
                    >
                    <span
                      ><i class="bi bi-stopwatch"></i
                      >{{ formatISOStringDateAndTime(game.kickOffTime) }} -
                      {{ formatISOStringDateAndTime(game.endTime) }}</span
                    >
                  </p>
                </div>
              </div>
              <div
                v-if="
                  userData.userType === 'Admin' || userData.userType === 'Coach'
                "
                class="player-game-responce"
              >
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Edit',
                    )
                  "
                  variant="outline-warning"
                  v-b-tooltip.hover
                  title="Edit"
                  ><i class="bi bi-pencil" aria-hidden="true"></i
                ></b-button>
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Delete',
                    )
                  "
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete"
                  ><i class="bi bi-trash" aria-hidden="true"></i
                ></b-button>
                <b-button
                  v-if="hasFeature('gpsReports')"
                  @click="openImportCSVModal(game)"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Add Training GPS data"
                  ><i class="bi bi-smartwatch"></i
                ></b-button>
                <span
                  class="recurring-event-icon"
                  v-if="game.recurringEventType !== null"
                  v-b-tooltip.hover
                  title="This is a recurring event"
                  ><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="games">
              <div class="empty-state">
                <img src="../img/emptyStateIllustration.svg" />
                <p>No upcoming training</p>
              </div>
            </div>
          </template>

          <div class="games" v-if="pastTraining.length > 0">
            <p class="games-section-heading">
              Past training
              <span class="games-count-badge">{{ pastTraining.length }}</span>
            </p>
            <sorting-by-created-date
              :arrayDataForSorting="pastTraining"
              sortingByValue="matchDate"
              @sorted-data-call="(data) => sortedDataCall(data, 'pastTraining')"
            />
            <div
              v-for="(game, index) in pastTraining"
              :key="index"
              class="game"
              :class="{ 'selected-training': isTrainingSelected(game) }"
              :id="game.id"
            >
              <div
                v-if="bulkTrainingMode"
                class="bulk-checkbox-wrapper"
                @click.stop
              >
                <b-form-checkbox
                  :checked="isTrainingSelected(game)"
                  @change="toggleTrainingSelection(game)"
                  class="bulk-select-checkbox"
                />
              </div>
              <div
                class="game-wrapper"
                @click="
                  bulkTrainingMode
                    ? toggleTrainingSelection(game)
                    : showGameDetails(game, 'viewGameDetails')
                "
              >
                <div class="match-details">
                  <p class="teams">
                    {{ game.gameType }}
                    <span class="small-text">{{ setPitchZoneText(game) }}</span>
                  </p>
                  <p class="game-info">
                    <span
                      ><i class="bi bi-calendar3"></i
                      >{{ getDayAndDate(game.matchDate) }}</span
                    >
                    <span
                      ><i class="bi bi-stopwatch"></i
                      >{{ formatISOStringDateAndTime(game.kickOffTime) }} -
                      {{ formatISOStringDateAndTime(game.endTime) }}</span
                    >
                  </p>
                </div>
              </div>
              <div
                v-if="
                  userData.userType === 'Admin' || userData.userType === 'Coach'
                "
                class="player-game-responce"
              >
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Edit',
                    )
                  "
                  variant="outline-warning"
                  v-b-tooltip.hover
                  title="Edit"
                  ><i class="bi bi-pencil" aria-hidden="true"></i
                ></b-button>
                <b-button
                  @click="
                    editDeleteGameOptionsModal(
                      game,
                      'viewGameDeleteEditOptions',
                      'Delete',
                    )
                  "
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete"
                  ><i class="bi bi-trash" aria-hidden="true"></i
                ></b-button>
                <b-button
                  v-if="hasFeature('gpsReports')"
                  @click="openImportCSVModal(game)"
                  variant="outline-success"
                  v-b-tooltip.hover
                  title="Add Training GPS data"
                  ><i class="bi bi-smartwatch"></i
                ></b-button>
                <span
                  class="recurring-event-icon"
                  v-if="game.recurringEventType !== null"
                  v-b-tooltip.hover
                  title="This is a recurring event"
                  ><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="games">
              <div class="empty-state">
                <img src="../img/emptyStateIllustration.svg" />
                <p>No past training</p>
              </div>
            </div>
          </template>
        </div>

        <div
          class="current-week-tab tab-content team-chat-wrapper"
          v-if="selectedTab === 'full-team-chat'"
        >
          <TeamDashboard
            :key="chatComponentKey"
            :userData="userData"
            :selectedTeam="selectedTeam"
            :currentTeam="currentTeam"
          />
        </div>

        <div
          class="current-week-tab tab-content team-tab-content"
          v-if="selectedTab === 'full-team-tab'"
        >
          <div class="team-content">
            <div class="team-types">
              <div class="full-team" v-if="currentTeam.length > 0">
                <strength-test-uploader
                  :openStrengthTestModal="openStrengthTestModalValue"
                  @close="openStrengthTestModalValue"
                  @update:openStrengthTestModalCall="
                    openStrengthTestModalValue = $event
                  "
                  :gameTrainingData="gameTrainingData"
                  :players="currentTeam"
                ></strength-test-uploader>

                <div class="buttons-wrapper">
                  <div class="buttons-row">
                    <b-button
                      v-if="
                        userData.userType === 'Admin' ||
                        userData.userType === 'Coach'
                      "
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Add Physical Performance data"
                      @click="openStrengthTestModalCall(true)"
                      ><i class="bi bi-watch" aria-hidden="true"></i>
                    </b-button>
                  </div>
                </div>
                <div class="lead-tabs-filters" v-if="currentTeam.length > 0">
                  <div class="lead-filters">
                    <div class="filter-group">
                      <label class="filter-label">Position</label>
                      <b-form-select
                        v-model="filterMembersPosition"
                        :options="membersPositionOptions"
                        class="filter-select"
                      />
                    </div>
                    <div class="filter-group">
                      <label class="filter-label">Age group</label>
                      <b-form-select
                        v-model="filterMembersAgeGroup"
                        :options="membersAgeGroupOptions"
                        class="filter-select"
                      />
                    </div>
                    <div class="filter-group">
                      <label class="filter-label">Injury status</label>
                      <b-form-select
                        v-model="filterMembersInjury"
                        :options="membersInjuryOptions"
                        class="filter-select"
                      />
                    </div>
                    <button
                      v-if="
                        filterMembersPosition ||
                        filterMembersAgeGroup ||
                        filterMembersInjury
                      "
                      type="button"
                      class="filter-reset"
                      @click="
                        filterMembersPosition = '';
                        filterMembersAgeGroup = '';
                        filterMembersInjury = '';
                      "
                    >
                      <i class="bi bi-x-circle" aria-hidden="true"></i> Reset
                    </button>
                  </div>
                </div>

                <h3 class="games-section-heading">
                  First team
                  <span class="games-count-badge">{{
                    filteredCurrentTeam.length
                  }}</span>
                </h3>
                <div
                  class="members-table-wrapper"
                  v-if="filteredCurrentTeam.length > 0"
                >
                  <table class="w-a-style members-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Number</th>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Age group</th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="League Games attended"
                        >
                          LG
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="Cup Games attended"
                        >
                          CG
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="Training sessions attended"
                        >
                          TR
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="Total minutes played"
                        >
                          Mins
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="Average RPE (1-10)"
                        >
                          RPE
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="Team training sessions"
                        >
                          Team
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="S&C sessions"
                        >
                          S&amp;C
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          title="Own training sessions"
                        >
                          Own
                        </th>
                        <th
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          Profile
                        </th>
                        <th>Type</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="player in filteredCurrentTeam"
                        :key="player.id"
                        :class="
                          player.injury === true ? 'injury-table-style' : ''
                        "
                      >
                        <td>
                          <img
                            class="player-photo"
                            v-if="
                              player.userImage !== null &&
                              player.userImage !== ''
                            "
                            :src="getImgUrl(player.userImage)"
                          />
                          <TenantLogo
                            v-else
                            logo-class="login-logo"
                            class="player-photo"
                          />
                        </td>
                        <td>{{ player.match_day_kit_number }}</td>
                        <td>
                          {{ player.name }}
                          <i v-if="player.has_medical_conditions == 1" class="bi bi-heart-pulse-fill medical-flag"
                            title="Medical information on file - see profile" aria-label="Medical information on file"></i>
                        </td>
                        <td>{{ player.position }}</td>
                        <td>{{ player.age_group }}</td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.gameAttendance }}
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.cupGameAttendance }}
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.trainingAttendance }}
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.totalMins || 0 }}
                          <span
                            v-if="player.minsSource"
                            class="mins-source-dot"
                            :class="'mins-source-' + player.minsSource"
                            v-b-tooltip.hover
                            :title="getMinsSourceTooltip(player)"
                          ></span>
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          <span
                            v-if="player.avgRpe !== null"
                            class="rpe-badge"
                            :class="getRpeBadgeClass(player.avgRpe)"
                          >
                            {{ player.avgRpe }}
                          </span>
                          <span v-else>-</span>
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.teamTrainingSessions || 0 }}
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.scTrainingSessions || 0 }}
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          {{ player.ownTrainingSessions || 0 }}
                        </td>
                        <td
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                        >
                          <a href="javascript:;" @click="goToPlayer(player)"
                            >View</a
                          >
                        </td>

                        <td class="trialist" v-if="hasFeature('trialists') && player.trialistId !== null">
                          <i class="bi bi-person" aria-hidden="true"></i>
                          Trialist
                        </td>
                        <td v-else>
                          <i class="bi bi-person" aria-hidden="true"></i> First
                          team
                        </td>
                        <!--<td>0</td>-->
                        <td class="red-warning" v-if="player.injury === true">
                          Injured
                        </td>
                        <td class="green-success" v-else><span>fit</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-if="filteredCurrentTeam.length === 0"
                  class="empty-state"
                >
                  <img src="../img/emptyStateIllustration.svg" />
                  <p>No team members match your current filters.</p>
                  <button
                    type="button"
                    class="filter-reset"
                    @click="
                      filterMembersPosition = '';
                      filterMembersAgeGroup = '';
                      filterMembersInjury = '';
                    "
                  >
                    <i class="bi bi-x-circle" aria-hidden="true"></i> Clear
                    filters
                  </button>
                </div>
              </div>
              <div v-else class="empty-state">
                <img src="../img/emptyStateIllustration.svg" />
                <p>No team members yet.</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="current-week-tab tab-content team-chat-wrapper team-attendance-wrapper"
          v-if="selectedTab === 'league-tab'"
        >
          <!-- Externally mapped team (Dribl/COMET): live ladder + fixtures -->
          <TeamLeaguePanel
            v-if="showExternalLeaguePanel && selectedTeam"
            :team-id="selectedTeam.id"
            :club-id="userData.clubId"
          />
          <div v-else class="competition-tab">
            <!-- Header: competition name + refresh -->
            <div
              v-if="competitionName || leagueTableHtml"
              class="competition-header"
            >
              <h3 class="games-section-heading" style="padding-left: 0">
                {{ competitionName || "Competition" }}
              </h3>
              <button
                type="button"
                class="filter-reset competition-refresh"
                @click="refreshCompetitionTable"
                :disabled="competitionLoading"
                v-b-tooltip.hover
                title="Refresh competition table"
              >
                <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                {{ competitionLoading ? "Refreshing…" : "Refresh" }}
              </button>
            </div>

            <!-- Loading -->
            <div
              v-if="competitionLoading && !leagueTableHtml"
              class="competition-loading"
            >
              <div class="spinner"></div>
              <p>Loading competition table…</p>
            </div>

            <!-- Unsupported (no mapping for this team / age group) -->
            <div v-else-if="competitionUnsupported" class="empty-state">
              <p>
                Competition table isn't available for this team / age group yet.
              </p>
              <p class="text-muted" style="font-size: 0.85rem">
                Only certain CAS Performance and Elite leagues are wired up at
                the moment.
              </p>
            </div>

            <!-- Error -->
            <div v-else-if="competitionError" class="empty-state">
              <p>{{ competitionError }}</p>
              <button
                type="button"
                class="filter-reset"
                @click="refreshCompetitionTable"
              >
                <i class="bi bi-arrow-clockwise" aria-hidden="true"></i> Retry
              </button>
            </div>

            <!-- Loaded table -->
            <!-- The FA-supplied HTML is div-based and styled via the global
                 `#scottish-FA-table` rules in styles/index.scss (display:
                 table-row / table-cell). Keep that id on the wrapper or the
                 cells render as plain stacked blocks.
                 The outer .competition-table-scroll provides horizontal
                 overflow so narrow screens can swipe the wider table
                 without the layout breaking. -->
            <div v-else-if="leagueTableHtml" class="competition-table-scroll">
              <div
                id="scottish-FA-table"
                class="competition-table-wrapper"
                v-html="leagueTableHtml"
              ></div>
            </div>

            <!-- Initial blank — happens briefly before the first fetch resolves -->
            <div v-else class="competition-loading">
              <div class="spinner"></div>
              <p>Loading competition table…</p>
            </div>
          </div>
        </div>

        <div
          class="current-week-tab tab-content"
          style="padding: 1rem"
          v-if="selectedTab === 'team-gps-tab'"
        >
          <div class="search-filter">
            <div class="form__item">
              <label class="form__label" for="picker">
                Select games date range</label
              >
              <VueDatePicker
                ref="picker"
                :locale="'en-GB'"
                :locale-data="dateRangePickerLocaleData"
                :range="{ autoRange: false }"
                @update:model-value="dateRangeSelected"
                :model-value="dateRange"
                :enable-time-picker="false"
                format="dd/MM/yyyy"
              >
                <template v-slot:input="picker">
                  <i class="bi bi-calendar3"></i>
                  {{ formatMatchDate(picker.startDate) }} -
                  <i class="bi bi-calendar3"></i>
                  {{ formatMatchDate(picker.endDate) }}
                </template>
              </VueDatePicker>
              <a
                class="clear-daterange"
                v-b-tooltip.hover
                title="Reset date range"
                @click="dateRangeReset()"
                href="javascript:;"
                ><i class="bi bi-arrow-counterclockwise"></i
              ></a>
              <div class="checkbox-full-season-wrapper">
                <b-form-checkbox
                  id="checkbox-full-season"
                  v-model="fullSeasonCheckBoxData"
                  @change="fullSeasonCheckBox()"
                  name="checkbox-full-season"
                >
                  Full Season
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="dropDown">
            <p>Select session</p>

            <b-form-select
              v-model="selectedGPSSession"
              id="gpsSessionSelect"
              :state="selectedGPSSession ? true : false"
              @change="gpsSelectedData"
            >
              <b-form-select-option disabled :value="null"
                >Please select a session</b-form-select-option
              >
              <b-form-select-option
                v-for="session in allGPSDataBySession"
                :key="session.id"
                :value="session"
                >{{ session.matchDate }} |
                <span v-if="session.opposition !== ''">{{
                  session.opposition
                }}</span>
                <span v-else>{{ session.gameType }}</span>
              </b-form-select-option>
            </b-form-select>
            <b-form-invalid-feedback>
              Please select a GPS session to view data
            </b-form-invalid-feedback>
          </div>

          <div
            v-if="gPSSelectedSessionId !== null"
            class=""
            style="width: 100%; margin-top: 2rem"
          >
            <div class="match-report-header">
              <div class="logo-header-wrapper">
                <div class="user-photo-info">
                  <TenantLogo logo-class="login-logo" />
                </div>

                <div class="title-text">
                  <h2>
                    {{ this.selectedTeam.teamName }}
                    <span
                      v-if="
                        selectedGameFullPerformanceReportGPSdataForTeam.opposition !==
                        undefined
                      "
                      >v
                      {{
                        selectedGameFullPerformanceReportGPSdataForTeam.opposition
                      }}</span
                    >
                    <span v-else>{{
                      selectedGameFullPerformanceReportGPSdataForTeam.opposition
                    }}</span>
                    report
                  </h2>
                  <h3>
                    <span>{{
                      selectedGameFullPerformanceReportGPSdataForTeam.sessionName
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>

            <div v-if="under16 === false" class="">
              <div class="col-wrapper-teams-gps">
                <div class="cols">
                  <h3>Total Distance</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalDistanceFullSession"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>High Speed Running</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalAbsoluteHighSpeedDistanceFullSession"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>Accelerations</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalAccelerationsTotalEffortsFullSession"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>Decelerations</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalDecelerationsTotalEffortsFullSession"
                    />
                  </div>
                </div>
              </div>

              <div
                class="col-wrapper-teams-gps"
                style="margin-top: 1rem; padding-top: 1rem"
                v-if="
                  selectedGameFullPerformanceReportGPSdataForTeam.opposition !==
                  undefined
                "
              >
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i>
                    First Half
                  </h2>
                </div>

                <div class="cols">
                  <h3>Total Distance</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal :chartData="totalDistanceFirstHalf" />
                  </div>
                </div>

                <div class="cols">
                  <h3>High Speed Running</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalAbsoluteHighSpeedDistanceFirstHalf"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>Accelerations</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalAccelerationsTotalEffortsFirstHalf"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>Decelerations</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalDecelerationsTotalEffortsFirstHalf"
                    />
                  </div>
                </div>
              </div>

              <div
                class="col-wrapper-teams-gps"
                style="margin-top: 1rem; padding-top: 1rem"
                v-if="
                  selectedGameFullPerformanceReportGPSdataForTeam.opposition !==
                  undefined
                "
              >
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i>
                    Second Half
                  </h2>
                </div>

                <div class="cols">
                  <h3>Total Distance</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalDistanceSecondHalf"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>High Speed Running</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalAbsoluteHighSpeedDistanceSecondHalf"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>Accelerations</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalAccelerationsTotalEffortsSecondHalf"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>Decelerations</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalDecelerationsTotalEffortsSecondHalf"
                    />
                  </div>
                </div>
              </div>

              <div
                class="col-wrapper-teams-gps"
                style="margin-top: 1rem; padding-top: 1rem"
                v-if="
                  selectedGameFullPerformanceReportGPSdataForTeam.opposition !==
                  undefined
                "
              >
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i>
                    Top speed tracker
                  </h2>
                </div>

                <div class="cols">
                  <h3>Top Speed (m/s)</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalMaximumVelocityFullSession"
                    />
                  </div>
                </div>

                <div class="cols">
                  <h3>% of Top Speed Achieved</h3>
                  <div class="name-bar">
                    <Bar-chart-horizontal
                      :chartData="totalMaxVelMaxFullSession"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col-wrapper-teams-gps">
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i
                    >Touches
                  </h2>
                </div>
                <div class="cols">
                  <h3>Total Touches</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.total_touches,
                            'Total Touches',
                          )
                        "
                      />
                    </div>
                  </div>
                </div>

                <div class="cols">
                  <h3>Right Foot Touches</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.right_leg_touches,
                            'Right Foot Touches',
                          )
                        "
                      />
                    </div>
                  </div>
                </div>

                <div class="cols">
                  <h3>Left Foot Touches</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.left_leg_touches,
                            'Left Foot Touches',
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-wrapper-teams-gps pie-charts">
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i>Left
                    and Right Touches
                  </h2>
                </div>
                <div class="cols">
                  <div
                    class="pie-chart-wrapper"
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Pie-chart
                        :chartData="
                          populateSeasonStrainingAndGamesstatsChartPieDataPlayMakerSetsData(
                            gpsData,
                            'Left and Right Touches',
                          )
                        "
                        :height="50"
                        :width="50"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-wrapper-teams-gps">
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i
                    >Releases
                  </h2>
                </div>
                <div class="cols">
                  <h3>Total Releases</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.releases,
                            'Total Releases',
                          )
                        "
                        height="100px"
                      />
                    </div>
                  </div>
                </div>

                <div class="cols">
                  <h3>Right Foot Releases</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.releases_right,
                            'Right Foot Releases',
                          )
                        "
                        height="100px"
                      />
                    </div>
                  </div>
                </div>

                <div class="cols">
                  <h3>Left Foot Releases</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.releases_left,
                            'Left Foot Releases',
                          )
                        "
                        height="100px"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-wrapper-teams-gps">
                <div style="width: 100%" class="match-report-header">
                  <h2>
                    <i class="bi bi-clipboard-data" aria-hidden="true"></i
                    >Physical
                  </h2>
                </div>
                <div class="cols">
                  <h3>Total Distance (m)</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.distance_covered,
                            'Total Distance (m)',
                          )
                        "
                        height="100px"
                      />
                    </div>
                  </div>
                </div>

                <div class="cols">
                  <h3>Top Speed (m/s)</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.top_speed,
                            'Top Speed (m/s)',
                          )
                        "
                        height="100px"
                      />
                    </div>
                  </div>
                </div>

                <div class="cols">
                  <h3>Work Rate (m/min)</h3>
                  <div
                    v-for="gpsData in selectedGameFullPerformanceReportGPSdataForTeam.gpsData"
                    :key="gpsData.id"
                  >
                    <div
                      class="name-bar"
                      v-if="
                        gpsData.session_type === 'Session' ||
                        gpsData.session_type === 'Training'
                      "
                    >
                      <p>{{ getPlayersNameFromId(gpsData.player_id) }}</p>
                      <Bar-chart-horizontal
                        :chartData="
                          populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                            gpsData.work_rate,
                            'Work Rate (m/min)',
                          )
                        "
                        height="100px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="empty-state">
              <img src="../img/emptyStateIllustration.svg" />
              <p>No GPS data</p>
            </div>
          </div>
        </div>

        <!-- Squad Maturity Dashboard Tab -->
        <div
          class="current-week-tab tab-content"
          style="padding: 1rem"
          v-if="selectedTab === 'squad-maturity-tab'"
        >
          <SquadMaturityDashboard
            v-if="selectedTeam.id"
            :teamId="selectedTeam.id"
            :userData="userData"
          />
        </div>

        <div
          class="current-week-tab tab-content team-attendance-wrapper team-tab-content"
          v-if="selectedTab === 'team-reports-tab'"
        >
          <div class="team-content">
            <div class="team-types">
              <div class="full-team">
                <h3>Match Report Summary</h3>

                <table class="w-a-style">
                  <thead>
                    <tr>
                      <th>Player's Name</th>
                      <th>Position(s) Played</th>
                      <th>Playing Time (mins)</th>
                      <th>Performance Rating</th>
                      <th>Comments</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="player in currentTeam" :key="player.id">
                      <td>{{ player.name }}</td>
                    </tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="team-content">
            <div class="team-types">
              <div class="full-team" v-if="currentTeam.length > 0">
                <h3>Match Report Summary</h3>
                <table class="w-a-style">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Number</th>
                      <th>Name</th>
                      <th>Position</th>
                      <th>Age group</th>

                      <th v-for="game in pastGames" :key="game.id">
                        {{ game.opposition }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="player in currentTeam" :key="player.id">
                      <td>
                        <img
                          v-if="
                            player.userImage !== null && player.userImage !== ''
                          "
                          :src="getImgUrl(player.userImage)"
                          alt=""
                          class="player-photo"
                        />
                        <TenantLogo
                          v-else
                          logo-class="login-logo"
                          class="player-photo"
                        />
                      </td>
                      <td>{{ player.match_day_kit_number }}</td>
                      <td>
                        {{ player.name }}
                        <i v-if="player.has_medical_conditions == 1" class="bi bi-heart-pulse-fill medical-flag"
                          title="Medical information on file - see profile" aria-label="Medical information on file"></i>
                      </td>
                      <td>{{ player.position }}</td>
                      <td>{{ player.age_group }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="empty-state">
                <img src="../img/emptyStateIllustration.svg" />
                <p>No team members</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="attendance-tab"
          v-if="selectedTab === 'team-attendance-tab'"
        >
          <!-- Filters bar -->
          <div class="attendance-filters">
            <div class="attendance-date-picker">
              <VueDatePicker
                ref="picker"
                :locale="'en-GB'"
                :locale-data="dateRangePickerLocaleData"
                :range="{ autoRange: false }"
                @update:model-value="dateRangeSelected"
                :model-value="dateRange"
                :enable-time-picker="false"
                format="dd/MM/yyyy"
                placeholder="Select date range"
              >
                <template v-slot:input="picker">
                  <i class="bi bi-calendar3"></i>
                  {{ formatMatchDate(picker.startDate) }} -
                  {{ formatMatchDate(picker.endDate) }}
                </template>
              </VueDatePicker>
              <button
                class="attendance-reset-btn"
                @click="dateRangeReset()"
                title="Reset date range"
              >
                <i class="bi bi-arrow-counterclockwise"></i>
              </button>
            </div>
            <label class="attendance-season-toggle">
              <input
                type="checkbox"
                v-model="fullSeasonCheckBoxData"
                @change="fullSeasonCheckBox()"
              />
              <span>Full Season</span>
            </label>
          </div>

          <!-- Summary cards -->
          <div
            class="attendance-summary"
            v-if="currentTeam.length > 0 && selectedGamesEvents.length > 0"
          >
            <div class="attendance-summary-card">
              <span class="attendance-summary-value">{{
                selectedGamesEvents.filter((g) => g.gameType !== "Training")
                  .length
              }}</span>
              <span class="attendance-summary-label">Games</span>
            </div>
            <div class="attendance-summary-card">
              <span class="attendance-summary-value">{{
                selectedGamesEvents.filter((g) => g.gameType === "Training")
                  .length
              }}</span>
              <span class="attendance-summary-label">Training</span>
            </div>
            <div class="attendance-summary-card">
              <span class="attendance-summary-value">{{
                currentTeam.length
              }}</span>
              <span class="attendance-summary-label">Players</span>
            </div>
          </div>

          <!-- Attendance table -->
          <div
            class="attendance-table-wrap"
            v-if="currentTeam.length > 0 && selectedGamesEvents.length > 0"
          >
            <table class="attendance-table">
              <thead>
                <tr>
                  <th class="attendance-th-player">Player</th>
                  <th
                    class="attendance-th-avg"
                    @click="attendanceSortDesc = !attendanceSortDesc"
                  >
                    Avg
                    <i
                      :class="
                        attendanceSortDesc ? 'bi bi-sort-down' : 'bi bi-sort-up'
                      "
                      class="sort-icon"
                    ></i>
                  </th>
                  <th
                    class="attendance-th-event"
                    v-for="game in selectedGamesEvents"
                    :key="game.id"
                  >
                    <div class="attendance-header-cell">
                      <span
                        class="attendance-event-type"
                        :class="{
                          'event-match': game.gameType !== 'Training',
                          'event-training': game.gameType === 'Training',
                        }"
                        >{{
                          game.gameType === "Training"
                            ? "T"
                            : game.gameType === "Cup game"
                              ? "C"
                              : "L"
                        }}</span
                      >
                      <span
                        class="attendance-event-opp"
                        v-if="game.gameType !== 'Training'"
                        :title="game.opposition"
                        >{{ game.opposition }}</span
                      >
                      <span class="attendance-event-date">{{
                        getDayAndDate(game.matchDate)
                      }}</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="teamMember in sortedAttendanceTeam"
                  :key="teamMember.id"
                >
                  <td class="attendance-td-player">
                    <img
                      class="attendance-player-img"
                      v-if="teamMember.userImage"
                      :src="getImgUrl(teamMember.userImage)"
                      alt=""
                    />
                    <img
                      class="attendance-player-img"
                      v-else
                      :src="getImgUrl('default-image.png')"
                      alt=""
                    />
                    <span class="attendance-player-name">{{
                      teamMember.name
                    }}</span>
                  </td>
                  <td class="attendance-td-avg">
                    <span
                      class="attendance-avg-badge"
                      :class="{
                        'avg-high':
                          getPlayerAverageAttendance(teamMember.id) >= 75,
                        'avg-mid':
                          getPlayerAverageAttendance(teamMember.id) >= 50 &&
                          getPlayerAverageAttendance(teamMember.id) < 75,
                        'avg-low':
                          getPlayerAverageAttendance(teamMember.id) < 50,
                      }"
                      >{{ getPlayerAverageAttendance(teamMember.id) }}%</span
                    >
                  </td>
                  <td
                    class="attendance-td-status"
                    v-for="game in selectedGamesEvents"
                    :key="game.id"
                  >
                    <span
                      class="attendance-icon attended"
                      v-if="
                        checkGameTrainingAttendance(
                          teamMember.id,
                          game.id,
                          game.kickOffTime,
                        ) === 'Attended'
                      "
                      title="Attended"
                    >
                      <i class="bi bi-check-circle-fill"></i>
                    </span>
                    <span
                      class="attendance-icon not-attended"
                      v-else-if="
                        checkGameTrainingAttendance(
                          teamMember.id,
                          game.id,
                          game.kickOffTime,
                        ) === 'Not Attended'
                      "
                      title="Did Not Attend"
                    >
                      <i class="bi bi-x-circle-fill"></i>
                    </span>
                    <span
                      class="attendance-icon no-response"
                      v-else
                      title="No Response"
                    >
                      <i class="bi bi-dash-circle"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Empty state -->
          <div class="attendance-empty" v-else>
            <i class="bi bi-clipboard-data"></i>
            <p>No attendance data available for this date range.</p>
          </div>
        </div>

        <div
          class="current-week-tab tab-content team-tab-content"
          v-if="selectedTab === 'homework-tab'"
        >
          <div class="homework-container">
            <!-- Team Homework Section -->
            <div class="homework-section-card">
              <div class="homework-section-header">
                <div class="section-title">
                  <i class="bi bi-journal-bookmark"></i>
                  <h3>Team Homework</h3>
                  <span class="badge-count" v-if="allHomeWorkData.length > 0">{{
                    allHomeWorkData.length
                  }}</span>
                </div>
                <div
                  class="section-actions"
                  v-if="
                    (userData.userType === 'Admin' ||
                      userData.userType === 'Coach') &&
                    !$store.getters.isReadOnlySeason
                  "
                >
                  <button
                    class="add-homework-btn"
                    @click="addHomeWorkModalCall()"
                  >
                    <i class="bi bi-plus-lg"></i> Add Homework
                  </button>
                </div>
              </div>

              <div class="homework-section-content">
                <!-- Desktop Table View -->
                <div
                  v-if="allHomeWorkData.length > 0"
                  class="homework-table-wrapper"
                >
                  <table class="homework-table-modern desktop-only">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Title</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="homework in allHomeWorkData"
                        :key="homework.id"
                      >
                        <td>
                          <span class="date-cell">
                            <i class="bi bi-calendar3"></i>
                            {{ formatDateForHuman(homework.created_date) }}
                          </span>
                        </td>
                        <td>
                          <span class="title-cell">{{ homework.title }}</span>
                        </td>
                        <td>
                          <div class="action-buttons">
                            <button
                              class="action-btn view"
                              @click="viewHomework(homework)"
                              title="View"
                            >
                              <i class="bi bi-eye"></i>
                            </button>
                            <button
                              v-if="
                                (userData.userType === 'Admin' ||
                                  userData.userType === 'Coach') &&
                                !$store.getters.isReadOnlySeason
                              "
                              class="action-btn edit"
                              @click="editHomeworkMdalCall(homework)"
                              title="Edit"
                            >
                              <i class="bi bi-pencil"></i>
                            </button>
                            <button
                              v-if="
                                (userData.userType === 'Admin' ||
                                  userData.userType === 'Coach') &&
                                !$store.getters.isReadOnlySeason
                              "
                              class="action-btn delete"
                              @click="deleteHomework(homework.id)"
                              title="Delete"
                            >
                              <i class="bi bi-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Mobile Card View -->
                  <div class="homework-cards mobile-only">
                    <div
                      class="homework-card"
                      v-for="homework in allHomeWorkData"
                      :key="'mobile-' + homework.id"
                    >
                      <div class="homework-card-header">
                        <div class="homework-date">
                          <i class="bi bi-calendar3"></i>
                          {{ formatDateForHuman(homework.created_date) }}
                        </div>
                      </div>
                      <div class="homework-card-body">
                        <div class="homework-title">{{ homework.title }}</div>
                      </div>
                      <div class="homework-card-actions">
                        <button
                          class="action-btn view"
                          @click="viewHomework(homework)"
                        >
                          <i class="bi bi-eye"></i> View
                        </button>
                        <div
                          class="action-btns-right"
                          v-if="
                            (userData.userType === 'Admin' ||
                              userData.userType === 'Coach') &&
                            !$store.getters.isReadOnlySeason
                          "
                        >
                          <button
                            class="action-btn edit"
                            @click="editHomeworkMdalCall(homework)"
                          >
                            <i class="bi bi-pencil"></i>
                          </button>
                          <button
                            class="action-btn delete"
                            @click="deleteHomework(homework.id)"
                          >
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else class="empty-state-modern">
                  <div class="empty-icon">
                    <i class="bi bi-journal-x"></i>
                  </div>
                  <h4>No Team Homework</h4>
                  <p>
                    No homework assignments have been added for this team yet.
                  </p>
                  <p
                    class="empty-hint"
                    v-if="
                      userData.userType === 'Admin' ||
                      userData.userType === 'Coach'
                    "
                  >
                    Click "Add Homework" to create the first assignment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="current-week-tab tab-content documents-tab"
          v-if="selectedTab === 'team-documents-tab'"
        >
          <div class="games-info documents-wrapper">
            <DocumentView :uploadedDocuments="uploadedDocuments" />
          </div>
        </div>

        <div
          class="current-week-tab tab-content team-chat-wrapper"
          v-if="selectedTab === 'team-performance-tab'"
        >
          <ul class="tabs headding-space">
            <li class="tab-item">
              <a
                :class="
                  selectedTabGamesTraining ===
                  'teams-over-games-performance-tab'
                    ? 'tab-link active'
                    : 'tab-link'
                "
                @click="
                  tabChange(
                    'selectedTabGamesTraining',
                    'teams-over-games-performance-tab',
                  )
                "
                href="javascript:;"
                >Games</a
              >
            </li>
            <li class="tab-item">
              <a
                :class="
                  selectedTabGamesTraining === 'teams-over-games-training-tab'
                    ? 'tab-link active'
                    : 'tab-link'
                "
                @click="
                  tabChange(
                    'selectedTabGamesTraining',
                    'teams-over-games-training-tab',
                  )
                "
                href="javascript:;"
                >Training</a
              >
            </li>
          </ul>

          <div class="tabs-wrapper">
            <div
              class="current-week-tab tab-content"
              v-if="
                selectedTabGamesTraining === 'teams-over-games-performance-tab'
              "
            >
              <div class="lead-tabs-filters">
                <div class="lead-filters">
                  <div class="filter-group games-date-range-group">
                    <label class="filter-label">Date range</label>
                    <VueDatePicker
                      ref="picker"
                      :locale="'en-GB'"
                      :locale-data="dateRangePickerLocaleData"
                      :range="{ autoRange: false }"
                      @update:model-value="performanceDateRangeSelected"
                      :model-value="dateRange"
                      :enable-time-picker="false"
                      format="dd/MM/yyyy"
                    >
                      <template v-slot:input="picker">
                        <i class="bi bi-calendar3"></i>
                        {{ formatMatchDate(picker.startDate) }} -
                        <i class="bi bi-calendar3"></i>
                        {{ formatMatchDate(picker.endDate) }}
                      </template>
                    </VueDatePicker>
                  </div>
                  <div class="filter-group">
                    <label class="filter-label">Window</label>
                    <b-form-checkbox
                      id="checkbox-full-season-performance"
                      v-model="fullSeasonCheckBoxData"
                      @change="fullSeasonCheckBox()"
                      name="checkbox-full-season-performance"
                      class="filter-checkbox-inline"
                    >
                      Full Season
                    </b-form-checkbox>
                  </div>
                  <button
                    type="button"
                    class="filter-reset"
                    @click="dateRangeReset()"
                    v-b-tooltip.hover
                    title="Reset date range"
                  >
                    <i
                      class="bi bi-arrow-counterclockwise"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                </div>
              </div>

              <div v-if="loadingPerformanceData" class="text-center py-3">
                <b-spinner small variant="primary"></b-spinner>
                <span class="ml-2">Loading performance data...</span>
              </div>

              <p
                v-if="pastGames.length > 0 && !loadingPerformanceData"
                style="width: 100%"
              >
                Kindly be aware that only games with recorded scores will
                contribute to the majority of the totals. The "Games Played"
                category is an exception, as it will include games even without
                recorded scores.
              </p>

              <div class="win-loss-draw">
                <span v-for="(pastGame, i) in pastGames" :key="i">
                  <span
                    v-if="pastGame.result_added == '1'"
                    :class="`result-${checkGameResult(pastGame)}`"
                    >{{ checkGameResult(pastGame) }}</span
                  >
                </span>
              </div>

              <div class="past-games-performance" v-if="pastGames.length > 0">
                <div class="main-stats">
                  <div class="games-played">
                    <h3>
                      Games played
                      <span class="games-count-badge">{{
                        teamStats.gamesPlayed
                      }}</span>
                    </h3>
                  </div>

                  <div class="games-wins">
                    <h3>Wins</h3>
                    <span>{{ teamStats.wins }}</span>
                  </div>

                  <div class="games-losses">
                    <h3>Losses</h3>
                    <span>{{ teamStats.losses }}</span>
                  </div>

                  <div class="games-draws">
                    <h3>Draws</h3>
                    <span>{{ teamStats.draws }}</span>
                  </div>

                  <div class="games-goals">
                    <h3>Goals</h3>
                    <span>{{ teamStats.goalsScored }}</span>
                  </div>

                  <div class="games-goals">
                    <h3>Goals Conceded</h3>
                    <span>{{ teamStats.goalsConceded }}</span>
                  </div>

                  <div class="games-goals">
                    <h3>Clean Sheets</h3>
                    <span>{{ teamStats.cleanSheets }}</span>
                  </div>

                  <div class="games-goals">
                    <h3>Goal Difference</h3>
                    <span
                      :style="{
                        color:
                          teamStats.goalsScored - teamStats.goalsConceded > 0
                            ? '#28a745'
                            : teamStats.goalsScored - teamStats.goalsConceded <
                                0
                              ? '#dc3545'
                              : '',
                      }"
                    >
                      {{
                        teamStats.goalsScored - teamStats.goalsConceded > 0
                          ? "+"
                          : ""
                      }}{{ teamStats.goalsScored - teamStats.goalsConceded }}
                    </span>
                  </div>

                  <div class="games-goals">
                    <h3>Points</h3>
                    <span>{{ teamStats.wins * 3 + teamStats.draws }}</span>
                  </div>

                  <div class="games-goals">
                    <h3>Win Rate</h3>
                    <span
                      >{{
                        teamStats.wins + teamStats.draws + teamStats.losses > 0
                          ? Math.round(
                              (teamStats.wins /
                                (teamStats.wins +
                                  teamStats.draws +
                                  teamStats.losses)) *
                                100,
                            )
                          : 0
                      }}%</span
                    >
                  </div>
                </div>
              </div>

              <div
                class="games-performance-analysis-stats"
                v-if="gamePerformanceAnalysisData.length > 0"
              >
                <div class="stats-overview">
                  <h3>Attacking</h3>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.penetrationScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.penetrationScoreTotal,
                          )
                        }}</span
                      >
                      Penetration
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.penetrationScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.penetrationScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.supportScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.supportScoreTotal,
                          )
                        }}</span
                      >
                      Support
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.supportScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.supportScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.mobilityScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.mobilityScoreTotal,
                          )
                        }}</span
                      >
                      Mobility
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.mobilityScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.mobilityScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.creativityScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.creativityScoreTotal,
                          )
                        }}</span
                      >
                      Creativity
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.creativityScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.creativityScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.transitionToAttackScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.transitionToAttackScoreTotal,
                          )
                        }}</span
                      >
                      Transition to Attack
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.transitionToAttackScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.transitionToAttackScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>
                </div>

                <div class="stats-overview">
                  <h3>Defending</h3>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.pressureScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.pressureScoreTotal,
                          )
                        }}</span
                      >
                      Pressure
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.pressureScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.pressureScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.coverScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.coverScoreTotal,
                          )
                        }}</span
                      >
                      Cover
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.coverScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.coverScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.balanceScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.balanceScoreTotal,
                          )
                        }}</span
                      >
                      Balance
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.balanceScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.balanceScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.compactnessScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.compactnessScoreTotal,
                          )
                        }}</span
                      >
                      Compactness
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.compactnessScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.compactnessScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>

                  <div class="performance-bar">
                    <p>
                      <span
                        :class="
                          setBarVariant(
                            averageGamePerformanceAnalysisData.transitionToDefendScoreTotal,
                          )
                        "
                        >{{
                          Math.round(
                            averageGamePerformanceAnalysisData.transitionToDefendScoreTotal,
                          )
                        }}</span
                      >
                      Transition to Defend
                    </p>

                    <b-progress
                      :value="
                        averageGamePerformanceAnalysisData.transitionToDefendScoreTotal
                      "
                      :variant="
                        setBarVariant(
                          averageGamePerformanceAnalysisData.transitionToDefendScoreTotal,
                        )
                      "
                      max="5"
                      class="mb-3"
                    ></b-progress>
                  </div>
                </div>
              </div>

              <div
                class="past-games-performance-analysis"
                v-if="gamePerformanceAnalysisData.length > 0"
              >
                <h4>Game analysis Games</h4>

                <table class="w-a-style">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Opposition</th>
                      <th>Coach</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(
                        gamePerformanceAnalysis, index
                      ) in gamePerformanceAnalysisData"
                      :key="gamePerformanceAnalysis.id + index"
                    >
                      <td>
                        {{ dayMonthYear(gamePerformanceAnalysis.matchDate) }}
                      </td>
                      <td>{{ gamePerformanceAnalysis.opposition }}</td>
                      <td>{{ gamePerformanceAnalysis.coachName }}</td>
                      <td>
                        <a
                          href="javascript:;"
                          @click="
                            gameAnalysisModal(
                              gamePerformanceAnalysis,
                              'gameAnalysisModal',
                            )
                          "
                          >Game analysis</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else-if="performanceFiltersActive" class="empty-state">
                <p>No game analyses match the current date range.</p>
                <button
                  type="button"
                  class="filter-reset"
                  @click="resetPerformanceFilters"
                >
                  <i class="bi bi-x-circle" aria-hidden="true"></i> Clear
                  filters
                </button>
              </div>
              <div v-else class="empty-state">
                <p>
                  No game analyses yet. Add an analysis from the Games tab to
                  see the team performance breakdown here.
                </p>
              </div>
            </div>

            <div
              class="current-week-tab tab-content"
              v-if="
                selectedTabGamesTraining === 'teams-over-games-training-tab'
              "
            >
              <div
                v-if="loadingTrainingPerformance"
                class="competition-loading"
              >
                <div class="spinner"></div>
                <p>Loading training stats…</p>
              </div>
              <div
                v-else-if="pastTraining.length > 0"
                class="past-games-performance"
              >
                <div class="main-stats">
                  <div class="games-played">
                    <h3>
                      Training sessions
                      <span class="games-count-badge">{{
                        pastTraining.length
                      }}</span>
                    </h3>
                  </div>

                  <div class="games-wins">
                    <h3>Average attendance per session</h3>
                    <span>{{ teamTrainingStats.averageAttendance }}</span>
                  </div>
                </div>
              </div>
              <div v-else-if="performanceFiltersActive" class="empty-state">
                <p>No training sessions match the current date range.</p>
                <button
                  type="button"
                  class="filter-reset"
                  @click="resetPerformanceFilters"
                >
                  <i class="bi bi-x-circle" aria-hidden="true"></i> Clear
                  filters
                </button>
              </div>
              <div v-else class="empty-state">
                <p>No training sessions logged for this team yet.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-if="showAddEditGames"
      v-model="showAddEditGames"
      size="lg"
      title="Add new Game"
      :hide-footer="true"
    >
      <form class="form" @submit.prevent="addEditProgrammeSubmit()">
        <div class="form__item">
          <label class="form__label" for="selectSection"
            >Select type of game</label
          >
          <b-form-select
            id="compressureType"
            text="select type"
            v-model="selectedGameTypeOption"
            :state="selectedGameTypeOption ? true : false"
            required
            @change="populateFirstTeamSelectedData($event)"
          >
            <b-form-select-option disabled value=""
              >Please select a game type</b-form-select-option
            >
            <b-form-select-option
              v-for="(i, index) in selectTypeOfGameoptions"
              :key="index"
              :value="i.value"
            >
              {{ i.text }}
            </b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback>
            Please select a game type
          </b-form-invalid-feedback>
        </div>
        <div class="form__item">
          <label class="form__label" for="homeTeamSection">Selected team</label>
          <span>{{ newGameData.teamName }}</span>
          <!--<a v-if="showTeamChange === false" href="javascript:;" @click="showTeamChange = true">Change team</a>-->
        </div>
        <div class="form__item" v-if="showTeamChange === true">
          <label class="form__label" for="homeTeamSection">Change team</label>

          <select
            v-model="selectedTeamName"
            @change="setSelectedTeam(selectedTeamName)"
            id="userSelect"
          >
            <option disabled value="">Please select a team</option>
            <option
              v-for="(clubTeam, index) in clubTeams"
              :value="clubTeam.teamName"
              :key="clubTeam.id + index"
            >
              {{ clubTeam.teamName }}
            </option>
          </select>
        </div>

        <div v-if="newGameData.gameType !== 'Training'" class="form__item">
          <label
            v-if="
              leagueTeams.length > 0 && newGameData.gameType === 'League game'
            "
            class="form__label"
            for="competitionSection"
            >Select opposition team</label
          >

          <label v-else class="form__label" for="competitionSection"
            >Add opposition team</label
          >

          <select
            v-if="
              leagueTeams.length > 0 && newGameData.gameType === 'League game'
            "
            @change="populateSelectedTeamVenue($event, 'newGameData')"
            id="competitionSection"
          >
            <option disabled value="">Please select an opposition team</option>
            <option
              v-for="team in leagueTeams"
              v-bind:key="team.id"
              :value="team.id"
            >
              {{ team.teamName }}
            </option>
          </select>
          <input
            v-else
            id="competitionSection"
            type="text"
            v-model="newGameData.opposition"
            name="competitionSection"
          />
        </div>
        <div class="form__item">
          <label class="form__label" for="matchDate">
            <span>{{ newGameData.gameType }}</span>
            Date</label
          >
          <VueDatePicker
            wrapper-class="fullscreen-when-on-mobile"
            :disabled-dates="disablePastDates"
            v-model="newGameData.matchDate"
            name="matchDate"
            id="matchDate"
            :enable-time-picker="false"
            format="dd/MM/yyyy"
            :locale="'en-GB'"
            @update:model-value="newGameData.matchDate = $event"
          />
        </div>
        <div class="form__item">
          <label class="form__label" for="kickOff">
            <span v-if="newGameData.gameType === 'Training'">Start</span>
            <span v-else>Kick off</span>
            time</label
          >
          <input
            id="kickOff"
            type="time"
            min="06:00"
            max="23:00"
            v-model="newGameData.kickOffTime"
            name="kickOff"
          />
        </div>
        <div class="form__item" v-if="newGameData.gameType === 'Training'">
          <label class="form__label" for="endTime">End time</label>
          <input
            id="endTime"
            type="time"
            min="06:00"
            max="23:00"
            v-model="newGameData.endTime"
            name="endTime"
          />
        </div>

        <div class="form__item" v-if="newGameData.gameType === 'Training'">
          <label class="form__label">Training content</label>
          <div
            v-if="
              sessionContent.programmes.length > 0 ||
              sessionContent.drills.length > 0
            "
            class="session-content-chips"
          >
            <span
              v-for="programme in sessionContent.programmes"
              :key="'prog-' + programme.id"
              class="session-content-chip chip-programme"
            >
              <i class="bi bi-collection"></i> {{ programme.title }}
              <button
                type="button"
                @click="removeSessionProgramme(programme.id)"
              >
                &times;
              </button>
            </span>
            <span
              v-for="drill in sessionContent.drills"
              :key="'drill-' + drill.id"
              class="session-content-chip chip-drill"
            >
              <i class="bi bi-clipboard-check"></i> {{ drill.name }}
              <button type="button" @click="removeSessionDrill(drill.id)">
                &times;
              </button>
            </span>
          </div>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm add-content-btn"
            @click="showTrainingContentPicker = true"
          >
            <i class="bi bi-plus-lg"></i> Add from library
          </button>
        </div>

        <PitchSelect
          :pitches="pitches"
          @pitchChange="pitchChange"
          @default-pitch-inputs="defaultPitchInputs"
          :gameData="newGameData"
        />

        <template v-if="togglePitchDetails === false">
          <div class="form__item">
            <label class="form__label" for="location">Location name</label>
            <input
              id="location"
              type="text"
              v-model="newGameData.locationName"
              name="location"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="address">Location address</label>
            <input
              id="address"
              type="text"
              v-model="newGameData.address"
              name="address"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="postCode">Location postCode</label>
            <input
              id="postCode"
              type="text"
              v-model="newGameData.postCode"
              name="postCode"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="selectpitchType"
              >Select Pitch type</label
            >
            <select v-model="newGameData.pitchType" id="selectpitchType">
              <option disabled value="">Please select a pitch type</option>
              <option value="4G">4G</option>
              <option value="3G">3G</option>
              <option value="Grass">Grass</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </template>

        <template v-else>
          <div class="form__item">
            <label class="form__label" for="location">Location name</label>
            <input
              id="location"
              type="text"
              v-model="newGameData.locationName"
              name="location"
              disabled="true"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="address">Location address</label>
            <input
              id="address"
              type="text"
              v-model="newGameData.address"
              name="address"
              disabled="true"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="postCode">Location postCode</label>
            <input
              id="postCode"
              type="text"
              v-model="newGameData.postCode"
              name="postCode"
              disabled="true"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="selectpitchType"
              >Select Pitch type</label
            >
            <input
              id="selectpitchType"
              type="text"
              v-model="newGameData.pitchType"
              name="selectpitchType"
              disabled="true"
            />
          </div>
        </template>

        <div class="form__item" v-if="newGameData.gameType !== 'Training'">
          <label class="form__label" for="stripType">Strip type</label>
          <input
            id="stripType"
            type="text"
            v-model="newGameData.stripType"
            name="stripType"
          />
        </div>
        <div class="form__item" v-if="newGameData.gameType !== 'Training'">
          <label class="form__label" for="meetTime">Meet time</label>
          <input
            id="meetTime"
            type="time"
            min="06:00"
            max="23:00"
            v-model="newGameData.meetTime"
            name="meetTime"
          />
        </div>
        <div v-if="newGameData.gameType !== 'Training'" class="form__item">
          <label class="form__label" for="notes">Home game</label>
          <b-form-checkbox
            id="home-game-event-checkBox"
            v-model="newGameData.home_team"
            name="home-game-event-checkBox"
          >
          </b-form-checkbox>
        </div>
        <div class="form__item">
          <label class="form__label" for="notes">Notes</label>
          <textarea
            id="notes"
            type="text"
            v-model="newGameData.notes"
            name="notes"
          ></textarea>
        </div>

        <div
          v-if="newGameData.gameType === 'Training'"
          class="form__item recurring-event-checkBox-class"
        >
          <b-form-checkbox
            id="recurring-event-checkBox"
            v-model="recurringEvent"
            name="recurring-event-checkBox"
            @change="toggleRecurringEvent()"
          >
            <span class="check-box-text">Make event recurring</span>
          </b-form-checkbox>
        </div>

        <div class="form__item" v-if="recurringEvent === true">
          <label class="form__label" for="recurringEventSelect"
            >Select recurring type</label
          >
          <select
            v-model="newGameData.recurringEventType"
            id="recurringEventSelect"
          >
            <option disabled value="">
              Please select a recurring event type
            </option>
            <option value="7">Weekly</option>
            <option value="14">By weekly</option>
          </select>
        </div>

        <div class="form__item">
          <button type="submit" class="green-button">Add game</button>
        </div>
      </form>
    </b-modal>

    <b-modal
      v-if="showEditGames"
      v-model="showEditGames"
      size="lg"
      title="Edit Game"
      :hide-footer="true"
    >
      <form class="form" @submit.prevent="editProgrammeSubmit('editGames')">
        <!--<div class="form__item">
            <label class="form__label" for="selectSection"
              >Select type of game</label>
            <b-form-select id="compressureType" text="select type" v-model="editGame.gameType">
               <option value="null" disabled>'Please select a game type</option>
               <option v-for="(i, index) in selectTypeOfGameoptions" :key="index" :value="i.value">{{ i.text }}</option>
            </b-form-select>
          </div>
          <div class="form__item">
            <label class="form__label" for="homeTeamSection">Selected team</label>
            <span>{{ editGame.teamName }}</span>
            <a v-if="showTeamChange === false" href="javascript:;" @click="showTeamChange = true">Change team</a>

          </div>-->
        <!--<div class="form__item" v-if="showTeamChange === true">
            <label class="form__label" for="homeTeamSection">Change team</label>

            <select v-model="selectedTeamName" @change="setSelectedTeam(selectedTeamName)" id="userSelect">
              <option disabled value="">Please select a team</option>
              <option v-for="clubTeam in clubTeams" :value="clubTeam.teamName" :key="clubTeam.id">{{ clubTeam.teamName }}</option>
            </select>

          </div>-->
        <div v-if="editGame.gameType !== 'Training'" class="form__item">
          <label
            v-if="leagueTeams.length > 0"
            class="form__label"
            for="competitionSection"
            >Select opposition team</label
          >

          <label v-else class="form__label" for="competitionSection"
            >Add opposition team</label
          >

          <select
            v-if="leagueTeams.length > 0 && editGame.gameType !== 'Cup game'"
            id="competitionSection"
            @change="populateSelectedTeamVenue($event, 'editGame')"
          >
            <option disabled value="">Please select an opposition team</option>
            <option
              v-for="team in leagueTeams"
              v-bind:key="team.id"
              :value="team.id"
            >
              {{ team.teamName }}
            </option>
          </select>
          <input
            v-else
            id="competitionSection"
            type="text"
            v-model="editGame.opposition"
            name="competitionSection"
          />
        </div>
        <div class="form__item">
          <label class="form__label" for="matchDate">
            <span>{{ selectedGame.gameType }}</span>
            Date</label
          >
          <VueDatePicker
            wrapper-class="fullscreen-when-on-mobile"
            :disabled-dates="disablePastDates"
            v-model="editGame.matchDate"
            name="matchDate"
            id="matchDate"
            :enable-time-picker="false"
            format="dd/MM/yyyy"
            :locale="'en-GB'"
            @update:model-value="editGame.matchDate = $event"
          />
        </div>

        <div class="form__item">
          <label class="form__label" for="kickOff">
            <span v-if="editGame.gameType === 'Training'">Start</span>
            <span v-else>Kick off</span>
            time</label
          >
          <input
            id="kickOff"
            type="time"
            min="06:00"
            max="23:00"
            v-model="editGame.kickOffTime"
            name="kickOff"
          />
        </div>
        <div class="form__item" v-if="editGame.gameType === 'Training'">
          <label class="form__label" for="endTime">End time</label>
          <input
            id="endTime"
            type="time"
            min="06:00"
            max="23:00"
            v-model="editGame.endTime"
            name="endTime"
          />
        </div>

        <div class="form__item" v-if="editGame.gameType === 'Training'">
          <label class="form__label">Training content</label>
          <div
            v-if="
              sessionContent.programmes.length > 0 ||
              sessionContent.drills.length > 0
            "
            class="session-content-chips"
          >
            <span
              v-for="programme in sessionContent.programmes"
              :key="'prog-' + programme.id"
              class="session-content-chip chip-programme"
            >
              <i class="bi bi-collection"></i> {{ programme.title }}
              <button
                type="button"
                @click="removeSessionProgramme(programme.id)"
              >
                &times;
              </button>
            </span>
            <span
              v-for="drill in sessionContent.drills"
              :key="'drill-' + drill.id"
              class="session-content-chip chip-drill"
            >
              <i class="bi bi-clipboard-check"></i> {{ drill.name }}
              <button type="button" @click="removeSessionDrill(drill.id)">
                &times;
              </button>
            </span>
          </div>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm add-content-btn"
            @click="showTrainingContentPicker = true"
          >
            <i class="bi bi-plus-lg"></i> Add from library
          </button>
        </div>

        <PitchSelect
          :pitches="pitches"
          @pitchChange="pitchChange"
          @default-pitch-inputs="defaultPitchInputs"
          :gameData="editGame"
        />

        <div class="form__item">
          <label class="form__label" for="location">Pitch booking type</label>
          {{ setPitchZoneText(editGame) }}
        </div>

        <template v-if="togglePitchDetails === false">
          <div class="form__item">
            <label class="form__label" for="location">Location name</label>
            <input
              id="location"
              type="text"
              v-model="editGame.locationName"
              name="location"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="address">Location address</label>
            <input
              id="address"
              type="text"
              v-model="editGame.address"
              name="address"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="postCode">Location postCode</label>
            <input
              id="postCode"
              type="text"
              maxlength="10"
              v-model="editGame.postCode"
              name="postCode"
            />
          </div>

          <div class="form__item">
            <label class="form__label" for="selectpitchType"
              >Select Pitch type</label
            >
            <select v-model="editGame.pitchType" id="selectpitchType">
              <option disabled value="">Please select a pitch type</option>
              <option value="4G">4G</option>
              <option value="3G">3G</option>
              <option value="Grass">Grass</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </template>

        <template v-else>
          <div class="form__item">
            <label class="form__label" for="location">Location name</label>
            <input
              id="location"
              type="text"
              v-model="editGame.locationName"
              name="location"
              disabled="true"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="address">Location address</label>
            <input
              id="address"
              type="text"
              v-model="editGame.address"
              name="address"
              disabled="true"
            />
          </div>
          <div class="form__item">
            <label class="form__label" for="postCode">Location postCode</label>
            <input
              id="postCode"
              type="text"
              maxlength="10"
              v-model="editGame.postCode"
              name="postCode"
              disabled="true"
            />
          </div>

          <div class="form__item">
            <label class="form__label" for="selectpitchType"
              >Select Pitch type</label
            >
            <input
              id="selectpitchType"
              type="text"
              v-model="editGame.pitchType"
              name="selectpitchType"
              disabled="true"
            />
          </div>
        </template>
        <div class="form__item" v-if="editGame.gameType !== 'Training'">
          <label class="form__label" for="stripType">Strip type</label>
          <input
            id="stripType"
            type="text"
            v-model="editGame.stripType"
            name="stripType"
          />
        </div>
        <div class="form__item" v-if="editGame.gameType !== 'Training'">
          <label class="form__label" for="meetTime">Meet time</label>
          <input
            id="meetTime"
            type="time"
            min="06:00"
            max="23:00"
            v-model="editGame.meetTime"
            name="meetTime"
          />
        </div>
        <div v-if="editGame.gameType !== 'Training'" class="form__item">
          <label class="form__label" for="notes">Home game</label>
          <b-form-checkbox
            id="home-game-event-checkBox"
            v-model="editGame.home_team"
            name="home-game-event-checkBox"
          >
          </b-form-checkbox>
        </div>
        <div class="form__item">
          <label class="form__label" for="notes">Notes</label>
          <textarea
            id="notes"
            type="text"
            v-model="editGame.notes"
            name="notes"
          ></textarea>
        </div>

        <!--<div v-if="newGameData.gameType === 'Training'" class="form__item recurring-event-checkBox-class">
          <b-form-checkbox
            id="recurring-event-checkBox"
            v-model="recurringEvent"
            name="recurring-event-checkBox"
            @change="toggleRecurringEvent()"
          >
            <span class="check-box-text">Make event recurring</span>
          </b-form-checkbox>
        </div>

        <div class="form__item" v-if="editGame.recurringEventType !== null">
          <label class="form__label" for="recurringEventSelect"
            >Select recurring type</label
          >
          <select
            v-model="editGame.recurringEventType"
            id="recurringEventSelect"
          >
            <option disabled value="">
              Please select a recurring event type
            </option>
            <option value="7">Weekly</option>
            <option value="14">By weekly</option>
          </select>
        </div>-->

        <div v-if="editGame.result_added == '1'" class="game-results-wrapper">
          <div class="form__item">
            <label class="form__label" for="notes">Home team goals</label>
            <textarea
              id="home_team_goals"
              type="number"
              v-model="editGame.home_team_goals"
              name="home_team_goals"
            ></textarea>
          </div>

          <div class="form__item">
            <label class="form__label" for="notes"
              >Home team goal scorers</label
            >
            <textarea
              id="home_team_goal_scorers"
              type="text"
              v-model="editGame.home_team_goal_scorers"
              name="home_team_goal_scorers"
            ></textarea>
          </div>

          <div class="form__item">
            <label class="form__label" for="notes">Away team goals</label>
            <textarea
              id="away_team_goals"
              type="number"
              v-model="editGame.away_team_goals"
              name="away_team_goals"
            ></textarea>
          </div>

          <div class="form__item">
            <label class="form__label" for="notes"
              >Away team goal scorers</label
            >
            <textarea
              id="away_team_goal_scorers"
              type="text"
              v-model="editGame.away_team_goal_scorers"
              name="away_team_goal_scorers"
            ></textarea>
          </div>
        </div>

        <div class="form__item">
          <b-button type="submit" variant="success">Save changes</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal
      v-if="showViewGameDetails"
      v-model="showViewGameDetails"
      size="xl"
      :hide-footer="true"
      @close="showViewGameDetails = false"
    >
      <h2 class="small-title">
        {{ selectedGame.gameType }}
        <span v-if="selectedGame.gameType !== 'Training'"
          >V {{ selectedGame.opposition }}</span
        >
        <span v-if="selectedGame.gameType === 'Training'" class="small-text">{{
          setPitchZoneText(selectedGame)
        }}</span>
      </h2>
      <div class="match-details">
        <div class="details">
          <i
            v-if="selectedGame.gameType !== 'Training'"
            class="bi bi-calendar2-day"
            aria-hidden="true"
          ></i>
          <i
            v-if="selectedGame.gameType === 'Training'"
            class="bi bi-alarm"
            aria-hidden="true"
          ></i>

          <div class="date-times-wrapper">
            <span class="match-date header-text-bold">{{
              getDayAndDate(selectedGame.matchDate)
            }}</span>
            <div class="times-wrapper">
              <span v-if="selectedGame.gameType !== 'Training'"> at </span>
              <span>{{
                formatISOStringDateAndTime(selectedGame.kickOffTime)
              }}</span>
              <span v-if="selectedGame.gameType === 'Training'"
                >- {{ formatISOStringDateAndTime(selectedGame.endTime) }}</span
              >
            </div>
          </div>
        </div>

        <div class="details" v-if="selectedGame.gameType !== 'Training'">
          <i class="bi bi-alarm" aria-hidden="true"></i>
          <div class="date-times-wrapper">
            <span
              >Report for:
              {{ formatISOStringDateAndTime(selectedGame.meetTime) }}</span
            >
          </div>
        </div>

        <div class="details">
          <i class="bi bi-pin-map" aria-hidden="true"></i>
          <div class="date-times-wrapper">
            <span class="venue-text header-text-bold"
              >{{ selectedGame.locationName }}
              {{ selectedGame.pitchType }}</span
            >
            <div class="times-wrapper">
              <span
                >{{ selectedGame.address }} {{ selectedGame.postCode }}</span
              >
              <a
                class="map-link"
                v-if="selectedGame.postCode !== ''"
                :href="`https://maps.google.fr/maps?q=${selectedGame.postCode}`"
                target="_blank"
              >
                <div class="map-icon-text">
                  <iframe
                    width="100%"
                    height="200px"
                    frameborder="0"
                    style="border: 0"
                    :src="googleMapsEmbedUrl"
                    allowfullscreen
                  >
                  </iframe>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="details" v-if="selectedGame.gameType !== 'Training'">
          <i class="bi bi-person" aria-hidden="true"></i>
          <div class="date-times-wrapper">
            <span>Strip: {{ selectedGame.stripType }}</span>
          </div>
        </div>

        <div v-if="selectedGame.notes != ''" class="notes-section">
          <i class="bi bi-chat-right-text" aria-hidden="true"></i>
          <span>{{ selectedGame.notes }}</span>
        </div>
      </div>

      <div
        v-if="selectedGame.gameType === 'Training'"
        class="session-content-section"
      >
        <h3 class="session-content-heading">
          <i class="bi bi-clipboard-check"></i> Session content
        </h3>

        <div v-if="loadingViewGameContent" class="session-content-empty">
          Loading session content...
        </div>

        <SessionContentList
          v-else-if="viewGameSessionContent.length > 0"
          :items="viewGameSessionContent"
        />

        <p v-else class="session-content-empty">
          No training content attached to this session.
        </p>
      </div>

      <div
        v-if="checkUserIsAttendingGame() === false"
        class="player-game-responce"
      >
        <b-button
          v-if="userData.userType !== 'Admin' && userData.userType !== 'Coach'"
          @click="gameResponce('Yes')"
          variant="outline-success"
          ><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i> Yes
          going</b-button
        >
        <b-button
          v-if="userData.userType !== 'Admin' && userData.userType !== 'Coach'"
          @click="gameResponce('No')"
          variant="outline-danger"
          ><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i> No can't
          make it</b-button
        >
      </div>
      <div v-else class="player-game-responce">
        <b-button disabled variant="success"
          ><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i>
          Attending</b-button
        >
        <b-button
          v-if="userData.userType !== 'Admin' && userData.userType !== 'Coach'"
          @click="gameResponce('No')"
          variant="outline-danger"
          ><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i> No can't
          make it</b-button
        >
        <div class="attending-game">
          <i class="bi bi-hand-thumbs-up" aria-hidden="true"></i> You are
          currently attending this
          <span v-if="selectedGame.gameType === 'Training'">Session</span>
          <span v-else>Game</span>
        </div>
      </div>

      <div class="avail-section">
        <div class="avail-tabs">
          <button
            class="avail-tab"
            :class="{ active: playerAvailabilityTab === 'going-tab' }"
            @click="tabChange('playerAvailabilityTab', 'going-tab')"
          >
            <i class="bi bi-check-circle-fill"></i>
            Going
            <span class="avail-tab-count">{{ goingList.length }}</span>
          </button>
          <button
            class="avail-tab"
            :class="{ active: playerAvailabilityTab === 'not-going-tab' }"
            @click="tabChange('playerAvailabilityTab', 'not-going-tab')"
          >
            <i class="bi bi-x-circle-fill"></i>
            Not Going
            <span class="avail-tab-count">{{ notGoingList.length }}</span>
          </button>
          <button
            class="avail-tab"
            :class="{ active: playerAvailabilityTab === 'no-response-tab' }"
            @click="tabChange('playerAvailabilityTab', 'no-response-tab')"
          >
            <i class="bi bi-dash-circle"></i>
            No Response
            <span
              class="avail-tab-count"
              :class="{ 'count-warn': noResponsePlayersList.length > 0 }"
              >{{ noResponsePlayersList.length }}</span
            >
          </button>
          <button
            class="avail-tab"
            :class="{ active: playerAvailabilityTab === 'injured-tab' }"
            @click="tabChange('playerAvailabilityTab', 'injured-tab')"
          >
            <i class="bi bi-bandaid"></i>
            Injured
            <span class="avail-tab-count">{{ injuredList.length }}</span>
          </button>
        </div>

        <!-- Going Tab -->
        <div class="avail-panel" v-if="playerAvailabilityTab === 'going-tab'">
          <div
            class="avail-player"
            v-for="attendee in goingList"
            :key="attendee.user_id"
          >
            <img
              v-if="attendee.userImage"
              :src="getImgUrl(attendee.userImage)"
              class="avail-player-img"
            />
            <img
              v-else
              :src="getImgUrl('default-image.png')"
              class="avail-player-img"
            />
            <span class="avail-player-name">{{ attendee.name }}</span>
            <i class="bi bi-check-circle-fill avail-status-icon going"></i>
            <select
              v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              "
              class="avail-change-select"
              @change="
                gameResponceChange(attendee.user_id);
                $event.target.value = '';
              "
              v-model="gameResponceValueChange"
            >
              <option value="">Change</option>
              <option value="No">Not Going</option>
              <option value="Injured">Injured</option>
            </select>
          </div>
          <div v-if="goingList.length === 0" class="avail-empty">
            <i class="bi bi-person-slash"></i>
            <p>No players confirmed yet.</p>
          </div>
        </div>

        <!-- Not Going Tab -->
        <div
          class="avail-panel"
          v-if="playerAvailabilityTab === 'not-going-tab'"
        >
          <div
            class="avail-player"
            v-for="attendee in notGoingList"
            :key="attendee.user_id"
          >
            <img
              v-if="attendee.userImage"
              :src="getImgUrl(attendee.userImage)"
              class="avail-player-img"
            />
            <img
              v-else
              :src="getImgUrl('default-image.png')"
              class="avail-player-img"
            />
            <div class="avail-player-info">
              <span class="avail-player-name">{{ attendee.name }}</span>
              <span v-if="attendee.comments" class="avail-player-comment">{{
                attendee.comments
              }}</span>
            </div>
            <i class="bi bi-x-circle-fill avail-status-icon not-going"></i>
            <select
              v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              "
              class="avail-change-select"
              @change="
                gameResponceChange(attendee.user_id);
                $event.target.value = '';
              "
              v-model="gameResponceValueChange"
            >
              <option value="">Change</option>
              <option value="Yes">Going</option>
              <option value="Injured">Injured</option>
            </select>
          </div>
          <div v-if="notGoingList.length === 0" class="avail-empty">
            <i class="bi bi-emoji-smile"></i>
            <p>Everyone's available!</p>
          </div>
        </div>

        <!-- No Response Tab -->
        <div
          class="avail-panel"
          v-if="playerAvailabilityTab === 'no-response-tab'"
        >
          <div
            v-if="
              noResponsePlayersList.length > 0 &&
              (userData.userType === 'Admin' || userData.userType === 'Coach')
            "
            class="avail-bulk-actions"
          >
            <button
              class="avail-bulk-btn going"
              @click="bulkMarkAttendance('Yes')"
              :disabled="bulkUpdating"
            >
              <i class="bi bi-check-all"></i> Mark All Going
            </button>
            <button
              class="avail-bulk-btn not-going"
              @click="bulkMarkAttendance('No')"
              :disabled="bulkUpdating"
            >
              <i class="bi bi-x-lg"></i> Mark All Not Going
            </button>
            <span v-if="bulkUpdating" class="avail-bulk-spinner">
              <span class="spinner-border spinner-border-sm"></span> Updating...
            </span>
          </div>
          <div
            class="avail-player"
            v-for="attendee in noResponsePlayersList"
            :key="attendee.id"
          >
            <img
              v-if="attendee.userImage"
              :src="getImgUrl(attendee.userImage)"
              class="avail-player-img"
            />
            <img
              v-else
              :src="getImgUrl('default-image.png')"
              class="avail-player-img"
            />
            <span class="avail-player-name">{{ attendee.name }}</span>
            <i class="bi bi-dash-circle avail-status-icon no-response"></i>
            <select
              v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              "
              class="avail-change-select"
              @change="
                gameResponceChange(attendee.id);
                $event.target.value = '';
              "
              v-model="gameResponceValueChange"
            >
              <option value="">Change</option>
              <option value="Yes">Going</option>
              <option value="No">Not Going</option>
              <option value="Injured">Injured</option>
            </select>
          </div>
          <div v-if="noResponsePlayersList.length === 0" class="avail-empty">
            <i class="bi bi-check-all"></i>
            <p>All players have responded.</p>
          </div>
        </div>

        <!-- Injured Tab -->
        <div class="avail-panel" v-if="playerAvailabilityTab === 'injured-tab'">
          <div
            class="avail-player"
            v-for="attendee in injuredList"
            :key="attendee.user_id"
          >
            <img
              v-if="attendee.userImage"
              :src="getImgUrl(attendee.userImage)"
              class="avail-player-img"
            />
            <img
              v-else
              :src="getImgUrl('default-image.png')"
              class="avail-player-img"
            />
            <span class="avail-player-name">{{ attendee.name }}</span>
            <i class="bi bi-bandaid-fill avail-status-icon injured"></i>
            <select
              v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              "
              class="avail-change-select"
              @change="
                gameResponceChange(attendee.user_id);
                $event.target.value = '';
              "
              v-model="gameResponceValueChange"
            >
              <option value="">Change</option>
              <option value="Yes">Going</option>
              <option value="No">Not Going</option>
            </select>
          </div>
          <div v-if="injuredList.length === 0" class="avail-empty">
            <i class="bi bi-emoji-smile"></i>
            <p>No injured players.</p>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-if="showViewGameDeleteEditOptions"
      v-model="showViewGameDeleteEditOptions"
      @hidden="occuranceModalClose()"
      size="lg"
      :hide-footer="true"
    >
      <h2>
        {{ modalTypeNmae }} {{ selectedGame.teamName }}
        <span v-if="selectedGame.gameType !== 'Training'"
          >V {{ selectedGame.opposition }}</span
        >
        <span v-else>{{ selectedGame.gameType }}</span>
      </h2>
      <b-form-group
        id="occurance-radios"
        :label="
          modalTypeNmae === 'Edit'
            ? 'Select the occurance you wish to Edit'
            : 'Select the occurance you wish to Delete'
        "
      >
        <b-form-radio
          v-model="gameDeleteEditoccuranceValue"
          name="game-delete-radios"
          :value="`one-${modalTypeNmae}`"
        >
          Only this occurance</b-form-radio
        >
        <!--<b-form-radio
          v-model="gameDeleteEditoccuranceValue"
          name="game-delete-radios"
          :value="`all-${modalTypeNmae}`"
        >
          All occurances</b-form-radio
        >
        <b-form-invalid-feedback v-if="gameDeleteEditoccuranceValue === null"
          >Please select one</b-form-invalid-feedback
        >-->
      </b-form-group>

      <div class="player-game-responce">
        <b-button
          @click="deleteGames()"
          v-if="
            modalTypeNmae === 'Delete' &&
            gameDeleteEditoccuranceValue !== null &&
            !$store.getters.isReadOnlySeason
          "
          variant="outline-danger"
          ><i class="bi bi-trash" aria-hidden="true"></i> Delete</b-button
        >
        <b-button
          @click="showEditAddGamesModal('edit')"
          v-if="
            modalTypeNmae === 'Edit' && gameDeleteEditoccuranceValue !== null
          "
          variant="outline-warning"
          v-b-tooltip.hover
          title="Edit"
          ><i class="bi bi-pencil" aria-hidden="true"></i
        ></b-button>
      </div>
    </b-modal>

    <!-- Bulk Delete Training Sessions Modal -->
    <b-modal
      v-if="showBulkDeleteTrainingModal"
      v-model="showBulkDeleteTrainingModal"
      size="lg"
      :hide-footer="true"
      title="Delete Training Sessions"
      @hidden="onBulkTrainingModalClose"
    >
      <div class="bulk-delete-modal-content">
        <div class="warning-message">
          <i class="bi bi-exclamation-triangle-fill text-warning"></i>
          <p>
            You are about to delete
            <strong>{{ selectedTrainingSessions.length }}</strong> training
            session(s). This action cannot be undone.
          </p>
        </div>

        <div class="sessions-to-delete">
          <h5>Sessions to be deleted:</h5>
          <ul class="training-list">
            <li v-for="session in selectedTrainingSessions" :key="session.id">
              <span class="session-date"
                ><i class="bi bi-calendar3"></i>
                {{ getDayAndDate(session.matchDate) }}</span
              >
              <span class="session-time"
                ><i class="bi bi-stopwatch"></i>
                {{ formatISOStringDateAndTime(session.kickOffTime) }} -
                {{ formatISOStringDateAndTime(session.endTime) }}</span
              >
              <span
                v-if="session.recurringEventType !== null"
                class="recurring-badge"
              >
                <i class="bi bi-arrow-clockwise"></i> Recurring
              </span>
            </li>
          </ul>
        </div>

        <div class="modal-actions">
          <b-button
            variant="outline-secondary"
            @click="showBulkDeleteTrainingModal = false"
            :disabled="isBulkDeleting"
          >
            Cancel
          </b-button>
          <b-button
            variant="danger"
            @click="confirmBulkDeleteTraining"
            :disabled="isBulkDeleting"
          >
            <span v-if="isBulkDeleting"
              ><i class="bi bi-hourglass-split"></i> Deleting...</span
            >
            <span v-else
              ><i class="bi bi-trash"></i> Delete
              {{ selectedTrainingSessions.length }} Session(s)</span
            >
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Bulk Edit Training Sessions Modal -->
    <b-modal
      v-if="showBulkEditTrainingModal"
      v-model="showBulkEditTrainingModal"
      size="lg"
      :hide-footer="true"
      title="Edit Training Sessions"
      @hidden="onBulkTrainingModalClose"
    >
      <div class="bulk-edit-modal-content">
        <div class="info-message">
          <i class="bi bi-info-circle-fill text-info"></i>
          <p>
            Edit <strong>{{ selectedTrainingSessions.length }}</strong> training
            session(s). Only filled fields will be updated.
          </p>
        </div>

        <form
          class="form bulk-edit-form"
          @submit.prevent="confirmBulkEditTraining"
        >
          <div class="form-row">
            <div class="form__item">
              <label class="form__label" for="bulkEditKickOffTime"
                >Start Time</label
              >
              <input
                type="time"
                id="bulkEditKickOffTime"
                v-model="bulkEditTrainingData.kickOffTime"
                class="form-control"
              />
              <small class="form-text text-muted"
                >Leave empty to keep existing times</small
              >
            </div>
            <div class="form__item">
              <label class="form__label" for="bulkEditEndTime">End Time</label>
              <input
                type="time"
                id="bulkEditEndTime"
                v-model="bulkEditTrainingData.endTime"
                class="form-control"
              />
              <small class="form-text text-muted"
                >Leave empty to keep existing times</small
              >
            </div>
          </div>

          <div class="form__item">
            <label class="form__label" for="bulkEditLocationName"
              >Location Name</label
            >
            <input
              type="text"
              id="bulkEditLocationName"
              v-model="bulkEditTrainingData.locationName"
              class="form-control"
              placeholder="Enter location name"
            />
          </div>

          <div class="form-row">
            <div class="form__item">
              <label class="form__label" for="bulkEditAddress">Address</label>
              <input
                type="text"
                id="bulkEditAddress"
                v-model="bulkEditTrainingData.address"
                class="form-control"
                placeholder="Enter address"
              />
            </div>
            <div class="form__item">
              <label class="form__label" for="bulkEditPostCode"
                >Post Code</label
              >
              <input
                type="text"
                id="bulkEditPostCode"
                v-model="bulkEditTrainingData.postCode"
                class="form-control"
                placeholder="Enter post code"
              />
            </div>
          </div>

          <div class="form__item">
            <label class="form__label" for="bulkEditPitch">Pitch</label>
            <b-form-select
              id="bulkEditPitch"
              v-model="bulkEditTrainingData.pitch_id"
            >
              <b-form-select-option :value="''"
                >-- Keep existing pitch --</b-form-select-option
              >
              <b-form-select-option
                v-for="pitch in pitches"
                :key="pitch.id"
                :value="pitch.id"
              >
                {{ pitch.name }}
              </b-form-select-option>
            </b-form-select>
          </div>

          <div class="form__item">
            <label class="form__label" for="bulkEditNotes">Notes</label>
            <textarea
              id="bulkEditNotes"
              v-model="bulkEditTrainingData.notes"
              class="form-control"
              rows="3"
              placeholder="Enter notes (will replace existing notes)"
            ></textarea>
          </div>

          <div class="sessions-to-edit">
            <h5>Sessions to be updated:</h5>
            <ul class="training-list">
              <li v-for="session in selectedTrainingSessions" :key="session.id">
                <span class="session-date"
                  ><i class="bi bi-calendar3"></i>
                  {{ getDayAndDate(session.matchDate) }}</span
                >
                <span class="session-time"
                  ><i class="bi bi-stopwatch"></i>
                  {{ formatISOStringDateAndTime(session.kickOffTime) }} -
                  {{ formatISOStringDateAndTime(session.endTime) }}</span
                >
              </li>
            </ul>
          </div>

          <div class="modal-actions">
            <b-button
              variant="outline-secondary"
              @click="showBulkEditTrainingModal = false"
              :disabled="isBulkEditing"
            >
              Cancel
            </b-button>
            <b-button type="submit" variant="warning" :disabled="isBulkEditing">
              <span v-if="isBulkEditing"
                ><i class="bi bi-hourglass-split"></i> Updating...</span
              >
              <span v-else
                ><i class="bi bi-pencil"></i> Update
                {{ selectedTrainingSessions.length }} Session(s)</span
              >
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal
      v-if="showAddNewGameresultModal"
      v-model="showAddNewGameresultModal"
      size="lg"
      :hide-footer="true"
      @close="resetGameResultsGoalSelection"
    >
      <h4>
        {{ editGame.gameType }} v {{ editGame.opposition }} -
        {{ dayMonthYear(editGame.kickOffTime) }}
        {{ formatISOStringDateAndTime(editGame.kickOffTime) }}
      </h4>

      <form
        class="form"
        @submit.prevent="editProgrammeSubmit('addNewGameresultModal')"
      >
        <div class="form__item">
          <label class="form__label" for="selectGameEvent"
            >Select game event</label
          >
          <select id="selectGameEvent" v-model="gameEventSelected">
            <option disabled value="">Please select a game event</option>
            <option value="goal">Add goal scorer & goal</option>
            <option value="result">Only add full result</option>
            <!--<option value="booking">Booking</option>
            <option value="sendingOff">Sending off</option>-->
          </select>
        </div>

        <template v-if="gameEventSelected === 'goal'">
          <div class="form__item">
            <label class="form__label" for="selectGameEvent"
              >What team scored
            </label>
            <select
              id="selectGameEvent"
              v-model="teamWhoScored"
              @change="updateTeamWhoScored()"
            >
              <option disabled value="">Please select a team</option>
              <option value="home">Home</option>
              <option value="away">Away</option>
            </select>
          </div>

          <div class="form__item">
            <label class="form__label" for="goal_type">Goal type </label>
            <select id="goal_type" v-model="editGame.goal_type">
              <option disabled value="">Please select the goal type</option>
              <option value="Open play">Open play</option>
              <option value="Fee kick">Fee kick</option>
              <option value="Pentaly">Pentaly</option>
            </select>
          </div>

          <div class="form__item" v-if="teamWhoScored === 'home'">
            <label class="form__label" for="userSelect">Who scored</label>

            <div class="user-select-wrapper">
              <div v-for="(user, index) in currentTeam" :key="user.id + index">
                <input
                  @change="goalScoredUserIdAddRemove($event)"
                  type="checkbox"
                  :id="user.id"
                  :name="user.id"
                  :value="user.name"
                  :checked="user.selected"
                />
                <label :for="user.id">{{ user.name }}</label
                ><br />
              </div>
            </div>
          </div>

          <div class="form__item" v-if="teamWhoScored === 'home'">
            <label class="form__label" for="userSelect"
              >Who assisted the goal</label
            >

            <div class="user-select-wrapper">
              <div v-for="(user, index) in currentTeam" :key="user.id + index">
                <input
                  @change="goalAssistUserIdAddRemove($event)"
                  type="checkbox"
                  :id="user.id"
                  :name="user.id"
                  :value="user.name"
                  :checked="user.selected"
                />
                <label :for="user.id">{{ user.name }}</label
                ><br />
              </div>
            </div>
          </div>

          <div class="form__item">
            <label class="form__label" for="selectGameEvent"
              >Time of goal (mins)
            </label>
            <input
              class="form__input very-small-two-numbers"
              type="number"
              min="0"
              max="99"
              size="1"
              maxlength="2"
              id="timeOfGoal"
              v-model="editGame.goal_time"
            />
          </div>
        </template>
        <template v-if="gameEventSelected === 'result'">
          <div class="form__item">
            <label class="form__label" for="home_team_goals"
              >{{ selectedTeam.teamName }} goals
            </label>
            <input
              class="form__input very-small-two-numbers"
              type="number"
              min="0"
              max="99"
              size="1"
              maxlength="2"
              id="home_team_goals"
              v-model="editGame.home_team_goals"
            />
          </div>

          <div class="form__item">
            <label class="form__label" for="away_team_goals"
              >{{ editGame.opposition }} goals
            </label>
            <input
              class="form__input very-small-two-numbers"
              type="number"
              min="0"
              max="99"
              size="1"
              maxlength="2"
              id="away_team_goals"
              v-model="editGame.away_team_goals"
            />
          </div>
        </template>

        <div class="player-game-responce">
          <b-button type="submit" variant="success">Add goal</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal
      v-if="showMatchReportModal"
      v-model="showMatchReportModal"
      modal-class="modal-fullscreen"
      size="lg"
      :hide-footer="true"
      title="Match Report"
    >
      <div class="match-report-modal-wrapper">
        <div class="match-details-col">
          <h4>
            {{ selectedMatchReportData.teamName }} vs
            {{ selectedMatchReportData.opposition }}
          </h4>
          <p>
            Match date: {{ getDayAndDate(selectedMatchReportData.matchDate) }}
          </p>
          <p>
            Match venue:
            <span v-if="selectedMatchReportData.home_team === true">Home</span
            ><span v-else>Away</span>
          </p>

          <p>Game result</p>

          <div class="form__item small-input">
            <label class="form__label" for="goals">{{
              selectedMatchReportData.teamName
            }}</label>
            <b-form-input
              id="goals"
              v-model="selectedMatchReportData.home_team_goals"
            ></b-form-input>
          </div>

          <div class="form__item small-input">
            <label class="form__label" for="opposition">{{
              selectedMatchReportData.opposition
            }}</label>
            <b-form-input
              id="opposition"
              v-model="selectedMatchReportData.away_team_goals"
            ></b-form-input>
          </div>
        </div>
        <div class="team-average-score-col">
          <p class="header">Team Average:</p>
          <p class="number-score">{{ this.teamAverageMatchReportScore }}</p>
        </div>
      </div>

      <table class="key-ratings-table">
        <thead>
          <tr>
            <th>Key to Ratings:</th>
            <th class="dark-green">5</th>
            <th class="green">4</th>
            <th class="black">3</th>
            <th class="yellow">2</th>
            <th class="red">1</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td class="dark-green">Excellent</td>
            <td class="green">Good</td>
            <td class="black">Average</td>
            <td class="yellow">⁠⁠Requires improvement</td>
            <td class="red">Poor</td>
          </tr>
        </tbody>
      </table>

      <div class="players-attendance-summary">
        <h3>Player attendance</h3>

        <div class="attendance-wrapper">
          <ul class="player-list">
            <li
              v-for="(attendee, index) in currentTeam"
              :key="attendee.id || index"
            >
              <p :class="getAttendanceStatusClass(attendee.id)">
                <img
                  v-if="attendee.userImage"
                  :src="getImgUrl(attendee.userImage)"
                  alt=""
                  class="user-image-small"
                />
                <TenantLogo
                  v-else
                  logo-class="login-logo"
                  class="user-image-small"
                />

                {{ attendee.name }}

                <span :class="getAttendanceIconClass(attendee.id)">
                  <i
                    :class="getAttendanceIcon(attendee.id)"
                    aria-hidden="true"
                  ></i>
                </span>

                <span
                  v-if="checkIfPlayersAttendance(attendee.id) !== 'notGoing'"
                >
                  <b-form-select
                    v-model="gameResponceValueChange"
                    @change="gameResponceChangeFromCoachReport(attendee)"
                    class="mb-3"
                  >
                    <b-form-select-option :value="null"
                      >Change player response</b-form-select-option
                    >
                    <b-form-select-option value="Yes"
                      >Going</b-form-select-option
                    >
                    <b-form-select-option value="No"
                      >Not Going</b-form-select-option
                    >
                  </b-form-select>
                </span>
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="eyeballImportAvailable" class="mb-3">
        <button
          @click="importEyeballDataToMatchReport()"
          class="eyeball-import-btn"
          :disabled="isImportingEyeballData"
        >
          <span
            v-if="isImportingEyeballData"
            class="spinner-border spinner-border-sm"
            role="status"
          ></span>
          <i v-else class="bi bi-download"></i>
          <span class="btn-text">
            <span class="btn-title">{{
              isImportingEyeballData ? "Importing…" : "Import from Eyeball"
            }}</span>
            <span class="btn-subtitle"
              >Minutes, goals &amp; positions · won't overwrite existing
              data</span
            >
          </span>
        </button>
      </div>

      <table class="w-a-style" style="width: 100%">
        <thead>
          <tr>
            <th>Player's Name</th>
            <th>Position(s) Played</th>
            <th>Playing Time (mins)</th>
            <th>Assists</th>
            <th>Goals</th>
            <th>Cards</th>
            <th>Performance Rating</th>
            <th>Positive Comments</th>
            <th>Improvement Comments</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(
              playerMatchData, index
            ) in selectedMatchReportData.playerMatchReports"
            :key="playerMatchData.id"
          >
            <td style="width: 16rem">
              {{ playerMatchData.players_name }} -
              {{ playerMatchData.age_group }}
              <span v-if="playerMatchData.trialistId !== null">
                <i class="bi bi-person" aria-hidden="true"></i> Trialist</span
              >
            </td>
            <td>
              <div
                class="access-pool"
                v-if="playerMatchData.positions_played.length > 0"
              >
                <span
                  v-for="positionPlayed in playerMatchData.positions_played"
                  :key="positionPlayed"
                  class="has-access"
                >
                  {{ positionPlayed }}
                  <span
                    @click="removePlayerPostionPlayed(index, positionPlayed)"
                    >x</span
                  >
                </span>
              </div>
              <div v-else>No Position selected</div>

              <select
                :value="''"
                @change="addPlayerPostionPlayed($event.target.value, index)"
              >
                <option disabled value="">Please select a position</option>
                <option value="Goalkeeper">Goalkeeper</option>
                <option value="Right Full-back (Wingback)">
                  Right Full-back (Wingback)
                </option>
                <option value="Left Full-back (Wingback)">
                  Left Full-back (Wingback)
                </option>
                <option value="Center-back left">Center-back left</option>
                <option value="Center-back right">Center-back right</option>
                <option value="Defensive Midfielder">
                  Defensive Midfielder
                </option>
                <option value="Centre midfield">Centre midfield</option>
                <option value="Centre Defensive Midfield">
                  Centre Defensive Midfield
                </option>
                <option value="Right Midfielder (Winger)">
                  Right Midfielder (Winger)
                </option>
                <option value="Left Midfielder (Winger)">
                  Left Midfielder (Winger)
                </option>
                <option value="Attacking Midfielder">
                  Attacking Midfielder
                </option>
                <option value="Center Forward (Striker) left">
                  Center Forward (Striker) left
                </option>
                <option value="Center Forward (Striker) right">
                  Center Forward (Striker) right
                </option>
                <option value="Sub">Sub</option>
                <option value="Did not play">Did not play</option>
              </select>
            </td>
            <td style="width: 10rem">
              <b-form-input
                id="textarea"
                v-model="playerMatchData.session_mins"
              ></b-form-input>
            </td>

            <td style="width: 10rem">
              <b-form-input
                id="textarea"
                v-model="playerMatchData.assists"
              ></b-form-input>
            </td>
            <td style="width: 10rem">
              <b-form-input
                id="textarea"
                v-model="playerMatchData.goals"
              ></b-form-input>
            </td>
            <td style="width: 10rem">
              <div class="card-checkboxes">
                <b-form-checkbox
                  v-model="playerMatchData.yellow_card"
                  :value="true"
                  :unchecked-value="false"
                  class="yellow-card-checkbox"
                >
                  <span class="card-icon yellow">🟨</span>
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="playerMatchData.red_card"
                  :value="true"
                  :unchecked-value="false"
                  class="red-card-checkbox"
                >
                  <span class="card-icon red">🟥</span>
                </b-form-checkbox>
              </div>
            </td>
            <td style="width: 10rem">
              <!--<b-form-input
                              v-on:keyup="updateTeamAverage()"
                              id="textarea"
                              v-model="playerMatchData.performance_rating"
                            ></b-form-input>-->

              <b-form-radio-group
                size="lg"
                v-model="playerMatchData.performance_rating"
                @input="onPerformanceRatingChange($event, index)"
                class="match-report-rating"
              >
                <b-form-radio class="dark-green" value="Excellent"
                  >5</b-form-radio
                >
                <b-form-radio class="green" value="Good">4</b-form-radio>
                <b-form-radio class="black" value="Progressing well"
                  >3</b-form-radio
                >
                <b-form-radio class="yellow" value="⁠⁠Requires improvement"
                  >2</b-form-radio
                >
                <b-form-radio class="red" value="Unsatisfactory"
                  >1</b-form-radio
                >
              </b-form-radio-group>
            </td>
            <td>
              <CoachReportAIHelper
                v-model="playerMatchData.game_comments"
                field-type="positives"
                :player-name="playerMatchData.players_name"
                :position="
                  Array.isArray(playerMatchData.positions_played)
                    ? playerMatchData.positions_played.join(', ')
                    : playerMatchData.positions_played || ''
                "
              />
              <b-form-textarea
                id="textarea"
                v-model="playerMatchData.game_comments"
                placeholder="Enter comments..."
                rows="3"
              ></b-form-textarea>
            </td>

            <td>
              <CoachReportAIHelper
                v-model="playerMatchData.game_improvements"
                field-type="improvements"
                :player-name="playerMatchData.players_name"
                :position="
                  Array.isArray(playerMatchData.positions_played)
                    ? playerMatchData.positions_played.join(', ')
                    : playerMatchData.positions_played || ''
                "
              />
              <b-form-textarea
                id="textarea"
                v-model="playerMatchData.game_improvements"
                placeholder="Enter improvements..."
                rows="3"
              ></b-form-textarea>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="form__item">
        <label class="form__label">Coach comments on match</label>
        <QuillEditor
          v-model:content="selectedMatchReportData.generalComments"
          contentType="html"
          theme="snow"
        />
      </div>

      <div class="form__item">
        <label class="form__label" for="coachSelect"
          >Name of Coach(s) completing the report</label
        >
        <b-form-select
          v-model="selectedMatchReportData.coachId"
          id="coachSelect"
          :state="selectedMatchReportData.coachId ? true : false"
          required
        >
          <b-form-select-option disabled value=""
            >Please select a coach</b-form-select-option
          >
          <b-form-select-option
            v-for="coach in coachData"
            :value="coach.id"
            :key="coach.id"
          >
            {{ coach.name }}
          </b-form-select-option>
        </b-form-select>
        <b-form-invalid-feedback>
          Please select a coach to complete the report
        </b-form-invalid-feedback>

        <p>{{ getCoachesNameFromId(selectedMatchReportData.coachId) }}</p>
      </div>

      <div class="form__item">
        <label class="form__label"> Physio Present:</label>
        <b-form-input
          style="width: 20rem"
          id="textarea"
          v-model="selectedMatchReportData.physio_name"
        >
        </b-form-input>
      </div>

      <b-button
        style="margin: 2rem 0"
        @click="createNewMultiGameAnalysis()"
        variant="success"
        >Save match report</b-button
      >
    </b-modal>

    <b-modal
      v-if="showGameAnalysisModal"
      v-model="showGameAnalysisModal"
      size="lg"
      :hide-footer="true"
      title="Game Analysis"
    >
      <h4>
        {{ selectedGameAnalysisData.teamName }} vs
        {{ selectedGameAnalysisData.opposition }}
      </h4>

      <div class="game-analysis-details">
        <p>Coach: {{ selectedGameAnalysisData.coachName }}</p>
        <p>
          Match date: {{ getDayAndDate(selectedGameAnalysisData.matchDate) }}
        </p>
      </div>

      <div class="attacting-options">
        <h4>Attacking Observations</h4>

        <div class="form__item">
          <label class="form__label" for="penetrationComments"
            >Penetration
          </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.penetrationScore"
              @update:rating="
                selectedGameAnalysisData.penetrationScore = $event
              "
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="penetrationComments"
            v-model="selectedGameAnalysisData.penetrationComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="supportComments">Support </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.supportScore"
              @update:rating="selectedGameAnalysisData.supportScore = $event"
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="supportComments"
            v-model="selectedGameAnalysisData.supportComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="mobilitComments">Mobility </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.mobilityScore"
              @update:rating="selectedGameAnalysisData.mobilityScore = $event"
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="mobilitComments"
            v-model="selectedGameAnalysisData.mobilityComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="creativitComments">Creativity </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.creativityScore"
              @update:rating="selectedGameAnalysisData.creativityScore = $event"
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="creativitComments"
            v-model="selectedGameAnalysisData.creativityComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="creativitComments"
            >Transition to Attack
          </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.transitionToAttackScore"
              @update:rating="
                selectedGameAnalysisData.transitionToAttackScore = $event
              "
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="transitionToAttackComments"
            v-model="selectedGameAnalysisData.transitionToAttackComments"
          ></b-form-textarea>
        </div>
      </div>

      <div class="defending-options">
        <h4>Defending Observations</h4>

        <div class="form__item">
          <label class="form__label" for="pressureComments">Pressure </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.pressureScore"
              @update:rating="selectedGameAnalysisData.pressureScore = $event"
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="pressureComments"
            v-model="selectedGameAnalysisData.pressureComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="supportComments">Cover </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.coverScore"
              @update:rating="selectedGameAnalysisData.coverScore = $event"
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="coverComments"
            v-model="selectedGameAnalysisData.coverComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="balanceComments">Balance </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.balanceScore"
              @update:rating="selectedGameAnalysisData.balanceScore = $event"
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="balanceComments"
            v-model="selectedGameAnalysisData.balanceComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="compactnessComments"
            >Compactness
          </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.compactnessScore"
              @update:rating="
                selectedGameAnalysisData.compactnessScore = $event
              "
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="compactnessComments"
            v-model="selectedGameAnalysisData.compactnessComments"
          ></b-form-textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="transitionToDefendComments"
            >Transition to Defend
          </label>
          <div class="ratingStars">
            <StarRating
              :rating="selectedGameAnalysisData.transitionToDefendScore"
              @update:rating="
                selectedGameAnalysisData.transitionToDefendScore = $event
              "
              :star-size="25"
            />
          </div>
          <b-form-textarea
            placeholder="Comments"
            rows="3"
            max-rows="6"
            id="transitionToDefendComments"
            v-model="selectedGameAnalysisData.transitionToDefendComments"
          ></b-form-textarea>
        </div>
      </div>

      <div class="general-options">
        <h4>General Observations</h4>
        <QuillEditor
          v-model:content="selectedGameAnalysisData.generalComments"
          contentType="html"
          theme="snow"
        />
      </div>

      <div class="training-suggestions">
        <h4>Training Suggestions</h4>
        <QuillEditor
          v-model:content="selectedGameAnalysisData.trainingComments"
          contentType="html"
          theme="snow"
        />
      </div>

      <div class="player-game-responce">
        <b-button
          v-if="selectedGameAnalysisData.edit === true"
          @click="upDateGameAnalysisData()"
          variant="success"
          >Edit</b-button
        >
        <b-button v-else @click="createNewGameAnalysis()" variant="success"
          >Save</b-button
        >
      </div>
    </b-modal>

    <b-modal
      v-if="showAddHomeworkModal"
      v-model="showAddHomeworkModal"
      size="lg"
      :hide-footer="true"
    >
      <h2>
        <span v-if="newHomeWorkData.id !== undefined">Edit</span
        ><span v-else>Add</span> homework
      </h2>

      <div class="form__item">
        <label class="form__label" for="goals">Title</label>
        <b-form-input
          id="textarea"
          v-model="newHomeWorkData.title"
        ></b-form-input>
      </div>
      <div class="form__item" v-if="pastGames.length > 0">
        <label class="form__label" for="goals">Select game</label><br />

        <b-form-select
          v-model="newHomeWorkData.gameId"
          id="gameSelect"
          :state="newHomeWorkData.gameId ? true : false"
          required
          class="mb-3"
        >
          <b-form-select-option disabled value=""
            >Please select a game</b-form-select-option
          >
          <b-form-select-option
            v-for="(game, index) in pastGames"
            :key="index"
            :value="game.id"
            >{{ formatDates(game.matchDate) }} -
            {{ game.opposition }}</b-form-select-option
          >
        </b-form-select>
        <b-form-invalid-feedback>
          Please select a game for the homework
        </b-form-invalid-feedback>
      </div>
      <p v-else class="no-games-to-select-text">
        No games to select, select other dates in the Games tab if you want to
        load older games and attatch the homework to a game.
      </p>
      <div class="form__item">
        <label class="form__label" for="goals">Information</label>
        <QuillEditor
          v-model:content="newHomeWorkData.information"
          contentType="html"
          theme="snow"
        />
      </div>

      <h4>Videos</h4>

      <b-button
        v-b-tooltip.hover
        title="Add video"
        @click="addVideo('homework')"
        variant="success"
      >
        <i class="bi bi-plus" aria-hidden="true"></i>
      </b-button>

      <div
        class="homework-links"
        v-for="(video, index) in newHomeWorkData.videos"
        :key="index"
        :value="video"
      >
        <div class="form__item">
          <label class="form__label" for="video-name">Video name</label>
          <b-form-input
            id="video-name"
            v-model="video.video_name"
          ></b-form-input>
        </div>

        <div class="form__item">
          <label class="form__label" for="video-url">Video URL</label>
          <b-form-input id="video-url" v-model="video.video_url"></b-form-input>
        </div>

        <b-button v-b-tooltip.hover title="remove video" variant="danger">
          <i class="bi bi-x" aria-hidden="true" @click="removeVideo(index)"></i
        ></b-button>
      </div>

      <b-button
        v-if="newHomeWorkData.id !== undefined"
        @click="editHomework()"
        size="lg"
        variant="outline-success"
        ><i class="bi bi-file-text" aria-hidden="true"></i> Edit game
        homework</b-button
      >

      <b-button
        v-else
        @click="saveHomework()"
        size="lg"
        variant="outline-success"
        :disabled="$store.getters.isReadOnlySeason"
        ><i class="bi bi-file-text" aria-hidden="true"></i> Submit game
        homework</b-button
      >
    </b-modal>

    <!--<b-modal
        id="addHomeworkModal"
        size="lg"
        :hide-footer="Boolean(true)"
      >

      <h2><span v-if="newHomeWorkData.id !== undefined">Edit</span><span v-else>Add</span> homework</h2>

      <div class="form__item">
        <label class="form__label" for="goals"
          >Title</label
        >
        <b-form-input
          id="textarea"
          v-model="newHomeWorkData.title"
        ></b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="goals"
          >Information</label
        >
        <QuillEditor v-model:content="newHomeWorkData.information" contentType="html" theme="snow" />
      </div>

          <b-button  v-if="newHomeWorkData.id !== undefined" @click="editHomework()" size="lg" variant="outline-success"
            ><i class="bi bi-file-text" aria-hidden="true"></i> Edit
            game homework</b-button
          >

          <b-button v-else @click="saveHomework()" size="lg" variant="outline-success"
            ><i class="bi bi-file-text" aria-hidden="true"></i> Submit
            game homework</b-button
          >
      </b-modal>-->

    <gpsUploader
      @gpsUploadModalValue="gpsUploadModalValue"
      :openGPSUploadModal="openGPSUploadModal"
      :gameTrainingData="gameTrainingData"
    />

    <b-modal
      v-if="showViewHomeworkModal"
      v-model="showViewHomeworkModal"
      size="lg"
      :hide-footer="true"
    >
      <h2>homework</h2>

      <div class="form__item">
        <label class="form__label" for="goals">Title</label>
        <p>{{ newHomeWorkData.title }}</p>
      </div>

      <div class="form__item">
        <label class="form__label" for="goals">Game</label>
        <p>
          {{ newHomeWorkData.opposition }} -
          {{ formatDate(newHomeWorkData.matchDate) }}
        </p>
      </div>

      <div class="form__item">
        <label class="form__label" for="goals">Information</label>
        <p v-html="newHomeWorkData.information"></p>
      </div>

      <h4>Videos</h4>

      <div
        v-if="newHomeWorkData.videos.length > 0"
        class="homework-links player-cv"
      >
        <div class="sessions-info" style="margin-bottom: 0.5rem">
          <div
            class="video-wrapper"
            v-for="(item, index) in newHomeWorkData.videos"
            :key="index"
          >
            <a target="_blank" :href="item.video_url" class="session-card">
              <TenantImage image-name="video" extension="jpg" />
              <p class="small-date">Video</p>
              <h3>{{ item.video_name }}</h3>
            </a>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal-overlay modal-fullscreen"
      :title="`${eyeBallSelectedGameData.homeGameTeam?.club?.name || ''} vs ${eyeBallSelectedGameData.awayGameTeam?.club?.name || ''} - ${formatDate(eyeBallSelectedGameData.game?.date)}`"
      v-if="showEyeballMatchDataModal"
      v-model="showEyeballMatchDataModal"
      size="xl"
      :hide-footer="true"
      @hidden="onEyeballModalHidden"
    >
      <div class="eyeballGameWrapper">
        <div class="eyeballGame">
          <div class="eyeballGameVideo">
            <video
              ref="hlsVideoPlayer"
              controls
              autoplay
              width="100%"
              height="400"
              :poster="eyeBallSelectedGameData.video?.poster"
            >
              <track
                v-if="
                  eyeBallSelectedGameData.video?.thumbs && !isMixedContentIssue
                "
                kind="thumbnails"
                :src="eyeBallSelectedGameData.video.thumbs"
                default
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div class="eyeballGameDetails">
            <div class="teamLines">
              <div class="game">
                <ul class="tabs">
                  <li class="tab-item">
                    <a
                      :class="
                        eyeballTeamSheetTab === 'homeTeam-tab'
                          ? 'tab-link active'
                          : 'tab-link'
                      "
                      @click="tabChange('eyeballTeamSheetTab', 'homeTeam-tab')"
                      href="javascript:;"
                      >Home team</a
                    >
                  </li>

                  <li class="tab-item">
                    <a
                      :class="
                        eyeballTeamSheetTab === 'awayTeam-tab'
                          ? 'tab-link active'
                          : 'tab-link'
                      "
                      @click="tabChange('eyeballTeamSheetTab', 'awayTeam-tab')"
                      href="javascript:;"
                      >Away team</a
                    >
                  </li>
                </ul>
              </div>

              <div class="tabs-wrapper">
                <div
                  class="tab-content"
                  v-if="eyeballTeamSheetTab === 'homeTeam-tab'"
                >
                  <div
                    class="homeTeamLine"
                    v-if="
                      eyeBallSelectedGameData.homeGameTeam.players.length > 0
                    "
                  >
                    <div class="starting-xi">
                      <h3>
                        <img
                          :src="eyeBallSelectedGameData.homeGameTeam.club.logo"
                          :alt="eyeBallSelectedGameData.homeGameTeam.club.name"
                        />
                        Starting XI
                      </h3>

                      <table class="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Goals</th>
                            <th>Minutes Played</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="player in eyeBallSelectedGameData.homeGameTeam.players.filter(
                              (p) => p.isSubstitute === false,
                            )"
                            :key="player.id"
                          >
                            <td>{{ player.numberSign }}</td>
                            <td>{{ player.name }}</td>
                            <td>{{ player.positionKey }}</td>
                            <td>{{ player.goals }}</td>
                            <td>
                              {{
                                formatMinutesFromMilliseconds(
                                  player.minutesPlayed,
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="substitutes">
                      <h3>Substitutes</h3>
                      <table class="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Goals</th>
                            <th>Minutes Played</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="player in eyeBallSelectedGameData.homeGameTeam.players.filter(
                              (p) => p.isSubstitute === true,
                            )"
                            :key="player.id"
                          >
                            <td>{{ player.numberSign }}</td>
                            <td>{{ player.name }}</td>
                            <td>{{ player.positionKey }}</td>
                            <td>{{ player.goals }}</td>
                            <td>
                              {{
                                formatMinutesFromMilliseconds(
                                  player.minutesPlayed,
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="homeTeamLine" v-else>
                    <p>No home team team line</p>
                  </div>
                </div>
                <div
                  class="tab-content"
                  v-if="eyeballTeamSheetTab === 'awayTeam-tab'"
                >
                  <div
                    class="awayTeamLine"
                    v-if="
                      eyeBallSelectedGameData.awayGameTeam.players.length > 0
                    "
                  >
                    <div class="starting-xi">
                      <h3 v-if="eyeBallSelectedGameData.awayGameTeam.club.logo">
                        <img
                          :src="eyeBallSelectedGameData.awayGameTeam.club.logo"
                          :alt="eyeBallSelectedGameData.awayGameTeam.club.name"
                        />
                        Starting XI
                      </h3>
                      <h3 v-else>
                        {{ eyeBallSelectedGameData.awayGameTeam.club.name }}
                        Starting XI
                      </h3>

                      <table class="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Goals</th>
                            <th>Minutes Played</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="player in eyeBallSelectedGameData.awayGameTeam.players.filter(
                              (p) => p.isSubstitute === false,
                            )"
                            :key="player.id"
                          >
                            <td>{{ player.numberSign }}</td>
                            <td>{{ player.name }}</td>
                            <td>{{ player.positionKey }}</td>
                            <td>{{ player.goals }}</td>
                            <td>
                              {{
                                formatMinutesFromMilliseconds(
                                  player.minutesPlayed,
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="substitutes">
                      <h3>Substitutes</h3>

                      <table class="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Goals</th>
                            <th>Minutes Played</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="player in eyeBallSelectedGameData.awayGameTeam.players.filter(
                              (p) => p.isSubstitute === true,
                            )"
                            :key="player.id"
                          >
                            <td>{{ player.numberSign }}</td>
                            <td>{{ player.name }}</td>
                            <td>{{ player.positionKey }}</td>
                            <td>{{ player.goals }}</td>
                            <td>
                              {{
                                formatMinutesFromMilliseconds(
                                  player.minutesPlayed,
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="awayTeamLine" v-else>
                    <p>No away team team line</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Eyeball Player Linking Modal -->
    <b-modal
      v-if="showEyeballLinkingModal"
      v-model="showEyeballLinkingModal"
      size="lg"
      :hide-footer="true"
      title="Manage Eyeball Player Links"
    >
      <p class="mb-3">
        Link Eyeball player names to your app players. This is a one-time setup
        per player - once linked, their match data (minutes, goals, position)
        can be imported into match reports.
      </p>

      <div v-if="isSyncingEyeballPlayers" class="text-center py-3">
        <span class="spinner-border spinner-border-sm" role="status"></span>
        Syncing players from Eyeball...
      </div>

      <div v-else>
        <table
          class="w-a-style"
          style="width: 100%"
          v-if="eyeballPlayerLinks.length > 0"
        >
          <thead>
            <tr>
              <th>Eyeball Player Name</th>
              <th>Linked App Player</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ep in eyeballPlayerLinks" :key="ep.id">
              <td>{{ ep.eyeball_name }}</td>
              <td>
                <span v-if="ep.is_linked == 1" class="text-success">
                  <i class="bi bi-check-circle"></i> {{ ep.linked_player_name }}
                </span>
                <select
                  v-else
                  v-model="eyeballLinkSelections[ep.id]"
                  class="form-control form-control-sm"
                >
                  <option :value="null">-- Select player --</option>
                  <option
                    v-for="player in currentTeam"
                    :key="player.id"
                    :value="player.id"
                  >
                    {{ player.name }}
                  </option>
                </select>
              </td>
              <td>
                <b-button
                  v-if="ep.is_linked == 1"
                  @click="unlinkEyeballPlayer(ep.id)"
                  variant="outline-danger"
                  size="sm"
                >
                  <i class="bi bi-x-circle"></i> Unlink
                </b-button>
                <b-button
                  v-else
                  @click="linkEyeballPlayerAction(ep.id)"
                  variant="outline-success"
                  size="sm"
                  :disabled="!eyeballLinkSelections[ep.id]"
                >
                  <i class="bi bi-link-45deg"></i> Link
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="text-center py-3">
          <p>
            No Eyeball players found. Make sure Eyeball games exist for this
            team.
          </p>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-if="CASfixturesModal"
      v-model="CASfixturesModal"
      size="xl"
      :hide-footer="true"
      title="CAS Fixtures"
    >
      <div class="game cas-fixtures-modal" v-if="CASfixturesData.length > 0">
        <div class="game-wrapper">
          <div
            v-for="(fixture, index) in CASfixturesData"
            :key="index"
            class="match-details"
          >
            <p class="fixture-date">
              <i class="bi bi-calendar3"></i> {{ formatDate(fixture.date) }}
            </p>
            <p class="teams">
              {{ fixture.home_team }} <span class="versus">Vs</span>
              {{ fixture.away_team }}
            </p>

            <div class="game-info">
              <p class="fixture-competition">{{ fixture.competition }}</p>

              <div class="venue-time">
                <p class="fixture-venue" v-if="fixture.venue !== undefined">
                  <i class="bi bi-geo-alt"></i> {{ fixture.venue }}
                </p>
                <p class="fixture-venue" v-else>
                  <i class="bi bi-geo-alt"></i> No venue set
                </p>
                <p class="fixture-kickoff" v-if="fixture.time !== null">
                  <i class="bi bi-stopwatch"></i> {{ fixture.time }}
                </p>
                <p class="fixture-kickoff" v-else>
                  <i class="bi bi-stopwatch"></i> No kickoff time set
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-fixtures-text">
        <p>Fixtures loading...</p>
      </div>
    </b-modal>

    <TrainingContentPicker
      v-if="showTrainingContentPicker"
      :club-id="userData.clubId"
      :preselected-drills="sessionContent.drills"
      :preselected-programmes="sessionContent.programmes"
      @close="showTrainingContentPicker = false"
      @confirm="onTrainingContentSelected"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CHECK_PROFILE_HAS_DATA, USER_POPULATE } from "@/store/actions/user.js";
import { Users } from "@/services/user-service.js";
import { PlayerInjury } from "@/services/player-Injury-service.js";
import { Documents } from "@/services/documents-service.js";
import { PlayerPhysicalPerformance } from "@/services/player-physical-performance-service.js";
import { Homework } from "@/services/homework-service.js";
import AppTemplate from "../layouts/App";
import SectionNav from "@/components/SectionNav/index.vue";
import moment from "moment";
import SortingByCreatedDate from "../../components/Sorting";
import PitchSelect from "../../components/PitchSelect";
import { GadyflLeaguetable } from "@/services/leaguetable-service.js";
import { Teams } from "@/services/teams-service.js";
import { Games } from "@/services/games-service.js";
import { EyeBall } from "@/services/eyeball-service.js";
import CoachReportAIHelper from "../../components/CoachReportAIHelper.vue";
import { Chat } from "@/services/ChatService.js";
import { Trialists } from "@/services/trialist-service.js";
import { Pitches } from "@/services/coaches-pitches.js";
import { Comments } from "@/services/comments-service.js";
import { PlayerCv } from "@/services/player-cv-service.js";
import BarChartHorizontal from "../../components/BarChart-horizontal";
import DocumentView from "../../components/DocumentView";
import { checkIfMinsStatsDataExists } from "@/services/player-performance-service.js";
import PieChart from "../../components/PieChart";
import ChatsComponent from "../../components/Chats";
import TeamDashboard from "../../components/TeamDashboard";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import StarRating from "vue3-star-ratings";
import {
  where,
  orderBy,
  query,
  limit,
  collection,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import db from "@/firebase/init.js";
import removeDuplicatesMixin from "@/mixin/removeDuplicates.js";
import goToPlayerMixin from "@/mixin/goToPlayer.js";
import checkIfUserHasMoreThanOneAccountMixin from "@/mixin/checkIfUserHasMoreThanOneAccount.js";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import setPitchZoneTextMixin from "@/mixin/pitchZoneText.js";
import checkFBauthStateMixin from "@/mixin/checkFBauthState.js";
import GpsUploader from "../../components/GpsUploader";
import StrengthTestUploader from "../../components/StrengthTestsUploader";
import dayjs from "dayjs";
import "vue3-emoji-picker/css";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import Hls from "hls.js";
import TenantLogo from "@/components/TenantLogo/index.vue";
import TenantImage from "@/components/TenantImage/index.vue";
import SquadMaturityDashboard from "@/components/SquadMaturityDashboard.vue";
import TeamLeaguePanel from "@/components/ExternalLeague/TeamLeaguePanel.vue";
import { ExternalLeagues } from "@/services/external-leagues-service.js";
import TrainingContentPicker from "@/components/TrainingContentPicker/index.vue";
import SessionContentList from "@/components/SessionContentList/index.vue";
import { TrainingWeek } from "@/services/training-week-service.js";
import { isFeatureEnabled, isGrassroots } from "@/config/tenant";
import { avatarUrl } from "@/utils/avatar";

const Filter = require("bad-words"),
  filterBadWords = new Filter();

export default {
  name: "Teams",
  mixins: [
    removeDuplicatesMixin,
    checkIfUserHasMoreThanOneAccountMixin,
    goToPlayerMixin,
    setPitchZoneTextMixin,
    extendSeasonEndDateToFullYearMixin,
    checkFBauthStateMixin,
  ],
  components: {
    AppTemplate,
    SectionNav,
    VueDatePicker,
    SortingByCreatedDate,
    PitchSelect,
    CoachReportAIHelper,
    StarRating,
    GpsUploader,
    StrengthTestUploader,
    QuillEditor,
    //BarChart,
    //BarChartStacked,
    BarChartHorizontal,
    PieChart,
    ChatsComponent,
    TeamDashboard,
    DocumentView,
    TenantLogo,
    TenantImage,
    SquadMaturityDashboard,
    TeamLeaguePanel,
    TrainingContentPicker,
    SessionContentList,
  },
  data() {
    return {
      // Competition tab state
      leagueTableHtml: "",
      // Teams linked to an external league (team_league_map) — these show the
      // TeamLeaguePanel in the Competition tab instead of the CAS table.
      externalMappedTeamIds: [],
      showExternalLeaguePanel: false,
      competitionLoading: false,
      competitionError: null,
      competitionUnsupported: false,
      competitionName: "",
      // Performance tab state
      loadingTrainingPerformance: false,
      // Members tab filters
      filterMembersPosition: "",
      filterMembersAgeGroup: "",
      filterMembersInjury: "",
      selectedTeamName: "",
      loadIngStuffText: "Loading",
      input: "",
      showEmojiPicker: false,
      playerAvailabilityTab: "going-tab",
      noResponsePlayersList: [],
      // Enhanced Visual Indicators for mobile tabs
      canScrollLeft: false,
      canScrollRight: true,
      openStrengthTestModalValue: false,
      eyeballTeamSheetTab: "homeTeam-tab",
      allHomeWorkData: [],
      newHomeWorkData: {
        created_date: "",
        gameId: null,
        id: null,
        matchDate: null,
        opposition: null,
        title: "",
        information: "",
        player_id: null,
        videos: [],
      },
      gameResponceValueChange: "",
      uploadedDocuments: [],
      listOfSelectedplayerIds: [],
      gamePerformanceAnalysisData: [],
      // averageGamePerformanceAnalysisData is now a computed off
      // gamePerformanceAnalysisData; no need for a data field.
      loadingPerformanceData: false,
      fullSeasonCheckBoxData: false,
      attendanceSortDesc: true,
      bulkUpdating: false,
      teamTrainingStats: {
        averageAttendance: 0,
        averageScores: "",
        averageEffortScores: "",
      },
      // teamStats is a computed (see below) derived from pastGames — it is
      // deliberately NOT data. It used to be mutated by countGamesResults()
      // from three call sites, one of which never reset first, so changing the
      // date range stacked the new totals on top of the old ones.

      selectedChat: {
        text: "",
      },
      selectedAllPlayerToggleValue: false,
      trialistsData: [],
      allPlayerInATeamInjuryReports: [],
      allGameGoalScorersData: [],
      allTeamsGameResultsData: [],
      selectedTabGamesTraining: "teams-over-games-performance-tab",
      selectedTabTeamsOverview: "teams-over-view-tab",
      commentsData: [],
      togglePitchDetails: false,
      leagueTable: "",
      gameDeleteEditoccuranceValue: null,
      modalTypeNmae: "Edit",
      showTeamChange: false,
      recurringEvent: false,
      editMode: false,
      editGame: {
        address: "",
        away_team_goal_scorers: null,
        away_team_goals: "0",
        endTime: "",
        gameType: "",
        home_team_goal_scorers: null,
        home_team_goals: "0",
        id: "",
        kickOffTime: "",
        locationName: "",
        matchDate: "",
        meetTime: "",
        notes: "",
        opposition: "",
        pitchType: "",
        postCode: "",
        recurringEventType: null,
        result_added: "0",
        stripType: "",
        teamId: "",
        teamName: "",
        pitch_id: "",
        pitch_zone: null,
      },
      teamsAttendedGamesAndTrainingData: [],
      adminNavigationSelectedTeam: false,
      selectedGame: {},
      selectedGameAttendees: [],
      currentTeam: [],
      coachData: [],
      selectedUserValue: "",
      pitches: [],
      newGameData: {
        opposition: "",
        kickOffTime: "",
        matchDate: "",
        locationName: "",
        address: "",
        postCode: "",
        stripType: "",
        meetTime: "",
        endTime: "",
        notes: "",
        gameType: "Training",
        teamId: "",
        teamName: "",
        pitchType: "",
        recurringEventType: null,
        home_team_goals: 0,
        away_team_goals: 0,
        away_team_goal_scorers: null,
        home_team_goal_scorers: null,
        result_added: 0,
        pitch_id: "",
        pitch_zone: null,
        home_team: false,
        training_session_type: null,
      },
      selectedGameTypeOption: "",
      showTrainingContentPicker: false,
      sessionContent: { drills: [], programmes: [] },
      viewGameSessionContent: [],
      loadingViewGameContent: false,
      thisWeeksGames: [],
      thisWeeksTraining: [],
      pastGames: [],
      pastTraining: [],
      // When browsing a past season, default the range to that season's window
      // instead of the rolling "last month → +2 months" — but only if the
      // stored season dates are usable, else a null/"Invalid date" would send
      // null date filters to every games/training query.
      dateRange: (() => {
        const usable = (v) =>
          v &&
          String(v).trim().toLowerCase() !== "invalid date" &&
          !isNaN(new Date(v).getTime());
        const s = localStorage.getItem("currentPlayingseasonStartDate");
        const e = localStorage.getItem("currentPlayingseasonEndDate");
        const usePast =
          localStorage.getItem("selectedSeasonYear") && usable(s) && usable(e);
        return {
          startDate: usePast
            ? s
            : moment().subtract(1, "months").format("YYYY-MM-DD"),
          endDate: usePast
            ? e
            : moment().add(2, "months").format("YYYY-MM-DD"),
        };
      })(),
      updateValues: {},
      dateRangePickerLocaleData: {
        direction: "ltr",
        format: "dd/mm/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 1,
      },
      selectedTab: "games-tab",
      navCollapsed: false,
      clubTeams: [],
      selectedTeam: "",
      leagueTeams: [],
      loadingStuff: false,
      weekSelectedNumber: "",
      selectedWeekMonSunday: "",
      weeklyDate: "",
      userData: {
        name: "",
        userType: "",
      },
      chatComponentKey: 0,
      allGameAnalysisData: [],
      injuredPlayersList: [],
      selectedGameAnalysisData: {
        gameId: null,
        teamId: null,
        teamName: null,
        coachName: null,
        coachId: null,
        age_group: null,
        matchDate: null,
        opposition: null,
        kickOffTime: null,
        penetrationScore: 0,
        penetrationComments: "",
        supportScore: 0,
        supportComments: "",
        mobilityScore: 0,
        mobilityComments: "",
        creativityScore: 0,
        creativityComments: "",
        transitionToAttackScore: 0,
        transitionToAttackComments: "",
        pressureScore: 0,
        pressureComments: "",
        coverScore: 0,
        coverComments: "",
        balanceScore: 0,
        balanceComments: "",
        compactnessScore: 0,
        compactnessComments: "",
        transitionToDefendScore: 0,
        transitionToDefendComments: "",
        generalComments: "",
        trainingComments: "",
      },
      teamGameResultsData: [],
      teamGameResultSlectedData: {},
      teamGameResultNewData: {},
      selectTypeOfGameoptions: [
        { value: "Training", text: "Team Training" },
        { value: "Training:S&C", text: "S&C Session" },
        { value: "League game", text: "League game" },
        { value: "Cup game", text: "Cup game" },
        { value: "Friendly", text: "Friendly" },
      ],
      // Match Reports Data
      playerMatchReports: [],
      playersWithCompleteReports: [],
      playersWithIncompleteReports: [],
      playersWithMissingReports: [],
      isLoadingMatchReports: false,
      noResponselayersList: [],
      hideRemoveTeamFilterButton: true,
      allTeamDataBeforFilterApplied: [],
      filterdTeamsData: [],
      toggleFilters: false,
      selectedFilterData: null,
      gameEventSelected: null,
      teamWhoScored: null,
      teamChatMessages: null,
      showallTeams: false,
      userHasMoreThanOneAccount: null,
      allGamesAndTrainingData: [],
      selectedMatchReportData: {},
      teamAverageMatchReportScore: 0,
      openGPSUploadModal: false,
      gameTrainingData: {},
      allGPSdata: [],
      playerPlayMakerGpsData: [],
      under16: false,
      allGPSDataBySession: [],
      selectedGamesEvents: [],
      selectedGameFullPerformanceReportGPSdataForTeam: {},
      gPSSelectedSessionId: null,
      selectedGPSSession: null,
      teamVideos: [],
      eyeBallPlayerStats: [],
      eyeBallTeamsGames: [],
      eyeBallSelectedGameData: {},
      eyeballPlayerLinks: [],
      eyeballLinkSelections: {},
      showEyeballLinkingModal: false,
      isSyncingEyeballPlayers: false,
      isImportingEyeballData: false,
      eyeballImportAvailable: false,
      // Modal visibility properties for Vue 3 migration
      showAddEditGames: false,
      showEditGames: false,
      showViewGameDetails: false,
      showViewGameDeleteEditOptions: false,
      showAddNewGameresultModal: false,
      showMatchReportModal: false,
      showGameAnalysisModal: false,
      showAddHomeworkModal: false,
      showViewHomeworkModal: false,
      showEyeballMatchDataModal: false,
      hlsInstance: null,
      CASfixturesModal: false,
      CASfixturesData: [],
      // Bulk training session management
      bulkTrainingMode: false,
      selectedTrainingSessions: [],
      showBulkDeleteTrainingModal: false,
      showBulkEditTrainingModal: false,
      bulkEditTrainingData: {
        kickOffTime: "",
        endTime: "",
        locationName: "",
        address: "",
        postCode: "",
        notes: "",
        pitch_id: "",
      },
      isBulkDeleting: false,
      isBulkEditing: false,
    };
  },
  computed: {
    // Left drawer nav items (SectionNav). Mirrors the old horizontal tabs,
    // respecting the same role/age visibility rules. Icons = Material Symbols.
    teamNavItems() {
      const isStaff = this.userData && this.userData.userType !== "User";
      const leagueAges = ["2007", "2008", "2009", "2010", "2011", "2012"];
      const showLeague =
        this.selectedTeam &&
        (leagueAges.includes(this.selectedTeam.age_group) ||
          this.teamHasExternalLeague(this.selectedTeam));
      const items = [
        { key: "games-tab", label: "Games", icon: "sports_soccer" },
        { key: "training-tab", label: "Training", icon: "fitness_center" },
        { key: "full-team-tab", label: "Members", icon: "groups" },
        { key: "full-team-chat", label: "Post & Chat", icon: "forum" },
      ];
      if (showLeague)
        items.push({ key: "league-tab", label: "Competition", icon: "emoji_events" });
      // Tier gating: team performance analysis is Pro-only
      if (isStaff && this.hasFeature("performanceReviews"))
        items.push({ key: "team-performance-tab", label: "Performance", icon: "insights" });
      items.push({ key: "homework-tab", label: "Homework", icon: "menu_book" });
      items.push({ key: "team-documents-tab", label: "Documents", icon: "folder_open" });
      if (isStaff)
        items.push({ key: "team-attendance-tab", label: "Attendance", icon: "event_available" });
      // Tier gating: GPS tab only for tenants whose tier enables it
      if (this.hasFeature("gpsReports"))
        items.push({ key: "team-gps-tab", label: "GPS data", icon: "monitoring" });
      if (isStaff)
        items.push({ key: "squad-maturity-tab", label: "Maturity", icon: "trending_up" });
      return items;
    },
    // Per-metric averages derived from gamePerformanceAnalysisData. Was
    // an imperative method (makeAverageGamePerformanceAnalysis) that wrote
    // to a data field on every fetch; converting to a computed means the
    // numbers refresh automatically when gamePerformanceAnalysisData
    // changes and Vue caches the result between unrelated re-renders.
    averageGamePerformanceAnalysisData() {
      const data = this.gamePerformanceAnalysisData || [];
      const avg = (key) =>
        this.averageFromArrayOfNumbers(data.map((p) => p[key]));
      return {
        penetrationScoreTotal: avg("penetrationScore"),
        supportScoreTotal: avg("supportScore"),
        mobilityScoreTotal: avg("mobilityScore"),
        creativityScoreTotal: avg("creativityScore"),
        transitionToAttackScoreTotal: avg("transitionToAttackScore"),
        pressureScoreTotal: avg("pressureScore"),
        coverScoreTotal: avg("coverScore"),
        balanceScoreTotal: avg("balanceScore"),
        compactnessScoreTotal: avg("compactnessScore"),
        transitionToDefendScoreTotal: avg("transitionToDefendScore"),
      };
    },

    // True when the user has narrowed the performance view away from the
    // default season window (either via an explicit date range or by
    // unchecking Full Season). Drives the "no matches" empty-state copy.
    performanceFiltersActive() {
      const seasonStart =
        this.selectedTeam && this.selectedTeam.season_start_date;
      const seasonEnd = this.selectedTeam && this.selectedTeam.season_end_date;
      if (!seasonStart || !seasonEnd) return false;
      const startMatches =
        String(this.dateRange.startDate).slice(0, 10) ===
        String(seasonStart).slice(0, 10);
      const endMatches =
        String(this.dateRange.endDate).slice(0, 10) ===
        String(seasonEnd).slice(0, 10);
      return !(startMatches && endMatches);
    },

    // Pre-built set of gameIds that have an analysis attached. Avoids the
    // O(n*m) we'd hit if checkIfGameHasAnalysis re-iterated allGameAnalysisData
    // for every game card on every render.
    gameAnalysisIdSet() {
      const set = new Set();
      (this.allGameAnalysisData || []).forEach((g) => {
        if (g && g.gameId !== undefined) set.add(g.gameId);
      });
      return set;
    },
    /**
     * Season/date-range team record, derived from the games themselves.
     *
     * Only games with a result entered by a coach (result_added == 1) count —
     * an unplayed fixture must not read as a 0-0 draw with a clean sheet.
     *
     * home_team_goals is always the selected team's goals and away_team_goals
     * the opposition's, whatever the venue; games.home_team records venue only
     * and is unreliable (NULL/0 on most rows), so it must not drive results.
     */
    teamStats() {
      const played = (this.pastGames || []).filter(
        (g) => String(g.result_added) === "1",
      );

      return played.reduce(
        (acc, game) => {
          const scored = Number(game.home_team_goals) || 0;
          const conceded = Number(game.away_team_goals) || 0;

          if (scored > conceded) acc.wins += 1;
          else if (scored === conceded) acc.draws += 1;
          else acc.losses += 1;

          if (conceded === 0) acc.cleanSheets += 1;

          acc.goalsScored += scored;
          acc.goalsConceded += conceded;
          acc.gamesPlayed += 1;
          return acc;
        },
        {
          wins: 0,
          losses: 0,
          draws: 0,
          goalsScored: 0,
          goalsConceded: 0,
          cleanSheets: 0,
          gamesPlayed: 0,
        },
      );
    },

    goingList() {
      return this.selectedGameAttendees.filter((a) => Number(a.going) === 1);
    },
    notGoingList() {
      return this.selectedGameAttendees.filter((a) => Number(a.notGoing) === 1);
    },
    injuredList() {
      return this.selectedGameAttendees.filter((a) => Number(a.injured) === 1);
    },
    sortedAttendanceTeam() {
      const dir = this.attendanceSortDesc ? -1 : 1;
      return [...this.currentTeam].sort((a, b) => {
        return (
          (this.getPlayerAverageAttendance(a.id) -
            this.getPlayerAverageAttendance(b.id)) *
          dir
        );
      });
    },
    currentTeamSortedByMins() {
      return [...this.currentTeam].sort((a, b) => {
        return (b.totalMins || 0) - (a.totalMins || 0);
      });
    },

    // Members tab filters — applied to the team list before the existing
    // sort-by-mins. Position / age group / injury status are derived from
    // the data so dropdowns stay in sync with whatever is loaded.
    filteredCurrentTeam() {
      let list = [...(this.currentTeam || [])];
      if (this.filterMembersPosition) {
        list = list.filter((p) => p.position === this.filterMembersPosition);
      }
      if (this.filterMembersAgeGroup) {
        list = list.filter(
          (p) => String(p.age_group) === String(this.filterMembersAgeGroup),
        );
      }
      if (this.filterMembersInjury === "injured") {
        list = list.filter((p) => p.injury === true);
      } else if (this.filterMembersInjury === "fit") {
        list = list.filter((p) => p.injury !== true);
      }
      return list.sort((a, b) => (b.totalMins || 0) - (a.totalMins || 0));
    },

    membersPositionOptions() {
      const set = new Set();
      (this.currentTeam || []).forEach((p) => {
        if (p.position) set.add(p.position);
      });
      return [
        { value: "", text: "All positions" },
        ...Array.from(set)
          .sort()
          .map((p) => ({ value: p, text: p })),
      ];
    },

    membersAgeGroupOptions() {
      const set = new Set();
      (this.currentTeam || []).forEach((p) => {
        if (p.age_group) set.add(String(p.age_group));
      });
      return [
        { value: "", text: "All age groups" },
        ...Array.from(set)
          .sort()
          .map((g) => ({ value: g, text: g })),
      ];
    },

    membersInjuryOptions() {
      return [
        { value: "", text: "All statuses" },
        { value: "injured", text: "Injured only" },
        { value: "fit", text: "Fit only" },
      ];
    },
    googleMapsEmbedUrl() {
      try {
        if (!this.selectedGame) {
          return "";
        }
        // Build the query string from locationName, address, and postCode
        const location = [
          this.selectedGame.locationName,
          this.selectedGame.address,
          this.selectedGame.postCode,
        ]
          .filter(Boolean)
          .join(", ");
        const encodedLocation = encodeURIComponent(location);
        const apiKey = "AIzaSyB2NIWI3Tv9iDPrlnowr_0ZqZWoAQydKJU";
        return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodedLocation}&maptype=roadmap`;
      } catch (error) {
        console.error("Error in googleMapsEmbedUrl:", error);
        return "";
      }
    },
    // mix the getters into computed with object spread operator
    ...mapGetters(["getProfile", "getWeekNumber", "getCoachesUsersData"]),

    // Check for mixed content issues (HTTP page loading HTTPS resources)
    isMixedContentIssue() {
      return (
        window.location.protocol === "http:" &&
        this.eyeBallSelectedGameData.video?.thumbs?.startsWith("https:")
      );
    },
    showMatchReportsTab() {
      if (!this.selectedGame || !this.selectedGame.matchDate) return false;
      // Use dayjs for date comparison
      const matchDate = this.selectedGame.matchDate;
      let matchDateObj;
      if (typeof matchDate === "string" || typeof matchDate === "number") {
        matchDateObj = this.$dayjs ? this.$dayjs(matchDate) : dayjs(matchDate);
      } else {
        matchDateObj = matchDate;
      }
      const now = this.$dayjs ? this.$dayjs() : dayjs();
      // Show tab if today is the match date or after
      return now.isSameOrAfter(matchDateObj, "day");
    },
  },
  beforeUnmount() {
    // Release the Firebase onSnapshot subscription set up in
    // deleteFireBaseDocs so it doesn't keep firing after navigation.
    if (typeof this.chatListener === "function") {
      try {
        this.chatListener();
      } catch (e) {
        /* noop */
      }
      this.chatListener = null;
    }
  },
  async created() {
    //this.$route.query.teamData !== undefined
    this.userHasMoreThanOneAccount = this.checkIfUserHasMoreThanOneAccount();
    //console.log(this.$refs["bottom"]);
    //const bottom = this.$refs["bottom"].value = null;
    // const now = moment().format("MM-DD-YYYY");
    this.weekSelectedNumber = moment().isoWeek();
    this.setMonToSundayWeekDates();
    const clientId = JSON.parse(localStorage.getItem("the_w_selectedClientId"));
    this.selectedUserValue = clientId;

    this.loadingStuff = true;
    const response = await this.$store.dispatch(CHECK_PROFILE_HAS_DATA);

    if (response === true) {
      this.setUser();
      this.loadExternalLeagueMappings();
      if (this.$route.query.teamData !== undefined) {
        this.getTeamsByUserId();
        this.getAllPitchesForClub();
      }

      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach" ||
        this.userHasMoreThanOneAccount !== null
      ) {
        this.showallTeams = true;
      }

      if (this.userHasMoreThanOneAccount !== null) {
        this.getTeamsDataForMultiAccounts();
        this.getAllPitchesForClub();
      } else {
        this.getTeamsByUserId();
        this.getAllPitchesForClub();
      }

      this.loadingStuff = false;
    } else {
      this.getUserById(clientId).then((response) => {
        if (response === true) {
          if (this.userHasMoreThanOneAccount !== null) {
            this.getTeamsDataForMultiAccounts();
            this.getAllPitchesForClub();
          } else {
            this.getTeamsByUserId();
            this.getAllPitchesForClub();
          }

          if (
            this.userData.userType === "Admin" ||
            this.userData.userType === "Coach" ||
            this.userHasMoreThanOneAccount !== null
          ) {
            this.showallTeams = true;
          }

          if (
            this.userData.userType === "Admin" ||
            this.userData.userType === "Coach"
          ) {
            this.selectedUserValue = this.$route.query.trainingPlanUserId;
          } else {
            this.selectedUserValue = clientId;
          }
        }
      });
      this.loadingStuff = false;
    }
    const clubIdString = this.userData.clubId.toString();
    this.teamChatMessages = query(
      collection(db, "team_chat_messages"),
      where("clubId", "==", clubIdString),
    );
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  methods: {
    // Tier gating (config/tiers.json)
    hasFeature(feature) {
      return isFeatureEnabled(feature);
    },
    // Grassroots UI simplification: hide Pro coaching workflows that are
    // not a distinct feature flag (game analysis / per-game match reports)
    isGrassrootsTier() {
      return isGrassroots();
    },
    checkIfPlayersAttendance(playerId) {
      if (this.selectedGameAttendees.length === 0) {
        return "noResponse";
      }

      let response = "noResponse";

      this.selectedGameAttendees.some((attendee) => {
        if (attendee.user_id === playerId) {
          if (attendee.going === 1) {
            response = "going";
          } else if (attendee.injured === 1) {
            response = "injured";
          } else {
            response = "noResponse";
          }
        }
      });

      return response;
    },

    getAttendanceStatusClass(playerId) {
      const status = this.checkIfPlayersAttendance(playerId);
      return status === "noResponse" ? "no-response-player" : "";
    },

    getAttendanceIconClass(playerId) {
      const status = this.checkIfPlayersAttendance(playerId);
      if (status === "going") return "going";
      return "not-going";
    },

    getAttendanceIcon(playerId) {
      const status = this.checkIfPlayersAttendance(playerId);
      if (status === "going") return "bi bi-hand-thumbs-up";
      if (status === "injured") return "bi bi-exclamation-circle";
      return "bi bi-hand-thumbs-down";
    },

    injuredPlayers() {
      this.injuredPlayersList = this.selectedGameAttendees.filter(
        (player) => player.injured === 1,
      );
    },
    noResponsePlayers() {
      // "No response" means the player has not answered — NOT merely that no
      // attendance row exists.
      //
      // A row is created with going/notGoing/injured all 0 and noResponse = 1
      // when attendance is initialised without an answer. This used to exclude
      // those players from the list (they "have a row"), while the Going /
      // Not going / Injured tabs each require their own flag to be 1 — so the
      // player matched no tab at all and disappeared from the squad entirely.
      // PTFC's U14s hit this for the Morton fixture: a 20-player roster, 19
      // attendee rows, and two players invisible in every tab.
      const hasAnswered = (playerId) =>
        this.selectedGameAttendees.some(
          (attendee) =>
            String(attendee.user_id) === String(playerId) &&
            (Number(attendee.going) === 1 ||
              Number(attendee.notGoing) === 1 ||
              Number(attendee.injured) === 1),
        );

      this.noResponsePlayersList = this.currentTeam.filter(
        (player) => !hasAnswered(player.id),
      );
    },
    async createNewGameFromCASdata() {
      const data = {
        action: "createNewGameFromCASdata",
        data: this.CASfixturesData,
      };
      const response = await GadyflLeaguetable.find(data);

      if (response && response.status === 200) {
        this.loadingStuff = true;
        await this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.loadingStuff = false;
        // Close the modal so users don't see the stale "Fixtures loading…"
        // copy after the import has actually completed.
        this.CASfixturesModal = false;
        this.$toast.info("CAS fixtures imported.", {
          title: "Imported",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      } else {
        console.error("Failed to populate CAS fixtures");
      }
    },
    // Populate full address and postcode for each fixture using fuzzy matching
    populateFullAddressData() {
      // Helper to normalize team names for fuzzy matching
      const normalize = (str) =>
        str
          .toLowerCase()
          .replace(/fc|f\.c\.|under\s*\d+|u\d+|\./g, "")
          .replace(/\s+/g, " ")
          .trim();

      const selectedTeamNorm = normalize(this.selectedTeam.teamName);

      return this.CASfixturesData.map((fixture) => {
        const homeNorm = normalize(fixture.home_team);
        const awayNorm = normalize(fixture.away_team);

        let address = "";
        let postcode = "";
        let pitchId = "";
        let pitchType = "";
        let selectedTeam = this.selectedTeam.teamName;
        let teamId = this.selectedTeam.id;
        let teamName = this.selectedTeam.teamName;
        let season_start_date = this.selectedTeam.season_start_date;
        let season_end_date = this.selectedTeam.season_end_date;

        // If home team is similar to selected team, clear address/postcode
        if (
          homeNorm.includes(selectedTeamNorm) ||
          selectedTeamNorm.includes(homeNorm)
        ) {
          address = this.pitches[0]?.address || "";
          postcode = this.pitches[0]?.postCode || "";
          pitchId = this.pitches[0]?.id || "";
          pitchType = this.pitches[0]?.pitchType || "";
        } else {
          let matchedTeam;
          // Try to find a matching team for away team
          matchedTeam = this.leagueTeams.find((team) => {
            const teamNorm = normalize(team.teamName);
            return (
              teamNorm &&
              (teamNorm.includes(awayNorm) || awayNorm.includes(teamNorm))
            );
          });

          // Try to find a matching team for home team
          matchedTeam = this.leagueTeams.find((team) => {
            const teamNorm = normalize(team.teamName);
            return (
              teamNorm &&
              (teamNorm.includes(homeNorm) || homeNorm.includes(teamNorm))
            );
          });

          if (matchedTeam) {
            address = matchedTeam.address || "";
            postcode = matchedTeam.postCode || "";
            pitchId = matchedTeam.id || "";
            pitchType = matchedTeam.pitchType || "";
          }
        }

        // Return a new fixture object with address/postcode
        return {
          ...fixture,
          address,
          postcode,
          pitchId,
          pitchType,
          selectedTeam,
          teamId,
          teamName,
          season_start_date,
          season_end_date,
        };
      });
    },
    async populateCASfixtures() {
      const data = {
        action: "populateCASfixtures",
        data: this.CASfixturesData,
      };
      const response = await GadyflLeaguetable.find(data);

      if (response && response.status === 200) {
        console.log("CAS fixtures populated successfully");
      } else {
        console.error("Failed to populate CAS fixtures");
      }
    },
    filterCASFixturesByTeam(fixtures, teamName) {
      // Normalize the team name for comparison (remove "FC", "Under", "U", etc.)
      const normalize = (str) =>
        str
          .toLowerCase()
          .replace(/fc|under\s*\d+|u\d+/g, "")
          .replace(/\s+/g, " ")
          .trim();

      const normalizedTeamName = normalize(teamName);
      console.log("Normalized Team Name:", normalizedTeamName);

      return fixtures.filter((fixture) => {
        const home = normalize(fixture.home_team);
        const away = normalize(fixture.away_team);
        // Check if normalized team name is included in either home or away team
        return (
          home.includes(normalizedTeamName) || away.includes(normalizedTeamName)
        );
      });
    },
    // Fetch CAS fixtures from the API
    async getCASFixtures(pageNumber) {
      let competitionIds = [];

      const competition = [
        { id: "35298345", name: "2007", level: "Elite" },
        { id: "35298093", name: "2009", level: "Elite" },
        { id: "148167", name: "2015", level: "Elite" },
        { id: "148166", name: "2014", level: "Elite" },
        { id: "148165", name: "2013", level: "Elite" },
        { id: "148327", name: "2013", level: "Elite" },
        { id: "148164", name: "2012", level: "Elite" },
        { id: "148163", name: "2011", level: "Elite" },
        { id: "38509171", name: "2015", level: "Elite" },
        { id: "38509171", name: "2015", level: "Performance" },

        { id: "35294216", name: "2015", level: "Performance" },
        { id: "148160", name: "2014", level: "Performance" },
        { id: "148159", name: "2013", level: "Performance" },
        { id: "148229", name: "2012", level: "Performance" },
        { id: "148328", name: "2012", level: "Performance" },
        { id: "148329", name: "2011", level: "Performance" },
        { id: "35296412", name: "2011", level: "Performance" },

        { id: "148327", name: "2013", level: "Performance" },
        { id: "35285402", name: "2009", level: "Performance" },
        { id: "35296748", name: "2007", level: "Performance" },
        { id: "35370506", name: "2007", level: "Performance" },
        { id: "35371598", name: "2009", level: "Performance" },
      ];

      competitionIds = competition
        .filter(
          (comp) =>
            comp.name === this.selectedTeam.age_group &&
            comp.level === this.setTeamAcademyLevel(),
        )
        .map((comp) => comp.id);

      try {
        const data = {
          action: "getCASFixtures",
          format: "json",
          competition: competitionIds,
          page: pageNumber || 1,
        };

        const response = await GadyflLeaguetable.find(data);

        if (response && response.status === 200) {
          this.CASfixturesData = this.filterCASFixturesByTeam(
            response.data.fixtures,
            this.selectedTeam.teamName,
          );
          this.CASfixturesData = this.populateFullAddressData();
          this.populateCASfixtures();
        } else {
          console.error("Failed to fetch CAS fixtures");
        }
      } catch (error) {
        console.error("Error fetching CAS fixtures:", error);
      }
    },
    // Enhanced Visual Indicators methods
    getCurrentTabIndex() {
      // Returns the index (1-based) of the currently selected tab
      const tabKeys = this.getTabKeys();
      const idx = tabKeys.indexOf(this.selectedTab);
      return idx >= 0 ? idx + 1 : 1;
    },
    getTotalTabsCount() {
      // Returns the total number of tabs
      return this.getTabKeys().length;
    },
    getTabKeys() {
      // Returns an array of tab keys in the order they appear
      const keys = [
        "games-tab",
        "training-tab",
        "full-team-tab",
        "full-team-chat",
        "league-tab",
        "team-performance-tab",
        "homework-tab",
        "team-documents-tab",
        "team-attendance-tab",
        "team-gps-tab",
      ];
      // Filter out tabs based on v-if conditions
      return keys.filter((key) => {
        if (key === "league-tab") {
          return (
            ["2007", "2008", "2009", "2010", "2011", "2012"].includes(
              this.selectedTeam.age_group,
            ) || this.teamHasExternalLeague(this.selectedTeam)
          );
        }
        if (key === "team-performance-tab" || key === "team-attendance-tab") {
          return this.userData.userType !== "User";
        }
        return true;
      });
    },
    scrollTabsLeft() {
      console.log("Scrolling left");
      const container = this.$refs.tabsContainer;
      if (container) {
        container.scrollLeft -= 100;
        this.handleTabScroll();
      }
    },
    scrollTabsRight() {
      const container = this.$refs.tabsContainer;
      if (container) {
        container.scrollLeft += 100;
        this.handleTabScroll();
      }
    },
    handleTabScroll() {
      const container = this.$refs.tabsContainer;
      if (container) {
        this.canScrollLeft = container.scrollLeft > 0;
        this.canScrollRight =
          container.scrollLeft < container.scrollWidth - container.clientWidth;
      }
    },
    checkCoachPerformanceReportIsNotEmpty(session) {
      const requiredKeys = [
        "technically_improvements",
        "technically_positives",
        "tactility_improvements",
        "tactility_positives",
        "mentally_improvements",
        "mentally_positives",
        "physicality_improvements",
        "physicality_positives",
      ];
      return requiredKeys.some(
        (key) => session[key] !== null && session[key] !== "",
      );
    },
    async fetchPlayerMatchReports() {
      if (!this.selectedGame || !this.selectedGame.id) {
        console.warn("No selected game found for match reports");
        return;
      }

      this.isLoadingMatchReports = true;

      try {
        // Reset arrays
        this.playersWithCompleteReports = [];
        this.playersWithIncompleteReports = [];
        this.playersWithMissingReports = [];

        // Load match report data first
        await this.getMatchReportForSelectedGame(this.selectedGame);

        // Process each attendee to check their report status
        for (const attendee of this.selectedGameAttendees) {
          try {
            // Only check players who are going to the game
            if (attendee.going === 1) {
              // Find the match report for this specific player
              const playerReport =
                this.selectedMatchReportData.playerMatchReports.find(
                  (report) => report.player_id === attendee.user_id,
                );

              const playerData = {
                id: attendee.user_id,
                name: attendee.name,
                reportLength: playerReport ? 1 : 0,
              };

              if (playerReport) {
                console.log("Player Report Found:", playerReport);
                // Check if the report is complete using your existing function
                const isReportComplete =
                  this.checkCoachPerformanceReportIsNotEmpty(playerReport);

                console.log(
                  `Player: ${attendee.name}, Report Length: ${playerData.reportLength}, Is Complete: ${isReportComplete}`,
                );
                console.log("Player Report Data:", playerReport);

                if (isReportComplete) {
                  this.playersWithCompleteReports.push(playerData);
                } else {
                  this.playersWithIncompleteReports.push(playerData);
                }
              } else {
                // No report exists for this player
                this.playersWithMissingReports.push(playerData);
              }
            }
          } catch (error) {
            console.error(
              `Error checking report for player ${attendee.name}:`,
              error,
            );
            // Treat as missing report on error
            this.playersWithMissingReports.push({
              id: attendee.user_id,
              name: attendee.name,
              reportLength: 0,
            });
          }
        }

        console.log("Match Reports Summary:", {
          complete: this.playersWithCompleteReports.length,
          incomplete: this.playersWithIncompleteReports.length,
          missing: this.playersWithMissingReports.length,
        });
      } catch (error) {
        console.error("Error fetching player match reports:", error);
        this.$toast.error("Failed to load match reports");
      } finally {
        this.isLoadingMatchReports = false;
      }
    },
    checkEyeBallMatchData(game) {
      if (this.eyeBallTeamsGames !== undefined) {
        return this.eyeBallTeamsGames.find(
          (item) => item.date === game.matchDate,
        );
      } else {
        return undefined;
      }
    },
    async openEyeballMatchDataModal(game) {
      const selectedEyeBallGame = this.eyeBallTeamsGames.find(
        (item) => item.date === game.matchDate,
      );

      if (!selectedEyeBallGame) {
        console.error("Selected EyeBall game not found");
      } else {
        console.log("Selected EyeBall game found:", selectedEyeBallGame);

        const response = await this.getEyeBallGameById(selectedEyeBallGame.id);

        if (response) {
          this.eyeBallSelectedGameData = response;
          this.showEyeballMatchDataModal = true;

          // Initialize HLS player after modal is shown
          this.$nextTick(() => {
            this.initializeHLSPlayer();
          });
        }
      }
    },

    initializeHLSPlayer() {
      const video = this.$refs.hlsVideoPlayer;
      const videoUrl = this.eyeBallSelectedGameData.video?.url;
      const posterUrl = this.eyeBallSelectedGameData.video?.poster;
      const thumbsUrl = this.eyeBallSelectedGameData.video?.thumbs;

      if (!video || !videoUrl) {
        console.error("Video element or URL not found");
        return;
      }

      // Set poster image if available
      if (posterUrl && !video.poster) {
        video.poster = posterUrl;
      }

      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoUrl);
        hls.attachMedia(video);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("HLS manifest loaded, starting playback");

          // Add thumbnail track if available and not a mixed content issue
          if (
            thumbsUrl &&
            !video.querySelector('track[kind="thumbnails"]') &&
            !this.isMixedContentIssue
          ) {
            const track = document.createElement("track");
            track.kind = "thumbnails";
            track.src = thumbsUrl;
            track.default = true;
            video.appendChild(track);
          }

          video.play().catch((e) => {
            console.log("Auto-play prevented:", e);
          });
        });

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error("HLS error:", data);
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.log(
                  "Fatal network error encountered, trying to recover",
                );
                hls.startLoad();
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log("Fatal media error encountered, trying to recover");
                hls.recoverMediaError();
                break;
              default:
                console.log("Fatal error, cannot recover");
                hls.destroy();
                break;
            }
          }
        });

        // Store HLS instance for cleanup
        this.hlsInstance = hls;
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        // Native HLS support (Safari)
        video.src = videoUrl;

        // Add thumbnail track for Safari if available and not a mixed content issue
        if (
          thumbsUrl &&
          !video.querySelector('track[kind="thumbnails"]') &&
          !this.isMixedContentIssue
        ) {
          const track = document.createElement("track");
          track.kind = "thumbnails";
          track.src = thumbsUrl;
          track.default = true;
          video.appendChild(track);
        }

        video.addEventListener("loadedmetadata", () => {
          video.play().catch((e) => {
            console.log("Auto-play prevented:", e);
          });
        });
      } else {
        console.error("HLS is not supported in this browser");
      }
    },

    destroyHLSPlayer() {
      if (this.hlsInstance) {
        this.hlsInstance.destroy();
        this.hlsInstance = null;
      }
    },

    formatMinutesFromMilliseconds(milliseconds) {
      if (!milliseconds || milliseconds === 0) return "0:00";

      const totalMinutes = Math.floor(milliseconds / 60000);
      const seconds = Math.floor((milliseconds % 60000) / 1000);

      return `${totalMinutes}:${seconds.toString().padStart(2, "0")}`;
    },

    onEyeballModalHidden() {
      this.destroyHLSPlayer();
    },

    // Eyeball Player Linking Methods
    getEyeballTeamId() {
      if (this.userData.clubId === "ptfc-2085XH") return 8733;
      if (this.userData.clubId === "stjfc-2085XH") return 61829;
      return null;
    },

    async openEyeballLinkingModal() {
      this.showEyeballLinkingModal = true;
      this.isSyncingEyeballPlayers = true;
      this.eyeballLinkSelections = {};

      try {
        const eyeballTeamId = this.getEyeballTeamId();
        const ageGroup = this.selectedTeam.age_group;

        // Get match dates from this team's past games to scope the sync
        const matchDates = this.pastGames
          .map((game) => game.matchDate)
          .filter(Boolean);

        // Sync players from Eyeball games matching this team's game dates
        await EyeBall.find({
          action: "syncEyeballPlayers",
          clubId: this.userData.clubId,
          eyeballTeamId: eyeballTeamId,
          ageGroup: ageGroup,
          matchDates: matchDates,
        });

        // Fetch the linked/unlinked player list filtered by age group
        const response = await EyeBall.find({
          action: "getEyeballPlayers",
          clubId: this.userData.clubId,
          ageGroup: ageGroup,
        });

        if (response && response.data && response.data.success) {
          this.eyeballPlayerLinks = response.data.players;
        }
      } catch (error) {
        console.error("Error loading Eyeball players:", error);
        this.$toast.error("Failed to load Eyeball players");
      } finally {
        this.isSyncingEyeballPlayers = false;
      }
    },

    async linkEyeballPlayerAction(eyeballPlayerId) {
      const playerId = this.eyeballLinkSelections[eyeballPlayerId];
      if (!playerId) return;

      try {
        await EyeBall.find({
          action: "linkEyeballPlayer",
          clubId: this.userData.clubId,
          eyeballPlayerId: eyeballPlayerId,
          player_id: playerId,
        });

        // Refresh the list filtered by current team's age group
        const response = await EyeBall.find({
          action: "getEyeballPlayers",
          clubId: this.userData.clubId,
          ageGroup: this.selectedTeam.age_group,
        });

        if (response && response.data && response.data.success) {
          this.eyeballPlayerLinks = response.data.players;
        }

        this.$toast.success("Player linked successfully");
      } catch (error) {
        console.error("Error linking Eyeball player:", error);
        this.$toast.error("Failed to link player");
      }
    },

    async unlinkEyeballPlayer(eyeballPlayerId) {
      try {
        await EyeBall.find({
          action: "linkEyeballPlayer",
          clubId: this.userData.clubId,
          eyeballPlayerId: eyeballPlayerId,
          player_id: 0,
        });

        // Refresh the list filtered by current team's age group
        const response = await EyeBall.find({
          action: "getEyeballPlayers",
          clubId: this.userData.clubId,
          ageGroup: this.selectedTeam.age_group,
        });

        if (response && response.data && response.data.success) {
          this.eyeballPlayerLinks = response.data.players;
        }

        this.$toast.success("Player unlinked");
      } catch (error) {
        console.error("Error unlinking Eyeball player:", error);
        this.$toast.error("Failed to unlink player");
      }
    },

    async importEyeballDataToMatchReport() {
      this.isImportingEyeballData = true;

      try {
        const response = await EyeBall.find({
          action: "getEyeballDataForMatchReport",
          matchDate: this.selectedMatchReportData.matchDate,
          clubId: this.userData.clubId,
        });

        if (!response || !response.data || !response.data.success) {
          this.$toast.error(
            response?.data?.message || "Failed to fetch Eyeball data",
          );
          return;
        }

        const eyeballData = response.data.playerData || {};
        let importedCount = 0;

        // Build a new array to ensure Vue reactivity picks up changes
        const updatedReports =
          this.selectedMatchReportData.playerMatchReports.map((report) => {
            const playerId = String(report.player_id);
            const data = eyeballData[playerId];

            if (!data) return report;

            const updated = { ...report };

            // Only pre-fill if current value is default/empty
            if (
              !updated.session_mins ||
              updated.session_mins === 0 ||
              updated.session_mins === "0"
            ) {
              updated.session_mins = data.minutes;
            }
            if (
              !updated.goals ||
              updated.goals === 0 ||
              updated.goals === "0"
            ) {
              updated.goals = data.goals;
            }
            if (
              !updated.positions_played ||
              updated.positions_played.length === 0 ||
              (updated.positions_played.length === 1 &&
                updated.positions_played[0] === "")
            ) {
              if (data.position && data.position !== "") {
                updated.positions_played = [data.position];
              }
            }

            importedCount++;
            return updated;
          });

        // Replace the entire object to trigger Vue reactivity
        this.selectedMatchReportData = {
          ...this.selectedMatchReportData,
          playerMatchReports: updatedReports,
        };

        const unlinkedCount = response.data.unlinkedCount || 0;
        this.$toast.success(
          `Imported Eyeball data for ${importedCount} player${importedCount !== 1 ? "s" : ""}.` +
            (unlinkedCount > 0
              ? ` ${unlinkedCount} player${unlinkedCount !== 1 ? "s" : ""} unlinked.`
              : ""),
        );

        // Fire-and-forget: persist Eyeball minutes to player_stats as source-of-truth
        EyeBall.find({
          action: "persistEyeballMinutes",
          matchDate: this.selectedMatchReportData.matchDate,
          clubId: this.userData.clubId,
          gameId: this.selectedMatchReportData.fullGameData?.id || null,
          teamId: this.selectedMatchReportData.fullGameData?.teamId || null,
        }).catch((err) => console.error("persistEyeballMinutes failed:", err));
      } catch (error) {
        console.error("Error importing Eyeball data:", error);
        this.$toast.error("Failed to import Eyeball data");
      } finally {
        this.isImportingEyeballData = false;
      }
    },

    /**
     * Fixtures may be dated in the past — teams routinely play a match and only
     * add it afterwards, and before this they simply could not.
     *
     * The floor is the start of the current season rather than "today":
     * everything the app shows is scoped to the season window, so a fixture
     * dated before it saves fine and then appears nowhere, which reads as data
     * loss. Beyond that the picker is open, and addEditProgrammeSubmit asks for
     * confirmation when the chosen date is in the past.
     */
    disablePastDates(date) {
      const seasonStart = localStorage.getItem("currentPlayingseasonStartDate");
      if (!seasonStart) return false;
      const floor = new Date(seasonStart);
      if (isNaN(floor.getTime())) return false;
      floor.setHours(0, 0, 0, 0);
      return date < floor;
    },

    /** True when this date is before today (time-of-day ignored). */
    isDateInThePast(value) {
      if (!value) return false;
      const d = new Date(value);
      if (isNaN(d.getTime())) return false;
      d.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return d < today;
    },

    /**
     * An existing fixture for the same team, date and opponent.
     *
     * Back-filling a match the club already has — or that the league feed has
     * already imported — creates a second row for one game, which doubles the
     * points and goals on Teams -> Performance -> Games and splits attendance
     * and match reports across two fixtures.
     */
    findDuplicateFixture(gameData) {
      // pastGames / thisWeeksGames are the split the Games tab already keeps
      // (see the isPast/isUpcoming filters); check both so a back-filled match
      // is compared against everything currently loaded for the team.
      const list = [...(this.pastGames || []), ...(this.thisWeeksGames || [])];
      const day = this.formatMatchDate(gameData.matchDate);
      const opp = String(gameData.opposition || "").trim().toLowerCase();
      return list.find((g) => {
        if (!g || g.gameType === "Training") return false;
        if (this.formatMatchDate(g.matchDate) !== day) return false;
        const existing = String(g.opposition || "").trim().toLowerCase();
        return existing !== "" && opp !== "" && existing === opp;
      });
    },
    async getEyeBallTeamsGames() {
      let teamIdValue = null;

      if (this.userData.clubId === "ptfc-2085XH") {
        teamIdValue = 8733;
      }

      if (this.userData.clubId === "stjfc-2085XH") {
        teamIdValue = 61829;
      }

      const data = {
        action: "getEyeBallTeamsGames",
        teamId: teamIdValue,
      };

      const response = await EyeBall.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        console.log("EyeBall teams games data:", response.data.games);
        this.eyeBallTeamsGames = response.data.games;
      }
    },
    async getEyeBallGameById(gameId) {
      const data = {
        action: "getEyeBallGameById",
        gameId: gameId,
      };

      const response = await EyeBall.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        console.log("EyeBall game data:", response.data);
        this.eyeBallSelectedGameData = response.data;
        return response.data;
      }
    },
    // A team's age_group is a birth year; Eyeball wants a "U<age>" label where
    // <age> is the age reached in the season's start year (2013 → U13 for
    // 2026/27). Derived rather than hard-coded so it covers every academy year
    // without gaps and stays correct each season.
    eyeballAgeGroup(ageGroup) {
      const birthYear = parseInt(ageGroup, 10);
      if (!birthYear || birthYear < 2000 || birthYear > 2025) return null;
      const seasonStart = localStorage.getItem("currentPlayingseasonStartDate");
      let refYear;
      if (seasonStart) {
        refYear = new Date(seasonStart).getFullYear();
      } else {
        const now = new Date();
        // UK season runs ~Aug–May: Jul onward belongs to the year just starting.
        refYear = now.getMonth() >= 6 ? now.getFullYear() : now.getFullYear() - 1;
      }
      const uAge = refYear - birthYear;
      if (uAge < 6 || uAge > 23) return null;
      return `U${uAge}`;
    },
    async getEyeBallPlayerStatsByTeam(ageGroup) {
      const teamAgeGroup = this.eyeballAgeGroup(ageGroup);

      // Age group doesn't resolve to an Eyeball group — skip the request rather
      // than sending an undefined teamAgeGroup (which 400s).
      if (!teamAgeGroup) {
        this.eyeBallPlayerStats = [];
        return;
      }

      const data = {
        action: "getEyeBallPlayerStatsByTeam",
        teamAgeGroup: teamAgeGroup,
      };

      const response = await EyeBall.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        if (response.data._embedded !== undefined) {
          console.log(
            "EyeBall player stats data:",
            response.data._embedded.items,
          );
          this.eyeBallPlayerStats = response.data._embedded.items;
        }
      }
    },
    checkMatchReport(gameId, userId, reportType) {
      if (!Array.isArray(this.teamsAttendedGamesAndTrainingData)) return 0;
      const record = this.teamsAttendedGamesAndTrainingData.find(
        (r) => r.user_id == userId && r.gameId && r.gameId == gameId,
      );
      if (!record) return 0;
      if (reportType === "gamePerformanceReportData")
        return Number(record.hasPlayerReport) || 0;
      if (reportType === "gamePerformanceCoachReportData")
        return Number(record.hasCoachReport) || 0;
      return 0;
    },
    uploadTeamPhysicalPerformanceModal() {},
    forceRerender() {
      this.chatComponentKey += 1;
    },
    getNewDataFromCollection() {
      this.forceRerender();
    },
    getChatGroupInfo(data) {
      if (data.chatGroup.length > 0) {
        const q = query(
          data.collection,
          where("chatId", "==", data.chatGroup[0].id.toString()),
          where("clubId", "==", this.userData.clubId.toString()),
          orderBy("createdDate", "asc"),
          limit(100),
        );

        this.chatListener = onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let chatMessage = doc.data();

            if (chatMessage.readById !== undefined) {
              let readMessage = chatMessage.readById.includes(
                this.userData.id.toString(),
              );

              const chatIdElement = document.getElementById(chatMessage.chatId);
              if (!chatIdElement) {
                console.warn(
                  `Chat element with ID ${chatMessage.chatId} not found`,
                );
                return;
              }

              const seconddiv = chatIdElement.querySelector(
                ".number-of-messages",
              );
              if (!seconddiv) {
                console.warn(
                  `Number of messages element not found for chat ${chatMessage.chatId}`,
                );
                return;
              }

              seconddiv.innerHTML === "0";

              if (readMessage !== true) {
                if (seconddiv.innerHTML === "0") {
                  seconddiv.innerHTML = 1;
                } else {
                  seconddiv.innerHTML = Number(seconddiv.innerHTML) + 1;
                }

                const chatElementForHidden = document.getElementById(
                  chatMessage.chatId,
                );
                if (chatElementForHidden) {
                  chatElementForHidden
                    .querySelectorAll(".hidden")
                    .forEach(function (el) {
                      el.classList.remove("hidden");
                    });
                }
              }

              if (readMessage === true && seconddiv.innerHTML === "0") {
                const chatElementForMessages = document.getElementById(
                  chatMessage.chatId,
                );
                if (chatElementForMessages) {
                  chatElementForMessages
                    .querySelectorAll(".number-of-messages")
                    .forEach(function (el) {
                      el.classList.add("hidden");
                    });
                }
              }
            }
          });
        });
      }
    },
    findMissingObjects(array1, array2, comparisonKey = "id") {
      // Add null safety checks
      if (!array1 || !array2) return [];

      return array1.filter(
        (obj1) =>
          obj1 &&
          !array2.some(
            (obj2) => obj2 && obj2[comparisonKey] === obj1[comparisonKey],
          ),
      );
    },
    getPlayersNameFromId(id) {
      const player = this.currentTeam.find((player) => player.id === id);
      return player ? player.name : null; // Return the name if found, otherwise return null
    },
    populateSeasonStrainingAndGamesstatsChartPieDataPlayMakerSetsData(
      data,
      dataSetName,
    ) {
      let labelsData = [];
      let datasetsData = [];

      if (dataSetName === "Left and Right Touches") {
        labelsData = ["Left", "Right"];
        datasetsData = [data.left_leg_touches, data.right_leg_touches];
      }

      if (datasetsData.length > 0) {
        return {
          labels: labelsData,
          datasets: [
            {
              backgroundColor: [
                "#5db0f7",
                "#5df7b8",
                "#00D8FF",
                "#DD1B16",
                "#41b883",
                "#16dddb",
                "#dd8b16",
                "#cddd16",
              ],
              data: datasetsData,
            },
          ],
        };
      } else {
        return {};
      }
    },
    populateFullSeasonStrainingAndGamesstatsChartDataSetsData(data, labelName) {
      return {
        labels: [labelName],
        datasets: [
          {
            label: labelName,
            backgroundColor: "#ffde00",
            data: [data],
          },
        ],
      };
    },
    gpsSelectedData() {
      const game = this.selectedGPSSession;
      if (!game) {
        this.gPSSelectedSessionId = null;
        return;
      }

      const dataType = this.under16 ? "playerPlayMakerGpsData" : "allGPSdata";
      this.gPSSelectedSessionId = game.id;

      const gpsData = JSON.parse(JSON.stringify(this[dataType]));

      const filteredGPSData = gpsData.filter(
        (gpsData) => gpsData.gameId === game.id,
      );

      this.selectedGameFullPerformanceReportGPSdataForTeam = {
        gpsData: filteredGPSData,
        sessionName: `${game.gameType} - ${this.formatDate(game.matchDate)} | ${
          game.teamName
        }`,
        opposition: game.opposition,
        sortedData: {
          accelerationsTotalEfforts: [...filteredGPSData]
            .map(
              ({
                accelerations_total_efforts,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                accelerations_total_efforts,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort(
              (a, b) =>
                b.accelerations_total_efforts - a.accelerations_total_efforts,
            ),

          decelerationsTotalEfforts: [...filteredGPSData]
            .map(
              ({
                decelerations_total_efforts,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                decelerations_total_efforts,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort(
              (a, b) =>
                b.decelerations_total_efforts - a.decelerations_total_efforts,
            ),

          maxVelMax: [...filteredGPSData]
            .map(
              ({
                max_vel_max,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                max_vel_max,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort((a, b) => b.max_vel_max - a.max_vel_max),

          maximumVelocity: [...filteredGPSData]
            .map(
              ({
                maximum_velocity,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                maximum_velocity,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort((a, b) => b.maximum_velocity - a.maximum_velocity),

          meterageperminute: [...filteredGPSData]
            .map(
              ({
                meterage_per_minute,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                meterage_per_minute,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort((a, b) => b.meterage_per_minute - a.meterage_per_minute),

          sessionDistance: [...filteredGPSData]
            .map(
              ({
                session_distance,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                session_distance,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort((a, b) => b.session_distance - a.session_distance),

          totalAbsoluteHighSpeedDistance: [...filteredGPSData]
            .map(
              ({
                total_absolute_high_speed_distance,
                gameId,
                session_date,
                session_type,
                player_id,
              }) => ({
                total_absolute_high_speed_distance,
                gameId,
                session_date,
                session_type,
                player_id,
              }),
            )
            .sort(
              (a, b) =>
                b.total_absolute_high_speed_distance -
                a.total_absolute_high_speed_distance,
            ),
        },
      };

      this.totalDistanceFullSession = {
        labels: this.getGPSsessionMappedData(
          "sessionDistance",
          "player_id",
          null,
          "Session",
        ),
        datasets: [
          {
            label: "Total distance",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "sessionDistance",
              null,
              "session_distance",
              "Session",
            ),
          },
        ],
      };

      this.totalDistanceFirstHalf = {
        labels: this.getGPSsessionMappedData(
          "sessionDistance",
          "player_id",
          null,
          "First Half",
        ),
        datasets: [
          {
            label: "Total distance",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "sessionDistance",
              null,
              "session_distance",
              "First Half",
            ),
          },
        ],
      };

      this.totalDistanceSecondHalf = {
        labels: this.getGPSsessionMappedData(
          "sessionDistance",
          "player_id",
          null,
          "Second Half",
        ),
        datasets: [
          {
            label: "Total distance",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "sessionDistance",
              null,
              "session_distance",
              "Second Half",
            ),
          },
        ],
      };

      this.totalAbsoluteHighSpeedDistanceFullSession = {
        labels: this.getGPSsessionMappedData(
          "totalAbsoluteHighSpeedDistance",
          "player_id",
          null,
          "Session",
        ),
        datasets: [
          {
            label: "High Speed Running",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "totalAbsoluteHighSpeedDistance",
              null,
              "total_absolute_high_speed_distance",
              "Session",
            ),
          },
        ],
      };

      this.totalAbsoluteHighSpeedDistanceFirstHalf = {
        labels: this.getGPSsessionMappedData(
          "totalAbsoluteHighSpeedDistance",
          "player_id",
          null,
          "First Half",
        ),
        datasets: [
          {
            label: "High Speed Running",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "totalAbsoluteHighSpeedDistance",
              null,
              "total_absolute_high_speed_distance",
              "First Half",
            ),
          },
        ],
      };

      this.totalAbsoluteHighSpeedDistanceSecondHalf = {
        labels: this.getGPSsessionMappedData(
          "totalAbsoluteHighSpeedDistance",
          "player_id",
          null,
          "Second Half",
        ),
        datasets: [
          {
            label: "High Speed Running",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "totalAbsoluteHighSpeedDistance",
              null,
              "total_absolute_high_speed_distance",
              "Second Half",
            ),
          },
        ],
      };

      this.totalAccelerationsTotalEffortsFullSession = {
        labels: this.getGPSsessionMappedData(
          "accelerationsTotalEfforts",
          "player_id",
          null,
          "Session",
        ),
        datasets: [
          {
            label: "Accelerations",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "accelerationsTotalEfforts",
              null,
              "accelerations_total_efforts",
              "Session",
            ),
          },
        ],
      };

      this.totalAccelerationsTotalEffortsFirstHalf = {
        labels: this.getGPSsessionMappedData(
          "accelerationsTotalEfforts",
          "player_id",
          null,
          "First Half",
        ),
        datasets: [
          {
            label: "Accelerations",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "accelerationsTotalEfforts",
              null,
              "accelerations_total_efforts",
              "First Half",
            ),
          },
        ],
      };

      this.totalAccelerationsTotalEffortsSecondHalf = {
        labels: this.getGPSsessionMappedData(
          "accelerationsTotalEfforts",
          "player_id",
          null,
          "Second Half",
        ),
        datasets: [
          {
            label: "Accelerations",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "accelerationsTotalEfforts",
              null,
              "accelerations_total_efforts",
              "Second Half",
            ),
          },
        ],
      };

      this.totalDecelerationsTotalEffortsFullSession = {
        labels: this.getGPSsessionMappedData(
          "decelerationsTotalEfforts",
          "player_id",
          null,
          "Session",
        ),
        datasets: [
          {
            label: "Decelerations",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "decelerationsTotalEfforts",
              null,
              "decelerations_total_efforts",
              "Session",
            ),
          },
        ],
      };

      this.totalDecelerationsTotalEffortsFirstHalf = {
        labels: this.getGPSsessionMappedData(
          "decelerationsTotalEfforts",
          "player_id",
          null,
          "First Half",
        ),
        datasets: [
          {
            label: "Decelerations",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "decelerationsTotalEfforts",
              null,
              "decelerations_total_efforts",
              "First Half",
            ),
          },
        ],
      };

      this.totalDecelerationsTotalEffortsSecondHalf = {
        labels: this.getGPSsessionMappedData(
          "decelerationsTotalEfforts",
          "player_id",
          null,
          "Second Half",
        ),
        datasets: [
          {
            label: "Decelerations",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "decelerationsTotalEfforts",
              null,
              "decelerations_total_efforts",
              "Second Half",
            ),
          },
        ],
      };

      this.totalMaximumVelocityFullSession = {
        labels: this.getGPSsessionMappedData(
          "maximumVelocity",
          "player_id",
          null,
          "Session",
        ),
        datasets: [
          {
            label: "Maximum Velocity",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "maximumVelocity",
              null,
              "maximum_velocity",
              "Session",
            ),
          },
        ],
      };

      this.totalMaxVelMaxFullSession = {
        labels: this.getGPSsessionMappedData(
          "maxVelMax",
          "player_id",
          null,
          "Session",
        ),
        datasets: [
          {
            label: "Max Vel (% Max)",
            backgroundColor: "#ffde00",
            data: this.getGPSsessionMappedData(
              "maxVelMax",
              null,
              "max_vel_max",
              "Session",
            ),
          },
        ],
      };
    },
    getGPSsessionMappedData(type, id, value, sessionType) {
      let data = [];

      // Convert sessionType to array if it's a string (backward compatibility)
      const sessionTypes = Array.isArray(sessionType)
        ? sessionType
        : [sessionType];

      id !== null
        ? this.selectedGameFullPerformanceReportGPSdataForTeam.sortedData[
            type
          ].map((user) => {
            if (sessionTypes.includes(user.session_type)) {
              data.push(this.getPlayersNameFromId(user[id]));
            }
          })
        : this.selectedGameFullPerformanceReportGPSdataForTeam.sortedData[
            type
          ].map((user) => {
            console.log("user", user);
            console.log("sessionTypes", sessionTypes);
            if (sessionTypes.includes(user.session_type)) {
              if (user[value] !== undefined) {
                data.push(user[value]);
              }
            }
          });

      return data;
    },
    showIfUnderU16(age_group) {
      if (age_group !== undefined) {
        const currentYear = new Date().getFullYear();
        const birthYear = parseInt(age_group);

        // Check if birth year is valid
        if (isNaN(birthYear)) {
          return false;
        }

        // Calculate age based on current year
        const age = currentYear - birthYear;

        // Return true if player is under 14
        return age < 14;
      }
      return false;
    },
    populateGamesWithGPSdata() {
      this.allGPSDataBySession = []; // Clear any previous data
      let sourceData = [];
      let formattedData = null;

      // Determine the source of the GPS data
      sourceData =
        this.showIfUnderU16(this.selectedTeam.age_group) === false
          ? this.allGPSdata
          : this.playerPlayMakerGpsData;

      // Transform the data to a consistent structure
      if (sourceData !== undefined) {
        formattedData = sourceData.map((game) => ({
          teamId: game.teamId,
          gameId: game.gameId,
          session_date: game.session_date,
        }));
      }

      // Match GPS data with selected games/events
      if (this.selectedGamesEvents.length > 0 && formattedData !== null) {
        formattedData.forEach((gpsData) => {
          const matchedEvent = this.selectedGamesEvents.find(
            (event) => gpsData.gameId === event.id,
          );
          console.log("Matched Event:", matchedEvent);

          if (
            matchedEvent &&
            !this.allGPSDataBySession.some(
              (item) => item.id === matchedEvent.id,
            )
          ) {
            this.allGPSDataBySession.push(matchedEvent);
          }
        });
      }
    },
    onPerformanceRatingChange(eventOrValue, index) {
      // Extract the actual value whether it's an event or direct value
      const value = eventOrValue?.target?.value || eventOrValue;

      // Create a new array to ensure Vue 3 reactivity
      const updatedReports = [
        ...this.selectedMatchReportData.playerMatchReports,
      ];
      updatedReports[index] = {
        ...updatedReports[index],
        performance_rating: value,
      };

      this.selectedMatchReportData = {
        ...this.selectedMatchReportData,
        playerMatchReports: updatedReports,
      };

      this.updateTeamAverage();
    },
    mapPerformanceTextToNumber(performanceText) {
      const performanceMap = {
        Excellent: 5,
        "Very Good": 4,
        Good: 3,
        Average: 2,
        Poor: 1,
        "N/A": 0,
      };
      return performanceMap[performanceText] || 0; // Default to 0 if not found
    },
    updateTeamAverage() {
      const allScores = this.selectedMatchReportData.playerMatchReports
        .map((player) =>
          this.mapPerformanceTextToNumber(player.performance_rating),
        )
        .filter((score) => score !== 0);

      const result = allScores.length
        ? allScores.reduce((sum, score) => sum + score, 0) / allScores.length
        : 0;
      this.teamAverageMatchReportScore = Math.round(result);
    },
    async loadSelectedGameForTeamMinsPerformanceData(team, date) {
      this.under16 = this.showIfUnderU16(this.selectedTeam.age_group);

      if (this.under16 === true) {
        const data = {
          action: "getGameMinsPerformancePlayeMakerData",
          teamId: team.id,
          session_date: date,
        };

        const responce = await PlayerPhysicalPerformance.find(data).catch(
          (error) => {
            console.log(error);
          },
        );

        if (responce && responce.status === 200) {
          this.playerPlayMakerGpsData = responce.data;
        }
      } else {
        const data = {
          action: "getGameMinsPerformanceData",
          teamId: team.id,
          session_date: date,
        };
        const responce = await PlayerPhysicalPerformance.find(data).catch(
          (error) => {
            console.log(error);
          },
        );

        if (responce && responce.status === 200) {
          this.allGPSdata = responce.data;
        }
      }

      this.populateGamesWithGPSdata();
    },
    openStrengthTestModalCall(value) {
      console.log("openStrengthTestModalCall", value);
      this.openStrengthTestModalValue = value;
    },
    gpsUploadModalValue(value) {
      this.openGPSUploadModal = value;
    },
    openImportCSVModal(data) {
      this.openGPSUploadModal = true;
      this.gameTrainingData = data;
    },
    getCoachesNameFromId(id) {
      const coach = this.coachData.find((coach) => coach.id === id);
      return coach ? coach.name : "";
    },
    async populateCoachesData() {
      const coachesData = {
        clubId: this.userData.clubId,
        action: "populateOnlyCoachesData",
      };

      const responce = await Users.find(coachesData).catch((error) => {
        console.log(error);
      });

      if (responce) {
        responce.data.length > 0 ? (this.coachData = responce.data) : [];
      }
    },
    addPlayerPostionPlayed(value, index) {
      if (
        !this.selectedMatchReportData.playerMatchReports[
          index
        ].positions_played.includes(value)
      ) {
        this.selectedMatchReportData.playerMatchReports[
          index
        ].positions_played.push(value);
      }
    },
    removePlayerPostionPlayed(index, positionPlayed) {
      this.selectedMatchReportData.playerMatchReports[index].positions_played =
        this.selectedMatchReportData.playerMatchReports[
          index
        ].positions_played.filter((item) => item !== positionPlayed);
    },
    async getMatchReportForSelectedGame(gameData) {
      const data = {
        action: "getMatchReportForSelectedGame",
        gameId: gameData.id,
      };

      const response = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.getGameAnalysisData();

        if (response.data.length === 0) {
          this.loadingStuff = true;
          // Load attendees first, then build blank report structure
          await this.getAllAttendeesForAGame();
          await this.makeMatchReportDataObject(gameData);
          // Now merge coach data on top of the blank structure (must run after makeMatchReportDataObject)
          await Promise.all([
            this.getCoachGamePerformanceReportsByGameId(gameData.id),
            this.updateTeamAverage(),
          ]);
          this.loadingStuff = false;
        } else {
          await this.getAllAttendeesForAGame();
          const gameAnalysisData =
            await this.populategameAnalysisMatchReportData(gameData.id);
          this.selectedMatchReportData = {
            fullGameData: gameData,
            opposition: gameData.opposition,
            teamName: gameData.teamName,
            matchDate: gameData.matchDate,
            home_team: gameData.teamName,
            result_added: gameData.result_added,
            away_team_goals: gameData.away_team_goals,
            home_team_goals: gameData.home_team_goals,
            generalComments: gameAnalysisData.generalComments,
            physio_name: gameAnalysisData.physio_name,
            coachId: this.selectedTeam.coach_id,
            playerMatchReports: [],
          };

          response.data.map((player) => {
            this.selectedMatchReportData.coachId = player.coachId;
            // Handle null, undefined, or empty positions_played from database
            if (
              player.positions_played &&
              player.positions_played.trim() !== ""
            ) {
              player.positions_played = player.positions_played
                .split(",")
                .filter((pos) => pos.trim() !== "");
            } else {
              player.positions_played = [];
            }

            if (this.isStringNumberBetween0And5(player.performance_rating)) {
              player.performance_rating = this.changeNumbersToRating(
                player.performance_rating,
              );
            }

            // Ensure goals and assists are numbers (may come as strings from DB)
            player.goals = parseInt(player.goals) || 0;
            player.assists = parseInt(player.assists) || 0;

            // Ensure yellow_card and red_card are booleans (handle string "1" from DB)
            player.yellow_card =
              player.yellow_card === 1 ||
              player.yellow_card === "1" ||
              player.yellow_card === true;
            player.red_card =
              player.red_card === 1 ||
              player.red_card === "1" ||
              player.red_card === true;

            this.selectedMatchReportData.playerMatchReports.push(player);
          });

          // Find players who are attending but don't have match reports
          this.selectedGameAttendees.forEach((player) => {
            // Only check players who are going to the game
            if (player.going === 1) {
              // Check if this player already has a match report
              const hasExistingReport =
                this.selectedMatchReportData.playerMatchReports.some(
                  (checkPlayer) => checkPlayer.player_id === player.user_id,
                );

              if (!hasExistingReport) {
                console.log(
                  "Player attending but has no match report:",
                  player,
                );

                // Create a match report for this player
                // Filter out empty position values
                const initialPosition =
                  player.position && player.position.trim() !== ""
                    ? [player.position]
                    : [];
                const playerMatchReport = {
                  player_id: player.user_id,
                  age_group: player.age_group,
                  positions_played: initialPosition,
                  performance_rating: "Progressing well", // Default rating
                  game_comments: "",
                  game_improvements: "",
                  players_name: player.name,
                  gameId: gameData.id,
                  session_mins: 0,
                  trialistId: null,
                  assists: 0,
                  goals: 0,
                  yellow_card: false,
                  red_card: false,
                  tactility_improvements: null,
                  tactility_positives: null,
                  technically_improvements: null,
                  technically_positives: null,
                  mentally_improvements: null,
                  mentally_positives: null,
                  physicality_improvements: null,
                  physicality_positives: null,
                  physio_name: "",
                };

                this.selectedMatchReportData.playerMatchReports.push(
                  playerMatchReport,
                );
              }
            }
          });

          // Await coach data merge so it's ready before the modal opens
          await Promise.all([
            this.getCoachGamePerformanceReportsByGameId(gameData.id),
            this.updateTeamAverage(),
          ]);
        }
      }
    },
    isStringNumberBetween0And5(str) {
      const num = Number(str);
      return !isNaN(num) && num >= 0 && num <= 5;
    },
    async getCoachGamePerformanceReportsByGameId(gameId) {
      const userData = {
        gameId: gameId,
        under16: this.showIfUnderU16(this.selectedTeam.age_group),
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        action: "getCoachGamePerformanceReportsByGameId",
      };
      const response = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        response.data.map((player) => {
          const playerData = this.getPlayerData(player.player_id);

          // Skip if player not found in current team
          if (!playerData) {
            console.warn(
              `Player with ID ${player.player_id} not found in current team`,
            );
            return;
          }

          // Convert rating first and store it
          let convertedRating;
          if (this.isStringNumberBetween0And5(player.player_rating)) {
            convertedRating = this.changeNumbersToRating(player.player_rating);
          } else {
            convertedRating = player.player_rating;
          }

          // Find existing playerMatchReport by player_id FIRST to preserve positions_played
          const existingIndex =
            this.selectedMatchReportData.playerMatchReports.findIndex(
              (existingPlayer) => existingPlayer.player_id === player.player_id,
            );

          // Preserve existing positions_played if it has data, otherwise fallback to player profile position
          let existingPositionsPlayed = [];
          if (existingIndex !== -1) {
            const existingReport =
              this.selectedMatchReportData.playerMatchReports[existingIndex];
            if (
              existingReport.positions_played &&
              existingReport.positions_played.length > 0
            ) {
              existingPositionsPlayed = existingReport.positions_played;
            }
          }

          // Only use player profile position as fallback if no saved positions exist
          const initialPosition =
            existingPositionsPlayed.length > 0
              ? existingPositionsPlayed
              : playerData.position && playerData.position.trim() !== ""
                ? [playerData.position]
                : [];

          let playerMatchReport = {
            player_id: player.player_id,
            age_group: this.selectedTeam.age_group,
            positions_played: initialPosition,
            performance_rating: convertedRating,
            game_comments: player.game_comments ? player.game_comments : "",
            game_improvements: player.game_improvements
              ? player.game_improvements
              : "",
            players_name: playerData.name || "",
            gameId: player.gameId,
            session_mins: player.session_mins ? player.session_mins : 0,
            trialistId: playerData.trialistId ? playerData.trialistId : null,
            // Get goals, assists, cards from API response (from team_game_results)
            assists: player.assists ? parseInt(player.assists) : 0,
            goals: player.goals ? parseInt(player.goals) : 0,
            yellow_card:
              player.yellow_card === 1 || player.yellow_card === true,
            red_card: player.red_card === 1 || player.red_card === true,
          };

          if (existingIndex !== -1) {
            // Create a completely new array to ensure Vue detects the change
            const newPlayerMatchReports = [
              ...this.selectedMatchReportData.playerMatchReports,
            ];
            newPlayerMatchReports[existingIndex] = { ...playerMatchReport };

            // Update the entire object to trigger reactivity
            this.selectedMatchReportData = {
              ...this.selectedMatchReportData,
              playerMatchReports: newPlayerMatchReports,
            };
          } else {
            // Add new playerMatchReport if not found
            this.selectedMatchReportData = {
              ...this.selectedMatchReportData,
              playerMatchReports: [
                ...this.selectedMatchReportData.playerMatchReports,
                playerMatchReport,
              ],
            };
          }
        });

        // Force Vue to update the view after all changes
        this.$nextTick(() => {
          console.log(
            "After nextTick - performance ratings:",
            this.selectedMatchReportData.playerMatchReports.map((p) => ({
              name: p.players_name,
              performance_rating: p.performance_rating,
            })),
          );
        });
      }
    },
    changeNumbersToRating(rating) {
      // Handle null, undefined, or empty values
      if (!rating || rating === null || rating === undefined) {
        return "Progressing well";
      }

      // Convert to number for consistent comparison
      const numRating = Number(rating);

      // Handle both string and number ratings
      switch (numRating) {
        case 5:
        case "5":
          return "Excellent";
        case 4:
        case "4":
          return "Good";
        case 3:
        case "3":
          return "Progressing well";
        case 2:
        case "2":
          return "⁠⁠Requires improvement";
        case 1:
        case "1":
          return "Unsatisfactory";
        default:
          return "Progressing well"; // Default case if no match found
      }
    },
    getPlayerData(playerId) {
      return this.currentTeam.find((player) => player.id === playerId);
    },
    createNewMultiGameAnalysis() {
      this.selectedMatchReportData.id === undefined
        ? this.saveNewGameAnalysis()
        : this.updateGameAnalysis();
    },
    async updateGameAnalysis() {},
    async saveNewGameAnalysis() {
      this.selectedGame.season_start_date = localStorage.getItem(
        "currentPlayingseasonStartDate",
      );
      this.selectedGame.season_end_date = this.extendSeasonEndDateToFullYear();
      const data = {
        action: "saveNewGameAnalysis",
        ...this.selectedMatchReportData,
        coachName: this.selectedTeam.name,
        age_group: this.selectedTeam.age_group,
        fullMatchReport: { ...this.selectedGame },
      };

      const response = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.$toast.info("Match report saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.getTeamsGamesGoalScorers();
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.hideModal("matchReportModal");
      }
    },
    async openMatchReportModal(gameData) {
      // Set loading state
      this.loadingStuff = true;
      this.loadIngStuffText = "Loading match report data";

      try {
        this.selectedGame = gameData;

        // Wait for all async data loading functions to complete
        await Promise.all([
          this.populateCoachesData(),
          this.getAllAttendeesForAGame(),
          this.getMatchReportForSelectedGame(gameData),
        ]);

        // Check if Eyeball data is available for this game
        this.eyeballImportAvailable =
          this.checkEyeBallMatchData(gameData) !== undefined;

        // Small delay to ensure all reactivity updates complete
        await new Promise((resolve) => setTimeout(resolve, 50));
        this.showModal("matchReportModal");
      } catch (error) {
        console.error("Error loading match report data:", error);
        this.$toast.error("Failed to load match report data");
      } finally {
        // Clear loading state
        this.loadingStuff = false;
        this.loadIngStuffText = "Loading";

        // Only show modal after everything is loaded and loading state is cleared
        this.$nextTick(() => {
          this.showModal("matchReportModal");
        });
      }
    },
    populategameAnalysisMatchReportData(id) {
      const gameAnalysisData = this.getgameAnalysisByGameId(id);
      return gameAnalysisData !== undefined
        ? gameAnalysisData
        : { generalComments: "", physio_name: "" };
    },
    makeMatchReportDataObject(gameData) {
      const gameAnalysisData = this.populategameAnalysisMatchReportData(
        gameData.id,
      );
      this.selectedMatchReportData = {
        fullGameData: gameData,
        opposition: gameData.opposition,
        teamName: gameData.teamName,
        matchDate: gameData.matchDate,
        home_team: gameData.teamName,
        result_added: gameData.result_added,
        away_team_goals: gameData.away_team_goals,
        home_team_goals: gameData.home_team_goals,
        generalComments: gameAnalysisData.generalComments,
        physio_name: gameAnalysisData.physio_name,
        coachId: "",
        playerMatchReports: [],
      };

      this.selectedGameAttendees.map((player) => {
        if (player.going === 1) {
          // Filter out empty position values
          const initialPosition =
            player.position && player.position.trim() !== ""
              ? [player.position]
              : [];
          const playerMatchReport = {
            player_id: player.user_id,
            age_group: player.age_group,
            positions_played: initialPosition,
            performance_rating: 0,
            game_comments: "",
            game_improvements: "",
            players_name: player.name,
            gameId: gameData.id,
            session_mins: 0,
            trialistId: null,
            assists: 0,
            goals: 0,
            yellow_card: false,
            red_card: false,
          };

          this.selectedMatchReportData.playerMatchReports.push(
            playerMatchReport,
          );
        }
      });
    },
    gameResponceChangeFromCoachReport(player) {
      console.log("gameResponceChangeFromCoachReport", player.id);
      this.gameResponce(this.gameResponceValueChange, player.id);
      this.fetchPlayerMatchReports();
    },
    gameResponceChange(userId) {
      this.gameResponce(this.gameResponceValueChange, userId);
    },
    populateSelectedTeamVenue(event, gameType) {
      const selectedTeam = this.leagueTeams.find(
        (team) => team.id == event.target.value,
      );

      if (!selectedTeam) return; // Early return if no team is found
      const {
        teamName,
        address,
        name: locationName,
        postCode,
        pitchType,
        id,
      } = selectedTeam;

      Object.assign(this[gameType], {
        pitch_id: id,
        opposition: teamName,
        address,
        locationName,
        postCode,
        pitchType:
          pitchType === "Astro"
            ? "4G"
            : pitchType === "Astro/Grass"
              ? "Other"
              : pitchType,
      });
    },
    formatDate(date) {
      console.log("Formatting date:", date);
      if (!date) {
        return "No Date";
      }
      // Try parsing with DD/MM/YYYY format first
      const m = moment(date, "DD/MM/YYYY", true);
      if (m.isValid()) {
        return m.format("MMMM Do YYYY");
      }
      // Fallback: try default parsing
      const fallback = moment(date);
      return fallback.isValid()
        ? fallback.format("MMMM Do YYYY")
        : "Invalid date";
    },
    formatDateForHuman(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).format("MMMM Do YYYY")
        : "";
    },
    async deleteHomework(id) {
      const data = {
        id: id,
        action: "deleteHomework",
      };

      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.populateTeamVideoLinkData();
        this.getAllHomeworkForTeam();

        this.$toast.info("Homework successfully deleted.", {
          title: "Deleted",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async editHomework() {
      const data = {
        matchDate: this.newHomeWorkData.matchDate,
        opposition: this.newHomeWorkData.opposition,
        gameId: this.newHomeWorkData.gameId,
        title: this.newHomeWorkData.title,
        information: this.newHomeWorkData.information,
        id: this.newHomeWorkData.id,
        created_date: moment().format("YYYY-MM-DD"),
        player_id: null,
        action: "editHomework",
        document_id: this.newHomeWorkData.id,
        teamId: this.selectedTeam.id,
        videos: this.newHomeWorkData.videos,
      };

      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.populateTeamVideoLinkData();
        this.getAllHomeworkForTeam();

        this.hideModal("addHomeworkModal");
        this.resetNewHomeWorkData();

        this.$toast.info("Homework successfully updated.", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async populateTeamVideoLinkData() {
      const data = {
        action: "populatePlayerVideoLinkData",
        teamId: this.selectedTeam.id,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce && responce.status === 200) {
        this.teamVideos = responce.data;
      }
    },
    filterHomeworkVideos(id) {
      const result = this.teamVideos.filter(
        (video) => video.document_id === id,
      );

      this.newHomeWorkData.videos = result;
    },
    viewHomework(homeworkData) {
      this.newHomeWorkData = homeworkData;
      this.filterHomeworkVideos(homeworkData.id);
      this.showViewHomeworkModal = true;
    },
    async saveHomework() {
      const data = {
        ...this.newHomeWorkData,
        created_date: moment().format("YYYY-MM-DD"),
        player_id: null,
        teamId: this.selectedTeam.id,
        action: "saveHomework",
      };

      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.populateTeamVideoLinkData();
        this.getAllHomeworkForTeam();

        this.hideModal("addHomeworkModal");
        this.resetNewHomeWorkData();

        this.$toast.info("Homework successfully saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.sendFBNotificationMessage(
          "Homework added",
          "You have a new homework item to review.",
          [this.selectedTeam.age_group],
          undefined,
          true,
        );
      }
    },
    async getAllHomeworkForTeam() {
      const data = {
        action: "getAllHomeworkForTeam",
        teamId: this.selectedTeam.id,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.allHomeWorkData = response.data;
      }
    },
    resetNewHomeWorkData() {
      this.newHomeWorkData = {
        title: "",
        information: "",
        videos: [],
      };
    },
    editHomeworkMdalCall(homework) {
      Object.assign(this.newHomeWorkData, {
        created_date: homework.created_date,
        gameId: homework.gameId,
        id: homework.id,
        information: homework.information,
        matchDate: homework.matchDate,
        opposition: homework.opposition,
        player_id: homework.player_id,
        title: homework.title,
        videos: homework.videos,
      });
      if (
        !Object.prototype.hasOwnProperty.call(this.newHomeWorkData, "videos")
      ) {
        this.newHomeWorkData.videos = [];
      }
      this.filterHomeworkVideos(homework.id);
      this.showModal("addHomeworkModal");
    },
    addHomeWorkModalCall() {
      this.resetNewHomeWorkData();
      this.showModal("addHomeworkModal");
    },
    getPlayerAverageAttendance(teamMemberId) {
      if (!Array.isArray(this.teamsAttendedGamesAndTrainingData)) return 0;

      const totalGames = this.selectedGamesEvents.length;
      if (totalGames === 0) return 0;

      const attendedRecords = this.teamsAttendedGamesAndTrainingData.filter(
        (game) => game.user_id == teamMemberId && Number(game.going) === 1,
      );

      // Deduplicate by gameId (or kickOffTime for older records) to avoid counting the same event twice
      const uniqueAttended = new Set();
      attendedRecords.forEach((record) => {
        const key = record.gameId || record.kickOffTime;
        if (key) uniqueAttended.add(key);
      });

      const attended =
        uniqueAttended.size > 0 ? uniqueAttended.size : attendedRecords.length;
      const percentage = Math.round((attended / totalGames) * 100);
      return Math.min(percentage, 100);
    },
    checkGameTrainingAttendance(teamMemberId, gameId, gameKickOffTime) {
      if (!Array.isArray(this.teamsAttendedGamesAndTrainingData))
        return "No Response";

      // Match by gameId first, fall back to kickOffTime for older records where gameId is null
      const game = this.teamsAttendedGamesAndTrainingData.find(
        (g) =>
          g.user_id == teamMemberId &&
          ((g.gameId && g.gameId == gameId) ||
            (!g.gameId && g.kickOffTime === gameKickOffTime)),
      );

      if (!game) return "No Response";
      if (Number(game.going) === 1) return "Attended";
      if (Number(game.notGoing) === 1) return "Not Attended";
      return "No Response";
    },
    teamsAttendedGamesAndTrainingBuild() {
      this.allGamesAndTrainingData = [...this.pastGames, ...this.pastTraining];
    },
    async getDocumentUploadsByTeamId() {
      let teamId = this.selectedTeam.teamId;
      if (this.selectedTeam.teamId === undefined) {
        teamId = this.selectedTeam.id;
      }
      const userData = {
        action: "getDocumentUploadsByTeamId",
        clubId: this.selectedTeam.clubId,
        teamId: teamId,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.getClubDocumentUploads(response.data);
      }
    },
    async getClubDocumentUploads(otherUploadData) {
      const userData = {
        action: "getClubDocumentUploads",
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.uploadedDocuments = [...response.data, ...otherUploadData];
      }
    },
    setBarVariant(value) {
      if (value > 0 && value <= 2) {
        return "danger";
      }
      if (value > 2 && value <= 3) {
        return "warning";
      }
      if (value > 3 && value <= 4) {
        return "primary";
      }
      if (value > 4 && value <= 5) {
        return "success";
      }
    },
    getTeamIdsFromUsers() {
      return this.userHasMoreThanOneAccount.map((user) => user.id);
    },
    async getTeamsDataForMultiAccounts() {
      const userData = {
        userIds: this.getTeamIdsFromUsers(),
        action: "getTeamsDataForMultiAccounts",
      };

      const responce = await Teams.find(userData).catch((error) => {
        console.log(error);
      });
      if (!responce) return;

      const cleanData = this.removeDuplicates(
        (responce.data || []).filter(Boolean),
        "id",
      );
      this.allTeamDataBeforFilterApplied = cleanData;
      this.clubTeams = cleanData;

      // Unlike the single-account paths (getTeamsByCoachid / getTeamsByUserId),
      // this one never selected a team — leaving selectedTeam as its "" default,
      // so the header rendered "Season: Invalid date". Select the first team and
      // run the same follow-up loads the other paths do.
      if (cleanData.length && !this.selectedTeam) {
        this.selectedTeam = cleanData[0];
        this.applyPastSeasonToSelectedTeam();
        this.under16 = this.showIfUnderU16(this.selectedTeam.age_group);
        this.getUserByTeamId();
        this.setClubTeamnewGameData(this.selectedTeam);
        this.getgadyflLeagueTableData();
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
      }
    },
    selectedAllPlayerToggle() {
      this.listOfSelectedplayerIds = [];

      if (this.selectedAllPlayerToggleValue) {
        this.currentTeam.map((player) => {
          this.listOfSelectedplayerIds.push(player.id);
        });
      }
    },
    detachListener() {
      this.chatListener();
    },
    async saveAppNotifications() {
      /* const docRef = await addDoc(collection(db, "app_notifications"), {
         chatId: '1',
         messageContent: filterBadWords.clean('helooooo'),
         userIds: "1,2,3,4,5,6,7,8",
         teamIds: "1,2,3",
         messageType: "sender",
         name: this.userData.name,
         userId: this.userData.id.toString(),
         media: "",
         userImageURL: this.userData.userImage,
         createdDate: new Date().toISOString(),
         clubId: this.userData.clubId
       }).then(() => {
             console.log("Document successfully written!");
           }).catch((error) => {
             console.error("Error writing document: ", error);
           });*/
    },
    async getAllCoachesAttachedToTeam() {
      const data = {
        teamId: this.selectedTeam.id,
        action: "getAllCoachesAttachedToTeam",
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });
      if (responce && responce.data.length > 0) {
        responce.data.map((coach) => {
          this.sendFBNotificationMessage(
            `A new message has been posted to the ${this.selectedTeam.teamName} ${this.selectedChat.name} chat`,
            `You have a new message to review from ${this.selectedTeam.teamName}`,
            [],
            coach.coach_id,
            true,
            this.selectedChat.id,
          );
        });
      }
    },
    sendFBNotificationToAllIds() {
      const idsList = this.selectedChat.usersInTheGroup.split(",");
      idsList.map((id) => {
        this.sendFBNotificationMessage(
          `A new message has been posted to the ${this.selectedTeam.teamName} ${this.selectedChat.name} chat`,
          `You have a new message to review from ${this.selectedTeam.teamName}`,
          [],
          Number(id),
          false,
          this.selectedChat.id,
        );
      });
      this.getAllCoachesAttachedToTeam();
    },
    checkIfGameHasAnalysis(gameId) {
      return this.gameAnalysisIdSet.has(gameId);
    },
    async upDateGameAnalysisData() {
      this.loadingStuff = true;
      const data = {
        ...this.selectedGameAnalysisData,
        action: "upDateGameAnalysisData",
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data === "Game analysis updated") {
        this.$toast.info("Game analysis updated", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
        this.getGameAnalysisData();
        // Refresh the underlying performance bars + stat grid too —
        // getGameAnalysisData only refreshes the analysis-table list.
        this.getGamePerformanceAnalysisData(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.hideModal("gameAnalysisModal");
        this.loadingStuff = false;
      }
    },
    async getGameAnalysisData() {
      const data = {
        teamId: this.selectedTeam.id,
        season_start_date: this.selectedTeam.season_start_date,
        season_end_date: this.selectedTeam.season_end_date,
        action: "getGameAnalysisData",
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.allGameAnalysisData = responce.data;
      }
    },
    async createNewGameAnalysis() {
      this.loadingStuff = true;
      const data = {
        ...this.selectedGameAnalysisData,
        action: "createNewGameAnalysis",
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data === "Game analysis added") {
        this.$toast.info("Game analysis added", {
          title: "Added",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
        this.getGameAnalysisData();
        // Refresh the underlying performance bars + stat grid too.
        this.getGamePerformanceAnalysisData(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );

        this.hideModal("gameAnalysisModal");
        this.loadingStuff = false;
      }
    },
    resetSelectedAnalysisObject() {
      this.selectedGameAnalysisData = {
        gameId: null,
        teamId: null,
        teamName: null,
        coachName: null,
        coachId: null,
        age_group: null,
        matchDate: null,
        opposition: null,
        kickOffTime: null,
        penetrationScore: 0,
        penetrationComments: "",
        supportScore: 0,
        supportComments: "",
        mobilityScore: 0,
        mobilityComments: "",
        creativityScore: 0,
        creativityComments: "",
        transitionToAttackScore: 0,
        transitionToAttackComments: "",
        pressureScore: 0,
        pressureComments: "",
        coverScore: 0,
        coverComments: "",
        balanceScore: 0,
        balanceComments: "",
        compactnessScore: 0,
        compactnessComments: "",
        transitionToDefendScore: 0,
        transitionToDefendComments: "",
        generalComments: "",
        trainingComments: "",
      };
    },
    getgameAnalysisByGameId(gameId) {
      return this.allGameAnalysisData.find(
        (gameAnalysis) => gameAnalysis.gameId === gameId,
      );
    },
    gameAnalysisModal(gameData, modelId, performanceData) {
      this.resetSelectedAnalysisObject();
      // Use gameId if present (from game_analysis records), otherwise use id (from games records)
      let gameDataId = gameData.gameId || gameData.id;
      if (performanceData !== undefined) {
        gameDataId = gameData.gameId;
      }
      if (this.checkIfGameHasAnalysis(gameDataId)) {
        // edit
        this.selectedGameAnalysisData = this.allGameAnalysisData.find(
          (gameAnalysis) => gameAnalysis.gameId === gameDataId,
        );
        this.selectedGameAnalysisData.edit = true;
      } else {
        // new
        this.selectedGameAnalysisData.gameId = gameDataId;
        this.selectedGameAnalysisData.teamId = this.selectedTeam.id;
        this.selectedGameAnalysisData.teamName = this.selectedTeam.teamName;
        this.selectedGameAnalysisData.coachName = this.selectedTeam.name;
        this.selectedGameAnalysisData.coachId = this.selectedTeam.coach_id;
        this.selectedGameAnalysisData.age_group = this.selectedTeam.age_group;
        this.selectedGameAnalysisData.matchDate = gameData.matchDate;
        this.selectedGameAnalysisData.opposition = gameData.opposition;
        this.selectedGameAnalysisData.kickOffTime = gameData.kickOffTime;
        this.selectedGameAnalysisData.edit = false;
      }
      this.showModal(modelId);
    },
    getPlayerFromId(userId) {
      const player = this.currentTeam.find((player) => player.id === userId);
      return player ? player.name : null;
    },
    updateTeamWhoScored() {
      this.editGame.team = this.teamWhoScored;
    },
    goalScoredUserIdAddRemove(data) {
      data.target.checked === true
        ? (this.editGame.userId = data.target.id)
        : null;
    },
    goalAssistUserIdAddRemove(data) {
      data.target.checked === true
        ? (this.editGame.assist = data.target.id)
        : null;
    },
    resetGameResultsGoalSelection() {
      this.gameEventSelected = null;
      this.teamWhoScored = null;
    },
    removeFilter() {
      this.clubTeams = this.allTeamDataBeforFilterApplied;
      this.hideRemoveTeamFilterButton = true;
    },
    filterBy(arrayToFilter, filterBy) {
      const filterResult = this[arrayToFilter].filter(
        (pilot) => pilot[filterBy] === this.selectedFilterData,
      );

      this.clubTeams = filterResult;
      this.hideRemoveTeamFilterButton = false;
    },
    getImgUrl(pic) {
      // Empty stays empty (callers rely on rendering nothing); a stored
      // "default-image.png" resolves to the neutral avatar via avatarUrl.
      return pic !== undefined && pic !== "" ? avatarUrl(pic) : "";
    },
    async getComments(type_id) {
      this.commentsData = [];
      const data = {
        type_id: type_id,
        teamId: this.selectedGame.teamId,
        action: "getComments",
      };

      const responce = await Comments.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        console.log("responce");
        this.commentsData = responce.data;
      }
    },
    defaultPitchInputs(gameType) {
      this[gameType].pitch_id = "";
      this.newGameData.address = "";
      this.newGameData.locationName = "";
      this.newGameData.postCode = "";
      this.newGameData.pitchType = "";
      this.newGameData.pitch_zone = null;
      this.togglePitchDetails = false;
    },
    setPitchZones(pitchData, gameDataType) {
      if (
        pitchData.sectionOne !== false &&
        pitchData.sectionTwo === false &&
        pitchData.sectionThree === false
      ) {
        this[gameDataType].pitch_zone = "1";
      } else if (
        pitchData.sectionTwo !== false &&
        pitchData.sectionOne === false &&
        pitchData.sectionThree === false
      ) {
        this[gameDataType].pitch_zone = "2";
      } else if (
        pitchData.sectionThree !== false &&
        pitchData.sectionOne === false &&
        pitchData.sectionTwo === false
      ) {
        this[gameDataType].pitch_zone = "3";
      } else if (
        pitchData.sectionOne !== false &&
        pitchData.sectionTwo === false &&
        pitchData.sectionThree !== false
      ) {
        this[gameDataType].pitch_zone = "1,3";
      } else if (
        pitchData.sectionTwo !== false &&
        pitchData.sectionThree !== false &&
        pitchData.sectionOne === false
      ) {
        this[gameDataType].pitch_zone = "2,3";
      } else if (
        pitchData.sectionOne !== false &&
        pitchData.sectionThree === false &&
        pitchData.sectionTwo !== false
      ) {
        this[gameDataType].pitch_zone = "1,2";
      }
    },
    pitchChange(pitchData, gameType) {
      //let seasonStartDate = moment().subtract(1, "months").format("YYYY-MM-DD");
      //let seasonEndDate = moment().add(3, "months").format("YYYY-MM-DD");
      if (this.newGameData.matchDate !== "" || this.editGame.matchDate !== "") {
        if (this.newGameData.matchDate !== "") {
          this.setPitchZones(pitchData, "newGameData");
          /*seasonStartDate = moment(this.newGameData.matchDate)
             .subtract(1, "months")
             .format("YYYY-MM-DD");
           seasonEndDate = moment(this.newGameData.matchDate)
             .add(3, "months")
             .format("YYYY-MM-DD");*/
        }

        if (this.editGame.matchDate !== "") {
          this.setPitchZones(pitchData, "editGame");
          // Season date calculation removed as variables were unused
        }
      }
      this[gameType].pitch_id = pitchData.pitchId || pitchData.id;
      const pitch = this.pitches.filter(
        (pitch) => pitch.id == pitchData.pitchId,
      );
      this[gameType].address = pitch[0].address;
      this[gameType].locationName = pitch[0].name;
      this[gameType].postCode = pitch[0].postCode;
      this[gameType].pitchType = pitch[0].pitchType;
      this.togglePitchDetails = true;
    },
    async getAllPitchesForClub() {
      const userData = {
        clubId: this.userData.clubId,
        action: "getAllPitchesForClub",
      };
      const responce = await Pitches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.pitches = responce.data;
      }
    },
    sortedDataCall(sortedDataArray, arrayName = null) {
      if (!Array.isArray(sortedDataArray) || sortedDataArray.length === 0) {
        console.warn("Invalid sorted data received:", sortedDataArray);
        return;
      }

      // If arrayName is provided, use it directly (much more reliable)
      if (arrayName) {
        // Check if the array exists in the component's data
        if (arrayName in this && Array.isArray(this[arrayName])) {
          console.log(
            `Updating ${arrayName} with sorted data (${sortedDataArray.length} items)`,
          );
          this[arrayName] = [...sortedDataArray];
          return;
        } else {
          console.warn(
            `Array ${arrayName} does not exist in component data or is not an array`,
          );
          return;
        }
      }

      // Fallback logic for backward compatibility (when no arrayName is provided)
      const firstItem = sortedDataArray[0];

      // Check if it's game/training data by looking for common properties
      const isGameData =
        firstItem &&
        (Object.prototype.hasOwnProperty.call(firstItem, "gameType") ||
          Object.prototype.hasOwnProperty.call(firstItem, "matchDate") ||
          Object.prototype.hasOwnProperty.call(firstItem, "kickOffTime"));

      if (!isGameData) {
        console.warn(
          "Sorted data does not appear to be game/training data:",
          firstItem,
        );
        return;
      }

      // Determine which specific array to update based on array length match
      const sortedLength = sortedDataArray.length;

      // Check for games vs training by gameType
      const hasTrainingItems = sortedDataArray.some(
        (item) =>
          item.gameType &&
          (item.gameType.toLowerCase().includes("training") ||
            item.gameType.toLowerCase().includes("session")),
      );

      // Check for past vs upcoming by comparing dates
      const now = new Date();
      const hasPastItems = sortedDataArray.some((item) => {
        if (!item.matchDate) return false;
        const matchDate = new Date(item.matchDate);
        return matchDate < now;
      });

      const hasUpcomingItems = sortedDataArray.some((item) => {
        if (!item.matchDate) return false;
        const matchDate = new Date(item.matchDate);
        return matchDate >= now;
      });

      // Update the appropriate array based on the analysis
      if (hasTrainingItems) {
        if (
          hasPastItems &&
          this.pastTraining &&
          this.pastTraining.length === sortedLength
        ) {
          this.pastTraining = [...sortedDataArray];
        } else if (
          hasUpcomingItems &&
          this.thisWeeksTraining &&
          this.thisWeeksTraining.length === sortedLength
        ) {
          this.thisWeeksTraining = [...sortedDataArray];
        } else {
          // Fallback: try to match by length if date analysis is inconclusive
          if (this.pastTraining && this.pastTraining.length === sortedLength) {
            this.pastTraining = [...sortedDataArray];
          } else if (
            this.thisWeeksTraining &&
            this.thisWeeksTraining.length === sortedLength
          ) {
            this.thisWeeksTraining = [...sortedDataArray];
          }
        }
      } else {
        // It's game data
        if (
          hasPastItems &&
          this.pastGames &&
          this.pastGames.length === sortedLength
        ) {
          this.pastGames = [...sortedDataArray];
        } else if (
          hasUpcomingItems &&
          this.thisWeeksGames &&
          this.thisWeeksGames.length === sortedLength
        ) {
          this.thisWeeksGames = [...sortedDataArray];
        } else {
          // Fallback: try to match by length if date analysis is inconclusive
          if (this.pastGames && this.pastGames.length === sortedLength) {
            this.pastGames = [...sortedDataArray];
          } else if (
            this.thisWeeksGames &&
            this.thisWeeksGames.length === sortedLength
          ) {
            this.thisWeeksGames = [...sortedDataArray];
          }
        }
      }
    },
    dateRangeReset() {
      // When browsing a past season, "reset" means the whole selected season.
      this.dateRange = localStorage.getItem("selectedSeasonYear")
        ? {
            startDate: localStorage.getItem("currentPlayingseasonStartDate"),
            endDate: localStorage.getItem("currentPlayingseasonEndDate"),
          }
        : {
            startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
            endDate: moment().add(2, "months").format("YYYY-MM-DD"),
          };

      this.getSelectedTeamsEvents(
        this.formatMatchDate(this.dateRange.startDate),
        this.formatMatchDate(this.dateRange.endDate),
      );
    },
    async fullSeasonCheckBox() {
      if (this.fullSeasonCheckBoxData === true) {
        const playingseasonStartDate = this.selectedTeam.season_start_date;
        const playingseasonEndDate = this.extendSeasonEndDateToFullYear();

        await this.getSelectedTeamsEvents(
          playingseasonStartDate,
          playingseasonEndDate,
        );
        await this.getGamePerformanceAnalysisData(
          playingseasonStartDate,
          playingseasonEndDate,
        );
        // Keep the Training sub-tab in sync — previously it stayed on the
        // last range until the user manually re-opened the Training tab.
        this.getTrainingPerformanceReportForTeam();
        // getAllGamesAttendeesByTeamId is already called inside getSelectedTeamsEvents
      } else {
        this.performanceDateRangeSelected();
      }
    },
    async performanceDateRangeSelected(handleDate) {
      if (handleDate !== undefined) {
        const pickedDatesData = JSON.parse(JSON.stringify(handleDate));
        this.dateRange.startDate = this.formatMatchDate(pickedDatesData[0]);
        this.dateRange.endDate = this.formatMatchDate(pickedDatesData[1]);
      } else {
        this.dateRange.startDate = this.formatMatchDate(
          this.dateRange.startDate,
        );
        this.dateRange.endDate = this.formatMatchDate(this.dateRange.endDate);
      }

      await this.getSelectedTeamsEvents(
        this.dateRange.startDate,
        this.dateRange.endDate,
      );

      await this.getGamePerformanceAnalysisData(
        this.formatMatchDate(this.dateRange.startDate),
        this.formatMatchDate(this.dateRange.endDate),
      );
      // Refresh Training stats whenever the date range changes so toggling
      // sub-tabs doesn't show numbers from an earlier period.
      this.getTrainingPerformanceReportForTeam();
    },
    async dateRangeSelected(handleDate) {
      const pickedDatesData = JSON.parse(JSON.stringify(handleDate));
      this.dateRange.startDate = this.formatMatchDate(pickedDatesData[0]);
      this.dateRange.endDate = this.formatMatchDate(pickedDatesData[1]);

      await this.getSelectedTeamsEvents(
        this.dateRange.startDate,
        this.dateRange.endDate,
      );
    },
    // home_team_goals is always the selected team's goals and away_team_goals
    // the opposition's — this is the convention used everywhere the score is
    // shown (the past-games card, the match report modal, the result-entry
    // form). The games.home_team flag only records venue and is unreliable
    // (NULL/0 for ~80% of games), so it must NOT drive win/loss logic.
    checkGameResult(game) {
      const scored = Number(game.home_team_goals) || 0;
      const conceded = Number(game.away_team_goals) || 0;

      if (scored > conceded) return "W";
      if (scored === conceded) return "D";
      return "L";
    },
    addNewGameresultModalClose() {
      this.editGame = this.emptyEditGameData();
    },
    addNewGameresultModal(game, modelId) {
      this.editGame = game;
      this.showModal(modelId);
    },
    occuranceModalClose() {
      this.gameDeleteEditoccuranceValue = null;
    },
    checkUserIsAttendingGame() {
      let responce = false;
      if (this.selectedGameAttendees.length > 0) {
        this.selectedGameAttendees.filter((game) => {
          if (String(game.user_id) === String(this.userData.id)) {
            responce = game.going == 1 ? true : false;
          }
        });
      }

      return responce;
    },
    populatePlayerAttendanceData() {
      if (
        !this.teamsAttendedGamesAndTrainingData ||
        !Array.isArray(this.teamsAttendedGamesAndTrainingData)
      ) {
        this.teamsAttendedGamesAndTrainingData = [];
        this.addDefaultDataToCurrentTeam();
        return;
      }

      // Build a stats lookup keyed by player id
      const statsByPlayerId = {};
      this.teamsAttendedGamesAndTrainingData.forEach((game) => {
        if (Number(game.going) !== 1) return;
        const pid = String(game.user_id);
        if (!statsByPlayerId[pid]) {
          statsByPlayerId[pid] = {
            gameAttendance: 0,
            trainingAttendance: 0,
            cupGameAttendance: 0,
            friendlyAttendance: 0,
            teamTrainingSessions: 0,
            scTrainingSessions: 0,
            ownTrainingSessions: 0,
          };
        }
        const s = statsByPlayerId[pid];
        const gt = (game.gameType || "").toLowerCase();
        const tst = game.training_session_type || "";

        if (
          gt === "training" ||
          tst === "S&C" ||
          tst === "Team Training" ||
          tst === "Own Training"
        ) {
          s.trainingAttendance += 1;
          if (tst === "S&C") {
            s.scTrainingSessions += 1;
          } else if (tst === "Own Training") {
            s.ownTrainingSessions += 1;
          } else {
            s.teamTrainingSessions += 1;
          }
        } else if (gt.includes("cup")) {
          s.cupGameAttendance += 1;
        } else if (gt.includes("friendly") || gt.includes("amical")) {
          s.friendlyAttendance += 1;
        } else {
          // Everything else is treated as a league/competitive game
          s.gameAttendance += 1;
        }
      });

      // Replace currentTeam with a new array so Vue picks up the changes
      this.currentTeam = this.currentTeam.map((player) => {
        const s = statsByPlayerId[String(player.id)] || {
          gameAttendance: 0,
          trainingAttendance: 0,
          cupGameAttendance: 0,
          friendlyAttendance: 0,
          teamTrainingSessions: 0,
          scTrainingSessions: 0,
          ownTrainingSessions: 0,
        };
        return {
          ...player,
          gameAttendance: s.gameAttendance,
          trainingAttendance: s.trainingAttendance,
          cupGameAttendance: s.cupGameAttendance,
          friendlyAttendance: s.friendlyAttendance,
          teamTrainingSessions: s.teamTrainingSessions,
          scTrainingSessions: s.scTrainingSessions,
          ownTrainingSessions: s.ownTrainingSessions,
          totalMins: player.totalMins || 0,
          avgRpe: player.avgRpe !== undefined ? player.avgRpe : null,
        };
      });
    },
    async populatePlayerStats() {
      try {
        const response = await Games.find({
          action: "getTeamPlayerStats",
          teamId: this.selectedTeam.id,
          season_start_date: this.selectedTeam.season_start_date,
          season_end_date: this.extendSeasonEndDateToFullYear(),
        });

        if (response && response.data && response.data.success) {
          const stats = response.data.playerStats || {};
          this.currentTeam = this.currentTeam.map((player) => {
            const playerStats = stats[String(player.id)];
            if (playerStats) {
              return {
                ...player,
                totalMins: playerStats.totalMins || 0,
                avgRpe: playerStats.avgRpe || null,
                minsSource: playerStats.dominantSource || null,
                eyeballMins: playerStats.eyeballMins || 0,
                coachMins: playerStats.coachMins || 0,
                autoMins: playerStats.autoMins || 0,
              };
            }
            return player;
          });
        }
      } catch (error) {
        console.error("Error fetching team player stats:", error);
      }
    },
    getMinsSourceTooltip(player) {
      const parts = [];
      if (player.eyeballMins > 0) parts.push(`${player.eyeballMins} Eyeball`);
      if (player.coachMins > 0) parts.push(`${player.coachMins} Coach`);
      if (player.autoMins > 0) parts.push(`${player.autoMins} Auto`);
      return parts.join(" · ") || "No data";
    },
    getRpeBadgeClass(rpe) {
      if (rpe === null) return "";
      if (rpe < 5) return "rpe-low";
      if (rpe <= 7) return "rpe-medium";
      return "rpe-high";
    },
    async getAllGamesAttendeesByTeamId(startDate, endDate) {
      if (startDate === "object") {
        this.dateRange.startDate = this.formatMatchDate(startDate);
        this.dateRange.endDate = this.formatMatchDate(endDate);
      }
      const userData = {
        teamId: this.selectedTeam.id,
        season_start_date: startDate,
        season_end_date: endDate,
        action: "getAllGamesAttendeesByTeamId",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.teamsAttendedGamesAndTrainingData = responce.data;
        this.populatePlayerAttendanceData();
        this.populatePlayerStats();
      }
    },
    async getAllAttendeesForAGame() {
      const userData = {
        userId: this.userData.id,
        kickOffTime: this.selectedGame.kickOffTime,
        teamId: this.selectedGame.teamId,
        action: "getAllAttendeesForAGame",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });
      if (!responce) return;
      this.selectedGameAttendees = this.checkForInjuredPlayers(responce.data);
      this.noResponsePlayers();
    },
    checkForInjuredPlayers(attendeeList) {
      return attendeeList;
    },
    setResponce(responceType) {
      if (responceType === "Yes") {
        this.selectedGame.going = 1;
        this.selectedGame.notGoing = 0;
        this.selectedGame.noResponse = 0;
        this.selectedGame.injured = 0;
      }
      if (responceType === "No") {
        this.selectedGame.notGoing = 1;
        this.selectedGame.going = 0;
        this.selectedGame.noResponse = 0;
        this.selectedGame.injured = 0;
      }

      if (responceType === "Injured") {
        this.selectedGame.injured = 1;
        this.selectedGame.going = 0;
        this.selectedGame.notGoing = 0;
        this.selectedGame.noResponse = 0;
      }
    },
    addInjuryToPlayer() {
      this.currentTeam = this.currentTeam.map((player) => {
        const hasInjury = this.allPlayerInATeamInjuryReports.some((injury) => {
          // Compare ids as strings — the player.id can come back as either
          // a number or a numeric string depending on the source endpoint.
          if (String(player.id) !== String(injury.player_id)) return false;
          // Trim + lowercase the recovered check so values like " Fully
          // recovered" or "fully recovered" don't leak through as "still
          // injured".
          const status = (injury.injury_status || "").trim().toLowerCase();
          return status !== "fully recovered";
        });
        player.injury = hasInjury;
        return player;
      });
    },
    async getAllPlayerInClubInjuryReports() {
      const userData = {
        clubId: this.selectedTeam.clubId,
        season_start_date: this.selectedTeam.season_start_date,
        season_end_date: this.selectedTeam.season_end_date,
        action: "getAllPlayerInClubInjuryReports",
      };

      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.allPlayerInATeamInjuryReports = responce.data;
        this.addInjuryToPlayer();
      }
    },
    async getAllPlayerInATeamInjuryInformation() {
      const userData = {
        teamId: this.selectedTeam.id,
        action: "getAllPlayerInATeamInjuryInformation",
      };

      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.allPlayerInATeamInjuryReports = responce.data;
        this.addInjuryToPlayer();
      }
    },
    async handlePlayerStats(
      matchDate,
      gameType,
      responseType,
      playerId,
      selectedGame,
    ) {
      await checkIfMinsStatsDataExists(
        matchDate,
        gameType,
        responseType,
        playerId,
        selectedGame,
      );
    },
    /*async checkIfMinsStatsDataExists(matchDate, gameType, responceType, id) {
      const data = {
        action: "getPlayerMinsPerformanceDataForDate",
        session_date: matchDate,
        player_id: id,
      };
      await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        }
      );
 
      responce.data !== false
        ? this.editDayMinsStatsData(
          matchDate,
          gameType,
          responceType,
          id,
          responce.data.id
        )
        : this.addDayMinsStatsData(matchDate, gameType, responceType, id);
    },*/
    makeSelectedDayPlayerDataObject(matchDate, gameType, id) {
      this.selectedDayPlayerData = {
        id: 0,
        player_id: id,
        playing_down_level: 0,
        playing_up_level: 0,
        session_date: matchDate,
        session_distance: 0,
        session_mins: 0,
        session_type: gameType,
        total_absolute_high_speed_distance: 0,
        maximum_velocity: 0,
        max_vel_max: 0,
        accelerations_total_efforts: 0,
        decelerations_total_efforts: 0,
        meterage_per_minute: 0,
      };
    },
    async editDayMinsStatsData(matchDate, gameType, responceType, id, minId) {
      this.makeSelectedDayPlayerDataObject(matchDate, gameType, id);
      if (responceType === "Yes") {
        gameType === "Training"
          ? (this.selectedDayPlayerData.session_mins = 75)
          : (this.selectedDayPlayerData.session_mins = 90);
      } else {
        this.selectedDayPlayerData.session_mins = 0;
      }

      const data = {
        action: "editDayMinsStatsData",
        ...this.selectedDayPlayerData,
        id: minId,
        mins_source: "auto",
      };
      await PlayerPhysicalPerformance.find(data).catch((error) => {
        console.log(error);
      });
    },
    async addDayMinsStatsData(matchDate, gameType, responceType, id) {
      this.makeSelectedDayPlayerDataObject(matchDate, gameType, id);
      if (responceType === "Yes") {
        gameType === "Training"
          ? (this.selectedDayPlayerData.session_mins = 75)
          : (this.selectedDayPlayerData.session_mins = 90);
      } else {
        this.selectedDayPlayerData.session_mins = 0;
      }
      this.selectedDayPlayerData.mins_source = "auto";
      const data = {
        action: "addDayMinsStatsData",
        data: this.selectedDayPlayerData,
      };
      await PlayerPhysicalPerformance.find(data).catch((error) => {
        console.log(error);
      });
    },
    async gameResponce(responceType, userId) {
      this.setResponce(responceType);
      let selectedUserId = userId || this.userData.id;
      let teamAgeGroup = "";

      this.clubTeams.map((team) => {
        if (team.id === Number(this.selectedGame.teamId)) {
          teamAgeGroup = team.age_group;
        }
      });
      const userData = {
        gameId: this.selectedGame.id,
        userId: selectedUserId,
        kickOffTime: this.selectedGame.kickOffTime,
        going: this.selectedGame.going,
        noResponse: this.selectedGame.noResponse,
        injured: this.selectedGame.injured,
        notGoing: this.selectedGame.notGoing,
        teamId: this.selectedGame.teamId,
        gameType: this.selectedGame.gameType,
        age_group: teamAgeGroup || "",
        action: "setUserGameResponse",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce && responce.status === 200) {
        // Only close modal if player is setting their own response
        const isCoachAction = userId && userId !== this.userData.id;
        if (!isCoachAction) {
          this.hideModal("viewGameDetails");
        }
        this.getAllAttendeesForAGame();
        this.getAllGamesAttendeesByTeamId(
          this.dateRange.startDate,
          this.dateRange.endDate,
        );
        this.handlePlayerStats(
          this.selectedGame.matchDate,
          this.selectedGame.gameType,
          responceType,
          selectedUserId,
          this.selectedGame,
        );
        this.gameResponceValueChange = "";
      }
    },
    setMonToSundayWeekDates() {
      const year = JSON.stringify(moment().year());
      const monday = moment()
        .year(year)
        .isoWeek(this.weekSelectedNumber)
        .day("monday")
        .startOf("day");
      this.selectedWeekMonSunday =
        monday.format("MMM D - ") + monday.add(6, "days").format("D YYYY");
      // this.depatchMonToSundayWeekDatesInLocalStorage();
    },
    toggleRecurringEvent() {
      if (this.recurringEvent === false) {
        this.newGameData.recurringEventType = null;
      }
    },
    editDeleteGameOptionsModal(game, modelId, type) {
      this.modalTypeNmae = type;
      if (type !== "Edit") {
        this.selectedGame = game;
        this.showModal(modelId);
      } else {
        this.editGame = structuredClone(game);
        this.loadSessionContentForGame(game);
        if (this.gameDeleteEditoccuranceValue === null) {
          this.converTimesForUI();
          this.showModal("editGames");
        } else {
          this.showModal(modelId);
        }
      }
    },
    showGameDetails(game, modelId) {
      this.selectedGame = game;
      this.getAllAttendeesForAGame();
      this.loadViewGameSessionContent(game);
      this.showModal(modelId);
    },
    async loadViewGameSessionContent(game) {
      this.viewGameSessionContent = [];
      if (!game || game.gameType !== "Training" || !game.id) return;
      this.loadingViewGameContent = true;
      try {
        const responce = await TrainingWeek.getSessionDrills(game.id);
        this.viewGameSessionContent = Array.isArray(responce.data)
          ? responce.data
          : [];
      } catch (error) {
        console.error("Error loading session content:", error);
      } finally {
        this.loadingViewGameContent = false;
      }
    },
    async bulkMarkAttendance(responseType) {
      if (this.noResponsePlayersList.length === 0) return;
      this.bulkUpdating = true;
      try {
        for (const player of [...this.noResponsePlayersList]) {
          this.setResponce(responseType);
          let teamAgeGroup = "";
          this.clubTeams.forEach((team) => {
            if (team.id === Number(this.selectedGame.teamId)) {
              teamAgeGroup = team.age_group;
            }
          });
          const userData = {
            gameId: this.selectedGame.id,
            userId: player.id,
            kickOffTime: this.selectedGame.kickOffTime,
            going: this.selectedGame.going,
            noResponse: this.selectedGame.noResponse,
            injured: this.selectedGame.injured,
            notGoing: this.selectedGame.notGoing,
            teamId: this.selectedGame.teamId,
            gameType: this.selectedGame.gameType,
            age_group: teamAgeGroup || "",
            action: "setUserGameResponse",
          };
          await Games.find(userData);
        }
        await this.getAllAttendeesForAGame();
        this.getAllGamesAttendeesByTeamId(
          this.dateRange.startDate,
          this.dateRange.endDate,
        );
      } catch (err) {
        console.error("Bulk attendance update error:", err);
      } finally {
        this.bulkUpdating = false;
      }
    },
    setClubTeamnewGameData(selectedTeam) {
      this.newGameData.teamId = selectedTeam.id;
      this.newGameData.teamName = selectedTeam.teamName;
    },
    async getUserGamesByTeam(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce && responce.data.length > 0) {
        this.userData = responce.data[0];
        const userData = responce.data[0];
        this.$store.dispatch(USER_POPULATE, { userData });
        return true;
      }
    },
    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce && responce.data.length > 0) {
        this.userData = responce.data[0];
        const userData = responce.data[0];
        this.$store.dispatch(USER_POPULATE, { userData });
        return true;
      }
    },
    showModal(modelId) {
      // Map old modal IDs to new visibility properties
      const modalMap = {
        addEditGames: "showAddEditGames",
        editGames: "showEditGames",
        viewGameDetails: "showViewGameDetails",
        viewGameDeleteEditOptions: "showViewGameDeleteEditOptions",
        addNewGameresultModal: "showAddNewGameresultModal",
        matchReportModal: "showMatchReportModal",
        gameAnalysisModal: "showGameAnalysisModal",
        addHomeworkModal: "showAddHomeworkModal",
        viewHomeworkModal: "showViewHomeworkModal",
      };

      if (modalMap[modelId]) {
        this[modalMap[modelId]] = true;
      } else {
        // Fallback for any modals not in the map - log warning instead of using $bvModal
        console.warn(
          `Modal '${modelId}' not found in modalMap. Please add it to the mapping.`,
        );
      }
    },
    hideModal(modelId) {
      // Map old modal IDs to new visibility properties
      const modalMap = {
        addEditGames: "showAddEditGames",
        editGames: "showEditGames",
        viewGameDetails: "showViewGameDetails",
        viewGameDeleteEditOptions: "showViewGameDeleteEditOptions",
        addNewGameresultModal: "showAddNewGameresultModal",
        matchReportModal: "showMatchReportModal",
        gameAnalysisModal: "showGameAnalysisModal",
        addHomeworkModal: "showAddHomeworkModal",
        viewHomeworkModal: "showViewHomeworkModal",
      };

      if (modalMap[modelId]) {
        this[modalMap[modelId]] = false;
      }
      if (modelId === "showViewGameDetails") {
        this.playerAvailabilityTab = "going-tab";
      }
    },
    showEditAddGamesModal(type, gameData) {
      this.editMode = false;
      this.showTeamChange = false;

      if (type === "edit") {
        this.emptySlectedGameData();
        this.converTimesForUI();
        this.addEditGames = gameData;
        this.editMode = true;
        this.loadSessionContentForGame(gameData);
        this.showModal("editGames");
      } else {
        this.emptyNewGameData();
        this.sessionContent = { drills: [], programmes: [] };
        let today = moment();
        this.weeklyDate = today._d;
        this.setClubTeamnewGameData(this.selectedTeam);
        //this.setTheWeekNumber(this.weeklyDate);
        //this.newSessionData.userId = this.selectedUserValue;
        this.showModal("addEditGames");
      }
      // this.coachesUsersData = this.getCoachesUsersData;
    },
    onTrainingContentSelected(selection) {
      this.sessionContent = {
        drills: selection.drills,
        programmes: selection.programmes,
      };
      this.showTrainingContentPicker = false;
    },
    removeSessionDrill(drillId) {
      this.sessionContent = {
        ...this.sessionContent,
        drills: this.sessionContent.drills.filter((d) => d.id !== drillId),
      };
    },
    removeSessionProgramme(programmeId) {
      this.sessionContent = {
        ...this.sessionContent,
        programmes: this.sessionContent.programmes.filter(
          (p) => p.id !== programmeId,
        ),
      };
    },
    async loadSessionContentForGame(game) {
      this.sessionContent = { drills: [], programmes: [] };
      if (!game || game.gameType !== "Training" || !game.id) return;
      try {
        const responce = await TrainingWeek.getSessionDrills(game.id);
        const rows = Array.isArray(responce.data) ? responce.data : [];
        this.sessionContent = {
          drills: rows
            .filter((row) => row.drill_id)
            .map((row) => ({ id: row.drill_id, name: row.drill_name })),
          programmes: rows
            .filter((row) => row.programme_id)
            .map((row) => ({ id: row.programme_id, title: row.programme_title })),
        };
      } catch (error) {
        console.error("Error loading session content:", error);
      }
    },
    async saveSessionContent(gameId) {
      if (!gameId) return;
      try {
        await TrainingWeek.saveSessionDrills({
          gameId: gameId,
          drillIds: this.sessionContent.drills.map((d) => d.id),
          programmeIds: this.sessionContent.programmes.map((p) => p.id),
          assignedBy: this.userData.id,
        });
      } catch (error) {
        console.error("Error saving session content:", error);
      }
    },
    emptySlectedGameData() {
      this.selectedGame = "";
    },
    emptyEditGameData() {
      this.editGame = {
        address: "",
        away_team_goal_scorers: null,
        away_team_goals: "0",
        endTime: "",
        gameType: "",
        home_team_goal_scorers: null,
        home_team_goals: "0",
        id: "",
        kickOffTime: "",
        locationName: "",
        matchDate: "",
        meetTime: "",
        notes: "",
        opposition: "",
        pitchType: "",
        postCode: "",
        recurringEventType: null,
        result_added: "0",
        stripType: "",
        teamId: "",
        teamName: "",
        pitch_id: "",
        pitch_zone: null,
        home_team: false,
      };
    },
    emptyNewGameData() {
      this.newGameData = {
        opposition: "",
        kickOffTime: "",
        matchDate: "",
        locationName: "",
        address: "",
        postCode: "",
        stripType: "",
        meetTime: "",
        endTime: "",
        notes: "",
        gameType: "Training",
        teamId: "",
        teamName: "",
        pitchType: "",
        recurringEventType: null,
        home_team_goals: 0,
        away_team_goals: 0,
        away_team_goal_scorers: null,
        home_team_goal_scorers: null,
        result_added: 0,
        pitch_id: "",
        pitch_zone: null,
        home_team: false,
      };
    },
    tabChange(tabValue, selectedTabValue) {
      this[tabValue] = selectedTabValue;

      if (selectedTabValue === "full-team-tab") {
        this.getAllTrialistsForTeam();
      }

      if (selectedTabValue === "team-performance-tab") {


        this.getGamePerformanceAnalysisData(
          this.selectedTeam.season_start_date,
          this.selectedTeam.season_end_date,
        );
      }

      if (selectedTabValue === "teams-over-games-training-tab") {
        this.getTrainingPerformanceReportForTeam();
      }

      if (selectedTabValue === "team-documents-tab") {
        this.getDocumentUploadsByTeamId();
      }

      if (selectedTabValue === "team-attendance-tab") {
        this.teamsAttendedGamesAndTrainingBuild();
      }

      if (selectedTabValue === "homework-tab") {
        this.populateTeamVideoLinkData();
        if (localStorage.getItem("currentPlayingseasonStartDate") === null) {
          let year = moment().year();

          localStorage.setItem(
            "currentPlayingseasonStartDate",
            this.selectedTeam.season_start_date,
          );
          localStorage.setItem(
            "currentPlayingseasonEndDate",
            this.selectedTeam.season_end_date,
          );

          localStorage.setItem("currentPlayingSeason", `${year}`);
        }
        this.populateTeamVideoLinkData();
        this.getAllHomeworkForTeam();
      }
      if (selectedTabValue === "team-gps-tab") {
        this.loadSelectedGameForTeamMinsPerformanceData(
          this.selectedTeam,
          null,
        );
      }

      if (selectedTabValue === "league-tab") {
        // Externally mapped teams (Dribl/COMET) get the TeamLeaguePanel;
        // everything else falls back to the legacy Scottish FA CAS table.
        this.showExternalLeaguePanel = this.teamHasExternalLeague(
          this.selectedTeam,
        );
        if (!this.showExternalLeaguePanel) {
          this.getScottishFADataCall();
        }
      }

      if (selectedTabValue === "full-team-chat") {
        this.teamChatMessages = collection(db, "team_chat_messages");
        this.deleteFireBaseDocs(db);
      }

      this.$nextTick(() => {
        this.handleTabScroll();
      });

      //pastGames
    },
    async deleteFireBaseDocs() {
      const less30dAYSDate = `${dayjs().subtract(30, "days").format("YYYY-MM-DD")}T00:00:00.000Z`;

      // Tear down any previous subscription so we don't accumulate listeners
      // when the user switches teams or chat-tabs multiple times.
      if (typeof this.chatListener === "function") {
        try {
          this.chatListener();
        } catch (e) {
          /* noop */
        }
        this.chatListener = null;
      }

      try {
        const q = query(
          this.teamChatMessages,
          where("createdDate", "<=", less30dAYSDate),
        );

        // onSnapshot returns an unsubscribe fn — store it (not the snapshot).
        this.chatListener = onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            deleteDoc(doc.ref);
          });
        });
      } catch (error) {
        console.error("Error deleting documents: ", error);
      }
    },
    async getTrainingPerformanceReportForTeam() {
      this.loadingTrainingPerformance = true;
      const data = {
        action: "getTrainingPerformanceReportForTeam",
        teamId: this.selectedTeam.id,
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data && responce.data.length > 0) {
        const attendanceRecords = responce.data;
        const totalSessions = this.pastTraining.length;
        const totalAttendees = attendanceRecords.length;
        this.teamTrainingStats.averageAttendance =
          totalSessions > 0 ? Math.round(totalAttendees / totalSessions) : 0;
      } else {
        this.teamTrainingStats.averageAttendance = 0;
      }
      this.loadingTrainingPerformance = false;
    },
    resetPerformanceFilters() {
      this.fullSeasonCheckBoxData = true;
      this.fullSeasonCheckBox();
    },
    getAllTrainingSessionIdsForTeam() {
      return this.pastTraining.map((trainingSession) => trainingSession.id);
    },
    emptyThisWeeksTrainingAndGames() {
      this.thisWeeksGames = [];
      this.thisWeeksTraining = [];
    },
    checkForAdminNavigation(e) {
      if (typeof e === "string") {
        return e;
      } else if (!e.target) {
        this.adminNavigationSelectedTeam = true;
        return e.teamName;
      } else {
        return e.target.value;
      }
    },
    setSelectedTeam(e) {
      this.loadingStuff = true;
      const teamData = this.checkForAdminNavigation(e);

      if (
        this.userHasMoreThanOneAccount !== null ||
        this.userData.userType === "Admin"
      ) {
        this.showallTeams = false;
      }

      let selectedTeamData = this.clubTeams.find(function (team) {
        return team.teamName === teamData;
      });

      this.selectedTeam = selectedTeamData;
      this.applyPastSeasonToSelectedTeam();
      this.under16 = this.showIfUnderU16(this.selectedTeam.age_group);
      // Don't clobber a past-season override (set by the global season selector).
      if (!localStorage.getItem("selectedSeasonYear")) {
        localStorage.setItem(
          "currentPlayingseasonStartDate",
          this.selectedTeam.season_start_date,
        );
        localStorage.setItem(
          "currentPlayingseasonEndDate",
          this.selectedTeam.season_end_date,
        );
      }

      // Default date range to season dates for this team
      if (
        this.selectedTeam.season_start_date &&
        this.selectedTeam.season_end_date
      ) {
        this.dateRange = {
          startDate: this.selectedTeam.season_start_date,
          endDate: this.selectedTeam.season_end_date,
        };
      }

      this.getUserByTeamId();
      this.setClubTeamnewGameData(selectedTeamData);
      //this.selectedTeam.league_link !== ""
      this.getgadyflLeagueTableData();
      // : (this.leagueTeams = []);
      this.emptyThisWeeksTrainingAndGames();
      this.getSelectedTeamsEvents(
        this.formatMatchDate(this.dateRange.startDate),
        this.formatMatchDate(this.dateRange.endDate),
      );

      // load eyeball data for team
      if (
        this.userData.clubId === "ptfc-2085XH" ||
        this.userData.clubId === "stjfc-2085XH"
      ) {
        this.getEyeBallPlayerStatsByTeam(selectedTeamData.age_group);
        this.getEyeBallTeamsGames();
      }

      // CAS fixtures endpoint is cometExplorer-gated; skip the guaranteed 403
      // on tiers without it (e.g. grassroots).
      if (this.hasFeature("cometExplorer")) {
        this.getCASFixtures();
      }
      this.loadingStuff = false;
    },
    setTeamAcademyLevel() {
      if (
        this.userData.clubId === "ptfc-2085XH" ||
        this.userData.clubId === "dfc-2085XH" ||
        this.userData.clubId === "ffc-2085XH" ||
        this.userData.clubId === "stjfc-2085XH"
      ) {
        return "Performance";
      }

      if (this.userData.clubId === "kfc-2085XH") {
        return "Elite";
      }
    },
    async getScottishFADataCall(forceRefresh = false) {
      const ageGroup = this.selectedTeam.age_group;
      const team = this.setTeamAcademyLevel();
      const startYear = localStorage
        .getItem("currentPlayingseasonStartDate")
        ?.substring(0, 4);
      const endYear = localStorage
        .getItem("currentPlayingseasonEndDate")
        ?.substring(2, 4);
      const Season = `${startYear}-${endYear}`;

      // Reset state for each call so previous error/empty messages clear.
      this.competitionError = null;
      this.competitionUnsupported = false;
      this.competitionName = "";

      let mappings = {};
      if (ageGroup === "2007" || ageGroup === "2009") {
        mappings = {
          Performance: {
            2007: { id: "35296952", name: "CAS Performance Under 19s League" },
            2009: { id: "35285882", name: "CAS Performance Under 17s League" },
          },
          Elite: {
            2007: { id: "35298382", name: "CAS Elite Under 19s League" },
            2009: { id: "35298119", name: "CAS Elite Under 17s League" },
          },
        };
      }

      const teamMapping = mappings[team];
      if (!teamMapping || !teamMapping[ageGroup]) {
        // No league configured for this team / age group.
        this.competitionUnsupported = true;
        this.leagueTableHtml = "";
        return;
      }

      const { id: SelectedLeagueId, name } = teamMapping[ageGroup];
      this.competitionName = name;

      // Cache key keeps the response per (team, ageGroup, season) so toggling
      // tabs in a session doesn't keep re-fetching upstream.
      const cacheKey = `${team}|${ageGroup}|${Season}`;
      if (
        !forceRefresh &&
        this._competitionCache &&
        this._competitionCache[cacheKey]
      ) {
        this.leagueTableHtml = this.highlightOwnTeamRow(
          this._competitionCache[cacheKey],
        );
        return;
      }

      this.competitionLoading = true;
      try {
        const faData = {
          action: "getScottishFAData",
          Season,
          SelectedLeagueId,
          ddlComp_65342003: SelectedLeagueId,
          XRequestedWith: "XMLHttpRequest",
        };

        const response = await GadyflLeaguetable.find(faData);
        const rawHtml = (response && response.data) || "";

        if (!this._competitionCache) this._competitionCache = {};
        this._competitionCache[cacheKey] = rawHtml;

        this.leagueTableHtml = this.highlightOwnTeamRow(rawHtml);
      } catch (error) {
        console.error("Error fetching Scottish FA data:", error);
        this.competitionError =
          "Couldn't load the competition table. Please check your connection and try again.";
        this.leagueTableHtml = "";
      } finally {
        this.competitionLoading = false;
      }
    },

    // Wrap the row whose team name matches the coach's selected team in a
    // highlight class. The Scottish FA HTML is div-based (display: table-*
    // via #scottish-FA-table styles); the team name lives in the cell with
    // class .table-cell.team — so we match against THAT, not the row's
    // full text content (which previously caused false positives where a
    // position number like "17" was a substring of "Under 17's").
    highlightOwnTeamRow(html) {
      if (!html) return "";
      const teamName = (this.selectedTeam && this.selectedTeam.teamName) || "";
      if (!teamName) return html;

      // Normalise both names: lowercase, drop common boilerplate (F.C., FC,
      // Under, U17, year suffixes, possessives) and collapse whitespace.
      // After normalising "Partick Thistle FC Under 17's" and
      // "Partick Thistle FC Under 17's" both become "partick thistle".
      const normalise = (s) =>
        (s || "")
          .toLowerCase()
          .replace(/\bf\.?c\.?\b/g, "")
          .replace(/\bunder\s*\d+s?\b/g, "")
          .replace(/\bu\d+'?s?\b/g, "")
          .replace(/\bacademy\b/g, "")
          .replace(/['’`.]/g, "")
          .replace(/[^a-z0-9 ]/g, " ")
          .replace(/\s+/g, " ")
          .trim();

      const target = normalise(teamName);
      if (target.length < 3) return html;

      try {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;
        const rows = wrapper.querySelectorAll("tr, .table-row");
        rows.forEach((row) => {
          // Prefer the dedicated team-name cell. Falls back to <td>/text
          // only if the markup isn't div-based.
          const teamCell = row.querySelector(
            ".table-cell.team, td.team, .team-name",
          );
          const cellText = teamCell ? teamCell.textContent : row.textContent;
          const candidate = normalise(cellText);
          if (!candidate) return;
          // Require an exact normalised match OR a tight word-boundary
          // containment (e.g. "partick thistle" inside "partick thistle ladies").
          if (
            candidate === target ||
            candidate.includes(target) ||
            target.includes(candidate)
          ) {
            row.classList.add("competition-own-team-row");
          }
        });
        return wrapper.innerHTML;
      } catch (e) {
        return html;
      }
    },

    refreshCompetitionTable() {
      this.getScottishFADataCall(true);
    },
    // Which internal teams are linked to an external league (Dribl/COMET/...).
    // Drives Competition tab visibility and panel-vs-CAS-table selection.
    async loadExternalLeagueMappings() {
      try {
        const res = await ExternalLeagues.getInternalTeams(this.userData.clubId);
        this.externalMappedTeamIds = (res.data || [])
          .filter((t) => t.mapped_league_id)
          .map((t) => t.id);
      } catch (e) {
        this.externalMappedTeamIds = [];
      }
    },
    teamHasExternalLeague(team) {
      return !!team && this.externalMappedTeamIds.includes(team.id);
    },
    async getgadyflLeagueTableData() {
      const data = {
        action: "getAllOppositionTeams",
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.leagueTeams = responce.data;
      }
      /*if (responce.hasOwnProperty("data")) {
        if (responce.data === "") {
          console.log(responce);
        } else {
          let table = responce.data;
          this.leagueTable = responce.data;
          var htmlObject = document.createElement("div");
          htmlObject.innerHTML = table;
          var htmlTable = htmlObject.getElementsByTagName("table");
          for (const r of htmlTable[0].getElementsByTagName("tr")) {
            for (const c of r.getElementsByTagName("td")) {
              if (c.getElementsByTagName("div")[0]) {
                let div = c.getElementsByTagName("div")[0];
                this.leagueTeams.push(
                  div.getElementsByTagName("span")[0].innerText
                );
              }
            }
          }
        }
      }*/
    },
    filterGameEvents(allGameEventData) {
      // Use moment day-level comparisons rather than string >=/< — more
      // robust to mixed formats (date-only vs full ISO timestamp) and
      // makes the "today counts as upcoming" rule explicit.
      const today = moment().startOf("day");
      const isUpcoming = (g) =>
        moment(g.matchDate).startOf("day").isSameOrAfter(today);
      const isPast = (g) => moment(g.matchDate).startOf("day").isBefore(today);
      const sortAsc = (a, b) =>
        moment(a.matchDate).valueOf() - moment(b.matchDate).valueOf();
      const sortDesc = (a, b) =>
        moment(b.matchDate).valueOf() - moment(a.matchDate).valueOf();

      this.thisWeeksGames = allGameEventData
        .filter((g) => g.gameType !== "Training" && isUpcoming(g))
        .sort(sortAsc);

      this.thisWeeksTraining = allGameEventData
        .filter((g) => g.gameType === "Training" && isUpcoming(g))
        .sort(sortAsc); // soonest first, matches games

      this.pastGames = allGameEventData
        .filter((g) => g.gameType !== "Training" && isPast(g))
        .sort(sortDesc); // most recent first

      this.pastTraining = allGameEventData
        .filter((g) => g.gameType === "Training" && isPast(g))
        .sort(sortDesc);
    },
    resetTrainingAndGamesData() {
      this.thisWeeksGames = [];
      this.thisWeeksTraining = [];
    },
    averageFromArrayOfNumbers(numbers) {
      if (!numbers || numbers.length === 0) return 0;
      let sum = 0;

      for (const num of numbers) {
        sum += Number(num) || 0;
      }

      return sum / numbers.length;
    },
    async getGamePerformanceAnalysisData(season_start_date, season_end_date) {
      if (!this.hasFeature("performanceReviews")) return;
      const data = {
        action: "getGamePerformanceAnalysisData",
        teamId: this.selectedTeam.id,
        season_start_date: season_start_date,
        season_end_date: season_end_date,
      };

      this.loadingPerformanceData = true;
      try {
        const responce = await Games.find(data);

        if (responce && responce.data && responce.data.length > 0) {
          this.gamePerformanceAnalysisData = responce.data;
          // averageGamePerformanceAnalysisData is now a computed off
          // gamePerformanceAnalysisData, so updating the source is enough.

        } else {
          this.gamePerformanceAnalysisData = [];
        }
      } catch (error) {
        console.error("Failed to load performance data:", error);
        this.$toast.error("Failed to load performance data");
        this.gamePerformanceAnalysisData = [];
      } finally {
        this.loadingPerformanceData = false;
      }
    },
    async getAllTeamsPastResults(
      gameStartDateAndTime,
      gameEndDateAndTime,
      allTeamsIds,
    ) {
      const data = {
        action: "getAllTeamsPastResults",
        teamIds: allTeamsIds,
        gameStartDateAndTime: gameStartDateAndTime,
        gameEndDateAndTime: gameEndDateAndTime,
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.allTeamsGameResultsData = responce.data;
      }
    },
    getAllTeamsIdsFromTeamsEvents() {
      return this.clubTeams.map((event) => event.teamId);
    },
    async getTeamsGamesGoalScorers() {
      const data = {
        action: "getTeamsGamesGoalScorers",
        teamId: this.selectedTeam.id,
        pastGamesIds: this.pastGames.map((game) => game.id),
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.allGameGoalScorersData = responce.data;
      }
    },
    async getSelectedTeamsEvents(startDate, endDate) {
      this.loadingStuff = true;
      this.resetTrainingAndGamesData();
      // Guard against junk dates (e.g. moment's "Invalid date") reaching the
      // backend, where new DateTime() would throw a fatal on PHP 8.3.
      const safeDate = (v) =>
        v && String(v).trim().toLowerCase() !== "invalid date" &&
        !isNaN(new Date(v).getTime())
          ? v
          : null;
      const data = {
        action: "getAllGamesEventsById",
        teamId: this.selectedTeam.id,
        gameFromDate: safeDate(startDate),
        gameToDate: safeDate(endDate),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });
      if (!responce) {
        this.loadingStuff = false;
        return;
      }
      this.selectedGamesEvents = responce.data;
      if (Array.isArray(responce.data) && responce.data.length > 0) {
        this.filterGameEvents(responce.data);
        this.getTeamsGamesGoalScorers();
      } else if (
        typeof responce.data === "object" &&
        Object.keys(responce.data).length > 0
      ) {
        this.filterGameEvents(responce.data);
        this.getTeamsGamesGoalScorers();
      } else {
        this.thisWeeksGames = [];
        this.thisWeeksTraining = [];
        this.pastGames = [];
        this.pastTraining = [];
      }

      if (this.userData.userType === "Admin") {
        const allTeamsIds = this.getAllTeamsIdsFromTeamsEvents();
        // Scope past results to the active season window — the current season,
        // or a past season when one is selected in the header. Previously the
        // current-season case used a rolling "last 3 months → today" window,
        // which bled last season's tail into the view during the off-season.
        this.getAllTeamsPastResults(
          localStorage.getItem("currentPlayingseasonStartDate"),
          localStorage.getItem("currentPlayingseasonEndDate"),
          allTeamsIds,
        );
      }

      this.getGameAnalysisData();
      this.getAllGamesAttendeesByTeamId(
        this.dateRange.startDate,
        this.dateRange.endDate,
      );
      this.populateGamesWithGPSdata();
      this.loadingStuff = false;
    },
    async getTeamsByCoachid() {
      const data = {
        action: "getTeamsByCoachid",
        coach_id: this.userData.id,
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data.length > 0) {
        this.clubTeams = this.removeDuplicates(responce.data, "id");
        this.allTeamDataBeforFilterApplied = this.clubTeams;
        this.selectedTeam = responce.data[0];
        this.applyPastSeasonToSelectedTeam();
        this.getUserByTeamId();
        this.setClubTeamnewGameData(this.selectedTeam);
        this.getgadyflLeagueTableData();
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
      }
    },
    // When the global season selector is set to a PAST season, the team's
    // own (current-season) date columns must be overridden so every query
    // that reads `this.selectedTeam.season_start_date/end_date` filters to
    // the selected past season instead of the live one.
    applyPastSeasonToSelectedTeam() {
      if (this.selectedTeam && localStorage.getItem("selectedSeasonYear")) {
        const start = localStorage.getItem("currentPlayingseasonStartDate");
        const end = localStorage.getItem("currentPlayingseasonEndDate");
        // Only override the team's real (current-season) dates when the stored
        // past-season dates are actually usable. A null / empty / "Invalid date"
        // here would blank season_start_date/end_date, and every date-filtered
        // query (games, training, Full Season) would then send null → no data.
        const usable = (v) =>
          v &&
          String(v).trim().toLowerCase() !== "invalid date" &&
          !isNaN(new Date(v).getTime());
        if (usable(start) && usable(end)) {
          this.selectedTeam.season_start_date = start;
          this.selectedTeam.season_end_date = end;
        }
      }
    },
    async getTeamsByUserId() {
      this.userHasMoreThanOneAccount === null;
      if (this.userData.userType === "Coach") {
        this.getTeamsByCoachid();
      } else {
        const data = {
          action: "getTeamsDataById",
          userId: this.userData.id,
        };

        if (
          this.userData.userType === "Admin" ||
          this.userData.userType === "Coach"
        ) {
          data.clubId = this.userData.clubId;
        }
        const responce = await Teams.find(data).catch((error) => {
          console.log(error);
        });
        if (!responce) return;
        this.allTeamDataBeforFilterApplied = responce.data;
        this.clubTeams = responce.data;

        this.selectedTeam = responce.data[0];
        this.applyPastSeasonToSelectedTeam();

        if (this.$route.query.teamData !== undefined) {
          this.setSelectedTeam(JSON.parse(this.$route.query.teamData));
        }

        this.getUserByTeamId();
        this.setClubTeamnewGameData(this.selectedTeam);
        this.getgadyflLeagueTableData();
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.populateCoachesData();
        this.under16 = this.showIfUnderU16(this.selectedTeam.age_group);
      }
    },
    deleteGames() {
      // The "All occurances" radio is currently commented out in the
      // template, so the only reachable value is "one-Delete". The
      // bulk-delete branch (and its empty deleteAllGames stub) was a no-op.
      this.deleteOnlyOneGame();
    },
    // Bulk Training Session Management Methods
    toggleBulkTrainingMode() {
      if (!this.bulkTrainingMode) {
        this.selectedTrainingSessions = [];
      }
    },
    isTrainingSelected(session) {
      return this.selectedTrainingSessions.some((s) => s.id === session.id);
    },
    toggleTrainingSelection(session) {
      const index = this.selectedTrainingSessions.findIndex(
        (s) => s.id === session.id,
      );
      if (index === -1) {
        this.selectedTrainingSessions.push(session);
      } else {
        this.selectedTrainingSessions.splice(index, 1);
      }
    },
    selectAllTrainingSessions() {
      const allTraining = [...this.thisWeeksTraining, ...this.pastTraining];
      this.selectedTrainingSessions = [...allTraining];
    },
    clearTrainingSelection() {
      this.selectedTrainingSessions = [];
    },
    // Fires on the b-modal @hidden event for both bulk training modals.
    // Esc / backdrop close otherwise leaves selectedTrainingSessions populated,
    // so the next time the modal opens it carries stale selections.
    onBulkTrainingModalClose() {
      // Don't wipe the selection if a successful save is currently in flight
      // (the success path already clears it). Only clear when the user has
      // cancelled out of the dialog.
      if (this.isBulkDeleting || this.isBulkEditing) return;
      this.selectedTrainingSessions = [];
    },
    openBulkDeleteTrainingModal() {
      if (this.selectedTrainingSessions.length > 0) {
        this.showBulkDeleteTrainingModal = true;
      }
    },
    openBulkEditTrainingModal() {
      if (this.selectedTrainingSessions.length > 0) {
        // Reset the bulk edit form
        this.bulkEditTrainingData = {
          kickOffTime: "",
          endTime: "",
          locationName: "",
          address: "",
          postCode: "",
          notes: "",
          pitch_id: "",
        };
        this.showBulkEditTrainingModal = true;
      }
    },
    async confirmBulkDeleteTraining() {
      this.isBulkDeleting = true;
      this.loadIngStuffText = "Deleting training sessions";

      try {
        const deletePromises = this.selectedTrainingSessions.map((session) => {
          const data = {
            ...session,
            amendment_type: "one-Delete",
            action: "saveOneDeletedGame",
            season_start_date: localStorage.getItem(
              "currentPlayingseasonStartDate",
            ),
            season_end_date: this.extendSeasonEndDateToFullYear(),
          };
          return Games.find(data);
        });

        await Promise.all(deletePromises);

        this.$toast.success(
          `Successfully deleted ${this.selectedTrainingSessions.length} training session(s)`,
          {
            title: "Success",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          },
        );

        // Refresh the training sessions list
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );

        // Reset bulk mode
        this.selectedTrainingSessions = [];
        this.bulkTrainingMode = false;
        this.showBulkDeleteTrainingModal = false;
      } catch (error) {
        console.error("Error deleting training sessions:", error);
        this.$toast.error(
          "Failed to delete some training sessions. Please try again.",
          {
            title: "Error",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "danger",
          },
        );
      } finally {
        this.isBulkDeleting = false;
      }
    },
    async confirmBulkEditTraining() {
      this.isBulkEditing = true;
      this.loadIngStuffText = "Updating training sessions";

      try {
        const editPromises = this.selectedTrainingSessions.map((session) => {
          // Build the update data, only including non-empty fields
          const updateData = { ...session };

          if (this.bulkEditTrainingData.kickOffTime) {
            // Combine existing date with new time
            const date = session.matchDate;
            updateData.kickOffTime = `${date}T${this.bulkEditTrainingData.kickOffTime}:00`;
          }

          if (this.bulkEditTrainingData.endTime) {
            const date = session.matchDate;
            updateData.endTime = `${date}T${this.bulkEditTrainingData.endTime}:00`;
          }

          if (this.bulkEditTrainingData.locationName) {
            updateData.locationName = this.bulkEditTrainingData.locationName;
          }

          if (this.bulkEditTrainingData.address) {
            updateData.address = this.bulkEditTrainingData.address;
          }

          if (this.bulkEditTrainingData.postCode) {
            updateData.postCode = this.bulkEditTrainingData.postCode;
          }

          if (this.bulkEditTrainingData.notes) {
            updateData.notes = this.bulkEditTrainingData.notes;
          }

          if (this.bulkEditTrainingData.pitch_id) {
            updateData.pitch_id = this.bulkEditTrainingData.pitch_id;
          }

          const data = {
            ...updateData,
            action: "saveEditGame",
            season_start_date: localStorage.getItem(
              "currentPlayingseasonStartDate",
            ),
            season_end_date: this.extendSeasonEndDateToFullYear(),
          };

          return Games.find(data);
        });

        await Promise.all(editPromises);

        this.$toast.success(
          `Successfully updated ${this.selectedTrainingSessions.length} training session(s)`,
          {
            title: "Success",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          },
        );

        // Refresh the training sessions list
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );

        // Reset bulk mode
        this.selectedTrainingSessions = [];
        this.bulkTrainingMode = false;
        this.showBulkEditTrainingModal = false;
      } catch (error) {
        console.error("Error editing training sessions:", error);
        this.$toast.error(
          "Failed to update some training sessions. Please try again.",
          {
            title: "Error",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "danger",
          },
        );
      } finally {
        this.isBulkEditing = false;
      }
    },
    async getAllTrialistsForTeam() {
      let data = {
        teamId: this.selectedTeam.id,
        clubId: this.selectedTeam.clubId,
        action: "getAllTrialistsForTeam",
      };
      const responce = await Trialists.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.status === 200) {
        this.trialistsData = responce.data.filter(
          (trialists) => trialists.outcome === 0,
        );
      }
    },
    async deleteAllOccurrencesOfAGame() {
      let data = {
        id: this.selectedGame.id,
        action: "deleteGame",
      };
      await Games.find(data).catch((error) => {
        console.log(error);
      });
    },
    async deleteOnlyOneGame() {
      let data = {
        ...this.selectedGame,
        amendment_type: "one-Delete",
        action: "saveOneDeletedGame",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      this.hideModal("viewGameDeleteEditOptions");
      this.loadIngStuffText = "Deleting";
      this.loadingStuff = true;

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });
      if (
        responce &&
        (responce.data === "Game added to games_removed_changed." ||
          responce.data === "game removed.")
      ) {
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.loadingStuff = false;
      }
    },
    checkIfResultNeedsUpdated() {
      if (this.editGame.team !== undefined) {
        this.editGame.team === "home"
          ? (this.editGame.home_team_goals += 1)
          : (this.editGame.away_team_goals += 1);
      }
    },
    async editProgrammeSubmit(modelId) {
      this.loadIngStuffText = "Saving";
      this.loadingStuff = true;
      if (modelId == "addNewGameresultModal") {
        this.editGame.result_added = 1;
        this.editGame.goal = 1;
        this.checkIfResultNeedsUpdated();
        if (this.editGame.goal_type === undefined) {
          this.editGame.goal_type = "Open play";
        }
      }
      if (modelId !== "addNewGameresultModal") {
        this.converTimesForDB("editGame");
      }
      const data = {
        ...this.editGame,
        action: "saveEditGame",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.status === 200) {
        if (
          modelId === "editGames" &&
          this.editGame.gameType === "Training" &&
          this.editGame.id
        ) {
          // Persist attached training content (also clears removed items)
          await this.saveSessionContent(this.editGame.id);
        }
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.resetGameResultsGoalSelection();
        this.hideModal(modelId);
        this.loadingStuff = false;
        this.$toast.info(responce.data, {
          title: "success",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.sendFBNotificationMessage(
          `${this.editGame.gameType} - ${this.formatISOStringDateAndTime(
            this.editGame.kickOffTime,
          )} - ${this.formatDateForHuman(this.editGame.matchDate)} has changed`,
          `Please review the changes to ${
            this.editGame.gameType
          } - ${this.formatDateForHuman(
            this.editGame.matchDate,
          )} - ${this.formatMatchDate(this.editGame.matchDate)}`,
          [this.selectedTeam.age_group],
          undefined,
          true,
        );
      }
    },
    async sendFBNotificationMessage(
      title,
      body,
      ageGroup,
      playerId,
      showToast,
      chatId,
    ) {
      if (ageGroup.length !== 0) {
        if (ageGroup.includes("2009")) {
          ageGroup.push("2010");
        }
        if (ageGroup.includes("2010")) {
          ageGroup.push("2009");
        }
        if (ageGroup.includes("2007")) {
          ageGroup.push("2008");
        }
        if (ageGroup.includes("2008")) {
          ageGroup.push("2007");
        }
      }

      const data = {
        action: "sendFBNotificationMessage",
        title: title,
        body: body,
        link: `${window.location.origin}/login`,
        age_group: ageGroup,
        player_id: playerId,
        clubId: this.userData.clubId,
        chatId: chatId,
      };
      const responce = await Chat.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.status === 200 && showToast === true) {
        this.$toast.info("Notification sent", {
          title: "Notification sent",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    addVideo(category) {
      if (!category || typeof category !== "string") {
        console.error("Invalid category provided.");
        return;
      }

      const videoData = {
        id: null,
        player_id: this.selectedUserValue || null,
        video_name: "New Video",
        category: category.trim(),
        document_id: this.newHomeWorkData.id,
        video_url: "",
      };

      this.newHomeWorkData.videos = [...this.newHomeWorkData.videos, videoData];
    },
    removeVideo(index) {
      this.newHomeWorkData.videos.splice(index, 1);
    },
    populateFirstTeamSelectedData(event) {
      // In Vue 3 compat mode, b-form-select @change may pass a native Event object
      // instead of the value directly. Use the v-model bound selectedGameTypeOption instead.
      const value =
        this.selectedGameTypeOption || (typeof event === "string" ? event : "");

      // Handle training session sub-types (e.g. "Training:S&C")
      if (value && value.includes(":")) {
        const [gameType, sessionType] = value.split(":");
        this.newGameData.gameType = gameType;
        this.newGameData.training_session_type = sessionType;
      } else {
        this.newGameData.gameType = value;
        this.newGameData.training_session_type =
          value === "Training" ? "Team Training" : null;
      }

      if (value === "League game") {
        if (this.newGameData.opposition === "") {
          this.newGameData.opposition = this.leagueTeams[0].teamName;
          const otherEvent = {
            target: {
              value: this.leagueTeams[0].id,
            },
          };
          this.populateSelectedTeamVenue(otherEvent, "newGameData");
        }
      }
    },
    async addEditProgrammeSubmit() {
      // Past dates are allowed, but never silently: confirm, so a mis-typed
      // year is caught here rather than turning up as a phantom result.
      if (this.isDateInThePast(this.newGameData.matchDate)) {
        const when = this.formatMatchDate(this.newGameData.matchDate);
        const duplicate = this.findDuplicateFixture(this.newGameData);
        const warning = duplicate
          ? `\n\nThere is ALREADY a fixture against ${duplicate.opposition} on ` +
            `that date. Adding another will count the result twice in the team ` +
            `stats. Check the Games list before continuing.`
          : "";
        if (
          !window.confirm(
            `This ${this.newGameData.gameType || "game"} is dated ${when}, ` +
              `which is in the past.\n\nAdd it anyway?${warning}`,
          )
        ) {
          return;
        }
      }

      this.loadIngStuffText = "Saving";
      this.loadingStuff = true;
      this.hideModal("addEditGames");
      this.converTimesForDB("newGameData");
      const action = { action: "saveNewGame" };
      this.newGameData.home_team === true
        ? (this.newGameData.home_team = 1)
        : (this.newGameData.home_team = 0);
      const data = {
        ...this.newGameData,
        ...action,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data && responce.data.message === "Game added.") {
        if (
          this.newGameData.gameType === "Training" &&
          (this.sessionContent.drills.length > 0 ||
            this.sessionContent.programmes.length > 0)
        ) {
          await this.saveSessionContent(responce.data.gameId);
        }
        this.getSelectedTeamsEvents(
          this.formatMatchDate(this.dateRange.startDate),
          this.formatMatchDate(this.dateRange.endDate),
        );
        this.loadingStuff = false;
        let body = "";
        if (this.newGameData.gameType !== "Training") {
          body = `${this.newGameData.gameType} vs  ${
            this.newGameData.opposition
          }. Kickoff: ${this.formatISOStringDateAndTime(
            this.newGameData.kickOffTime,
          )} Meet: ${this.time(this.newGameData.meetTime)} Venue: ${
            this.newGameData.locationName
          } ${this.newGameData.address} ${this.newGameData.postCode}`;
        } else {
          body = `${
            this.newGameData.gameType
          } Kickoff: ${this.formatISOStringDateAndTime(
            this.newGameData.kickOffTime,
          )} Venue: ${this.newGameData.locationName} ${
            this.newGameData.address
          } ${this.newGameData.postCode}`;
        }
        this.sendFBNotificationMessage(
          this.newGameData.gameType,
          body,
          [this.selectedTeam.age_group],
          undefined,
          true,
        );
      }
    },
    addDefaultDataToCurrentTeam() {
      this.currentTeam = this.currentTeam.map((player) => {
        player.trainingAttendance = 0;
        player.gameAttendance = 0;
        player.cupGameAttendance = 0;
        player.friendlyAttendance = 0;
        player.totalMins = 0;
        player.avgRpe = null;
        player.teamTrainingSessions = 0;
        player.scTrainingSessions = 0;
        player.ownTrainingSessions = 0;
        return player;
      });
    },
    async getUserByTeamId() {
      this.currentTeam = [];
      const userData = {
        teamId: this.selectedTeam.id,
        action: "getUserByTeamId",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce && responce.data.length > 0) {
        this.currentTeam = responce.data;
        this.addDefaultDataToCurrentTeam();
        // Run injury + attendance/stats fetches concurrently and await both
        // so the table doesn't render with half-populated rows. Without the
        // await, injury flags can land after attendance has already mapped
        // the rows, leaving stale state on screen briefly.
        await Promise.all([
          this.getAllPlayerInClubInjuryReports(),
          this.getAllGamesAttendeesByTeamId(
            this.dateRange.startDate,
            this.dateRange.endDate,
          ),
        ]);
        this.listOfSelectedplayerIds = this.currentTeam.map(
          (player) => player.id,
        );
      }
    },
    converTimesForDB(objectName) {
      if (this[objectName].endTime !== "") {
        this[objectName].endTime = this.changeTimeToTimeAndDate(
          this[objectName].endTime,
          this.formatMatchDate(this[objectName].matchDate),
        );
      }

      if (this[objectName].meetTime !== "") {
        this[objectName].meetTime = this.changeTimeToTimeAndDate(
          this[objectName].meetTime,
          this.formatMatchDate(this[objectName].matchDate),
        );
      }

      if (this[objectName].kickOffTime !== "") {
        this[objectName].kickOffTime = this.changeTimeToTimeAndDate(
          this[objectName].kickOffTime,
          this.formatMatchDate(this[objectName].matchDate),
        );
      }

      if (this[objectName].matchDate !== "") {
        this[objectName].matchDate = this.formatMatchDate(
          this[objectName].matchDate,
        );
      }
    },
    converTimesForUI() {
      if (
        this.editGame.endTime !== undefined &&
        this.editGame.endTime !== "" &&
        this.editGame.endTime.includes("000Z")
      ) {
        this.editGame.endTime = this.changeTimeAndDateToTime(
          this.editGame.endTime,
        );
      }

      if (
        this.editGame.meetTime !== undefined &&
        this.editGame.meetTime !== "" &&
        this.editGame.meetTime.includes("000Z")
      ) {
        this.editGame.meetTime = this.changeTimeAndDateToTime(
          this.editGame.meetTime,
        );
      }

      if (
        this.editGame.kickOffTime !== undefined &&
        this.editGame.kickOffTime !== "" &&
        this.editGame.kickOffTime.includes("000Z")
      ) {
        this.editGame.kickOffTime = this.changeTimeAndDateToTime(
          this.editGame.kickOffTime,
        );
      }

      if (this.editGame.matchDate !== "") {
        this.editGame.matchDate = this.formatMatchDate(this.editGame.matchDate);
      }
    },
    setUser() {
      if (this.getProfile !== null) {
        this.userData = this.getProfile;
      }
    },
    dayMonthYear(date) {
      const m = moment(date);
      return m.isValid() ? m.format("D MMM YYYY") : "—";
    },
    formatDates(date) {
      return moment(date).format("DD MMM");
    },
    getDayFromDate(date) {
      return moment(date).format("dddd");
    },
    getMonthFromDate(date) {
      return moment(date).format("MMMM");
    },
    getDayDateFromDate(date) {
      const fullDate = moment(date.year)
        .month(date.month)
        .weekday(date.weekday);

      return moment(fullDate).format("D");
    },
    changeTimeToTimeAndDate(timeString, date) {
      return `${date}T${timeString}:00.000Z`;
    },
    changeTimeAndDateToTime(dateAndTime) {
      return dateAndTime.substring(11, 16);
    },
    formatISOStringDateAndTime(timeDateString) {
      return moment(timeDateString).utc().format("h:mm a");
    },
    formatMatchDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    shortKickoffTime(date) {
      return moment(date).format("h:mm a DD MMM");
    },
    time(date) {
      // Stored times are wall-clock-UTC (…THH:MM:00.000Z) — read with .utc()
      // so the meet time isn't shifted by the viewer's TZ (+1h in BST).
      return moment(date).utc().format("h:mm a");
    },
    getDayNumberFromDate(date) {
      return moment(date).format("D");
    },
    getDayAndDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },
    getTimeFromDate(date) {
      return moment(date).format("dddd, HH.mm");
    },
  },
};
</script>
<style scoped lang="scss">
// Red pulse beside a player's name when they have declared medical
// conditions (users.has_medical_conditions = 1). Detail lives on the profile.
.medical-flag {
  color: #dc2626;
  margin-left: 6px;
  font-size: 0.9em;
  vertical-align: middle;
}

/* Training content attached to a session (chips in add/edit game modals) */
.session-content-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.session-content-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 14px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid;

  &.chip-programme {
    background: #eff6ff;
    border-color: #93c5fd;
    color: #1d4ed8;
  }

  &.chip-drill {
    background: #f0fdf4;
    border-color: #86efac;
    color: #15803d;
  }

  button {
    background: none;
    border: none;
    padding: 0;
    margin-left: 2px;
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    color: inherit;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
}

.add-content-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Session content list in the view-game-details modal */
.session-content-section {
  margin: 1rem 0;
  padding: 0.9rem 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.session-content-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.6rem;

  i {
    color: #3b82f6;
  }
}

.session-content-empty {
  font-size: 0.84rem;
  color: #64748b;
  margin: 0;
  padding: 4px 0;
}

/* Section side-drawer layout (SectionNav). Fixed left rail; main team view
   content padded left to clear it. Mirrors the Profile page pattern. */
.team-page.with-drawer {
  --section-nav-w: 260px;
  padding-left: calc(var(--section-nav-w) + 28px);
  transition: padding-left 0.2s ease;
}
.team-page.with-drawer.nav-collapsed {
  --section-nav-w: 72px;
}
@media (max-width: 768px) {
  .team-page.with-drawer,
  .team-page.with-drawer.nav-collapsed {
    padding-left: 0;
  }
}

// Standard filter-row pattern — shared with leads / games / trialists /
// booking schedule. Local override for the date-range group so the picker
// doesn't get squashed at the standard 180px min.
// Parent `.tab-content` (defined in styles/index.scss) is display:flex with
// flex-wrap, so direct children that don't claim a full row will pack
// horizontally next to each other. The original `.search-filter` set
// `width: 100%; padding: 1rem` to take a full row and inset its content;
// match that here so the filter row sits above the games sections (rather
// than stacking 3-column with them) and its content lines up with the
// 1rem-inset siblings (`.cas-buttons`, `.bulk-actions-bar`, etc.).
.lead-tabs-filters {
  width: 100%;
  padding: 1rem;
  margin: 0.5rem 0 0.75rem;
}

.lead-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;

  .filter-group {
    display: flex;
    flex-direction: column;
    min-width: 180px;
    flex: 0 1 auto;

    &.games-date-range-group {
      min-width: 280px;
    }
  }

  .filter-label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }

  .filter-checkbox-inline {
    height: 38px;
    display: flex;
    align-items: center;
  }

  .filter-reset {
    height: 38px;
    padding: 0 0.85rem;
    font-size: 0.85rem;
    color: #6c757d;
    background: transparent;
    border: 1px solid #ced4da;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    align-self: flex-end;
    transition:
      background 0.15s,
      border-color 0.15s,
      color 0.15s;

    &:hover {
      background: #f8f9fa;
      border-color: #adb5bd;
      color: #212529;
    }
  }
}

.games-section-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem;
  padding-left: 1rem; // align with the 1rem-inset filter row + sibling buttons
}

.competition-tab {
  padding: 1rem;
  // The parent .tab-content is display:flex with flex-wrap. Flex items
  // default to min-width: auto which means they don't shrink below their
  // content size — that lets the wide league table push the whole tab
  // wider than the viewport on mobile. Forcing min-width:0 lets the inner
  // overflow-x: auto scroll container actually take effect.
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.competition-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.competition-refresh {
  // Inherit .filter-reset style; this is just a positioning override.
  align-self: center;
}

.competition-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
  color: #6c757d;

  .spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e4e6eb;
    border-top-color: #0d6efd;
    border-radius: 50%;
    animation: comp-spin 1s linear infinite;
    margin-bottom: 0.75rem;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

@keyframes comp-spin {
  to {
    transform: rotate(360deg);
  }
}

// Make the rendered FA table horizontally scrollable on narrow screens.
// The team column has a min-width of 366px in the global #scottish-FA-table
// rules, so the table naturally exceeds typical mobile widths — let users
// swipe the table sideways instead of breaking the layout.
.competition-table-scroll {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  // Subtle fade hint that there's content to scroll to. Optional polish.
  background:
    linear-gradient(to right, #fff 30%, rgba(255, 255, 255, 0)) 0 0,
    linear-gradient(to left, #fff 30%, rgba(255, 255, 255, 0)) 100% 0,
    radial-gradient(
        farthest-side at 0 50%,
        rgba(0, 0, 0, 0.12),
        rgba(0, 0, 0, 0)
      )
      0 0,
    radial-gradient(
        farthest-side at 100% 50%,
        rgba(0, 0, 0, 0.12),
        rgba(0, 0, 0, 0)
      )
      100% 0;
  background-repeat: no-repeat;
  background-size:
    40px 100%,
    40px 100%,
    14px 100%,
    14px 100%;
  background-attachment: local, local, scroll, scroll;
}

.competition-table-wrapper {
  // Inner wrapper carries the #scottish-FA-table id (set on the same
  // element). No layout changes here; it renders at its natural width
  // inside the scroll container.
}

// Highlight the coach's own team row in the rendered FA table. The
// upstream rows can be <tr> or div.table-row depending on markup, so the
// rule matches either via :deep with the shared class.
.competition-table-wrapper :deep(.competition-own-team-row),
:deep(#scottish-FA-table .competition-own-team-row) {
  background: #fff8e1 !important;
  border-left: 4px solid #ffc107;
  font-weight: 600;
}

.games-count-badge {
  display: inline-block;
  min-width: 1.5rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  background: #e7f1ff;
  color: #084298;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
}

.card-checkboxes {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;

  .card-icon {
    font-size: 1.2rem;
    cursor: pointer;
  }
}

.players-attendance-summary {
  .attendance-wrapper {
    height: 16rem;
    overflow-y: scroll;
    margin-bottom: 2rem;
    border: 2px solid #e6e2e2;
    background: #f9f9f9;
  }
}

.match-details {
  .details {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;

    .date-times-wrapper {
      width: 100%;
    }

    .header-text-bold {
      font-weight: bold;
    }

    i {
      height: 3rem;
      width: 2rem;
      display: block;
    }

    .times-wrapper {
      font-size: 0.8rem;
    }
  }

  a.map-link {
    display: block;
    border: none;
    padding: 0;

    .map-icon-text {
      display: flex;
      gap: 0.3rem;
    }
  }

  .venue-text {
    margin: 0;
  }
}

.cas-fixtures-modal {
  .game-wrapper {
    .match-details {
      border: 1px solid #212529;
      padding: 1rem;
      margin-bottom: 1rem;

      .game-info {
        text-transform: "title-case";

        .venue-time {
          display: flex;
          gap: 1rem;
        }
      }
    }

    .teams {
      font-size: 1.1rem;
      font-weight: bold;
    }
  }
}

// Availability section in game/training detail modal
.avail-section {
  margin-top: 1.25rem;
}

.avail-tabs {
  display: flex;
  gap: 0.25rem;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 0;
  overflow-x: auto;
}

.avail-tab {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.6rem 0.9rem;
  border: none;
  background: none;
  font-size: 0.85rem;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    color: #343a40;
    background: #f8f9fa;
  }

  &.active {
    color: #212529;
    border-bottom-color: #0d6efd;
  }

  i {
    font-size: 0.9rem;
  }
}

.avail-tab-count {
  background: #e9ecef;
  color: #495057;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.1rem 0.45rem;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;

  &.count-warn {
    background: #fff3bf;
    color: #945a00;
  }
}

.avail-panel {
  padding: 0.75rem 0;
}

.avail-player {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.5rem;
  border-bottom: 1px solid #f1f3f5;
  transition: background 0.15s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8f9fa;
    border-radius: 6px;
  }
}

.avail-player-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.avail-player-name {
  font-weight: 500;
  font-size: 0.9rem;
  color: #212529;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.avail-player-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.avail-player-comment {
  font-size: 0.78rem;
  color: #868e96;
  background: #f1f3f5;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  margin-top: 0.2rem;
}

.avail-status-icon {
  font-size: 1rem;
  flex-shrink: 0;

  &.going {
    color: #2b8a3e;
  }

  &.not-going {
    color: #c92a2a;
  }

  &.no-response {
    color: #ced4da;
  }

  &.injured {
    color: #e67700;
  }
}

.avail-change-select {
  flex-shrink: 0;
  font-size: 0.78rem;
  padding: 0.25rem 0.4rem;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  background: #fff;
  color: #495057;
  cursor: pointer;
  max-width: 100px;

  &:focus {
    outline: none;
    border-color: #0d6efd;
  }
}

.avail-bulk-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.5rem;
  margin-bottom: 0.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  flex-wrap: wrap;
}

.avail-bulk-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &.going {
    background: #d3f9d8;
    color: #087f23;

    &:hover:not(:disabled) {
      background: #b2f2bb;
    }
  }

  &.not-going {
    background: #ffe0e0;
    color: #c62828;

    &:hover:not(:disabled) {
      background: #ffc9c9;
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.avail-bulk-spinner {
  font-size: 0.8rem;
  color: #6c757d;
}

.avail-empty {
  text-align: center;
  padding: 2rem 1rem;
  color: #868e96;

  i {
    font-size: 2rem;
    display: block;
    margin-bottom: 0.5rem;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

/* Legacy player-list kept for any other usages */
.player-list {
  li {
    margin: 0;
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;

    &:last-child {
      border-bottom: none;
    }

    img.user-image-small {
      margin: 0;
      width: 3rem;
      height: 3rem;
    }
  }
}

.match-report-tab {
  gap: 1rem;
}

/* match-reports-status - kept for any other usages outside attendance tab */
.match-reports-status {
  border: 1px solid #bec3c7;
  padding: 0.5rem;
  margin-top: 0.5rem;

  .report-item {
    font-size: 0.9rem;
    display: block;

    span {
      display: block;
    }
  }
}

// Match Reports Overview Tab Styles
.match-reports-summary-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  h4 {
    color: #495057;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  .summary-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 1rem;

    .stat-item {
      text-align: center;
      padding: 1rem;
      border-radius: 6px;

      &.complete {
        background-color: #d4edda;
        border: 1px solid #c3e6cb;
      }

      &.incomplete {
        background-color: #fff3cd;
        border: 1px solid #ffeaa7;
      }

      &.missing {
        background-color: #f8d7da;
        border: 1px solid #f5c6cb;
      }

      .stat-number {
        display: block;
        font-size: 1.8rem;
        font-weight: bold;
        margin-bottom: 0.25rem;
      }

      .stat-label {
        display: block;
        font-size: 0.875rem;
        color: #6c757d;
        font-weight: 500;
      }
    }
  }
}

.report-category {
  margin-bottom: 1.5rem;

  h5 {
    color: #495057;
    margin-bottom: 0.75rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .player-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    margin-bottom: 0.5rem;
    border-radius: 6px;

    &.complete {
      background-color: #d4edda;
      border-left: 4px solid #28a745;
    }

    &.incomplete {
      background-color: #fff3cd;
      border-left: 4px solid #ffc107;
    }

    &.missing {
      background-color: #f8d7da;
      border-left: 4px solid #dc3545;
    }

    .player-name {
      font-weight: 500;
      color: #495057;
    }

    .report-status {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.875rem;
      color: #6c757d;
    }
  }
}

.empty-state,
.loading-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;

  p {
    margin-top: 1rem;
    font-size: 1.1rem;
  }
}

.loading-state {
  .spinner-border {
    margin-bottom: 1rem;
  }
}

.user-image-table {
  p {
    font-size: 0.8rem;
    margin-top: 0.5rem !important;
  }
}

button.btn.btn-outline-warning,
button.btn.btn-outline-danger {
  background: white;

  &:hover,
  &:focus {
    background: #ffc10c;
    color: white !important;
  }
}

.players-in-chat {
  margin-bottom: 2rem;
}

.col-wrapper-teams-gps {
  width: 100%;
  height: 100%;
}

.col-wrapper-teams-gps.pie-charts {
  .cols {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    .pie-chart-wrapper {
      width: 30%;

      .name-bar p {
        position: relative;
        margin: 0;
      }
    }
  }
}

.player-cv {
  border: 1px solid #a9b3bc;
  max-width: 1000px;
  padding: 2rem;
  overflow: scroll;

  .sessions-info {
    display: flex;
    flex-wrap: wrap;

    .video-wrapper {
      margin-bottom: 1rem;
    }

    .session-card {
      padding: 1rem;
      margin-bottom: 1rem;
      display: block;
    }
  }
}

.player-cv-content {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    width: 100%;
    height: 100%;
  }

  .form__item {
    display: grid;
  }
}

.homework-links {
  margin-bottom: 1rem;
}

.no-games-to-select-text {
  color: #b5a118;
  border: 1px solid #b5a118;
  padding: 1rem;
  border-radius: 6px;
}

.players-in-chat {
  margin-bottom: 2rem;
}

.match-report-header {
  border-bottom: 2px solid #dddddd;
  padding-bottom: 1rem;
  margin-bottom: 2rem;

  .logo-header-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    .user-photo-info {
      width: 200px;

      img {
        width: 100%;
      }
    }
  }
}

.name-bar {
  position: relative;

  p {
    position: absolute;
    top: 0;
    left: 7px;
  }
}

.match-report-modal-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;

  .team-average-score-col {
    border: 1px solid #dee2e6;
    padding: 1rem;
    height: 8rem;
    border-radius: 4px;

    .header {
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 1.7rem;
    }

    .number-score {
      text-align: center;
      font-size: 2rem;
      font-weight: bold;
    }
  }
}

.small-input {
  .form-control {
    width: 9rem;
  }
}

.dark-green {
  color: #57b88b;
}

.green {
  color: #57b88b;
}

.yellow {
  color: #fbd055;
}

.red {
  color: #e06670;
}

.key-ratings-table {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid #dee2e6;

  th,
  td {
    padding: 1rem;
  }

  th,
  td {
    text-align: center;
  }

  th:first-of-type,
  td:first-of-type {
    text-align: left;
  }
}

.homework-list {
  width: 100%;
  min-width: 33rem;
}

.team-tab-content {
  overflow: scroll;
}

.trialist {
  color: #b69144;
}

// Attendance Tab
.attendance-tab {
  padding: 1.5rem;
}

.attendance-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.attendance-date-picker {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .dp__main {
    min-width: 240px;
  }
}

.attendance-reset-btn {
  background: none;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  color: #6c757d;
  transition: all 0.2s;

  &:hover {
    background: #f8f9fa;
    color: #343a40;
  }
}

.attendance-season-toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
  color: #495057;
  cursor: pointer;
  user-select: none;

  input[type="checkbox"] {
    accent-color: #198754;
    width: 16px;
    height: 16px;
  }
}

.attendance-summary {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.attendance-summary-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 0.6rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.attendance-summary-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #212529;
}

.attendance-summary-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.attendance-table-wrap {
  overflow-x: auto;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  th,
  td {
    padding: 0.5rem 0.6rem;
    vertical-align: middle;
  }

  th {
    background: #f1f3f5;
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
    white-space: nowrap;
  }
}

.attendance-th-player {
  position: sticky;
  left: 0;
  z-index: 3;
  background: #f1f3f5 !important;
  min-width: 180px;
}

.attendance-th-avg {
  text-align: center;
  min-width: 60px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  .sort-icon {
    font-size: 0.7rem;
    margin-left: 0.2rem;
    opacity: 0.6;
  }

  &:hover {
    background: #e9ecef;

    .sort-icon {
      opacity: 1;
    }
  }
}

.attendance-th-event {
  text-align: center;
  padding: 0.3rem 0.2rem !important;
  width: 44px;
  min-width: 44px;
  max-width: 44px;
  height: 120px;
  vertical-align: bottom !important;
  position: relative;
}

.attendance-header-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  position: absolute;
  bottom: 3.4rem;
  left: 50%;
  transform-origin: bottom center;
  transform: translateX(-50%) rotate(-55deg);
  white-space: nowrap;
}

.attendance-event-type {
  display: inline-block;
  font-size: 0.6rem;
  font-weight: 700;
  padding: 0.1rem 0.3rem;
  border-radius: 3px;
  color: white;
  line-height: 1;

  &.event-match {
    background: #0d6efd;
  }

  &.event-training {
    background: #6c757d;
  }
}

.attendance-event-opp {
  font-size: 0.65rem;
  font-weight: 600;
  color: #343a40;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attendance-event-date {
  font-size: 0.6rem;
  color: #868e96;
}

.attendance-table tbody {
  tr {
    border-bottom: 1px solid #e9ecef;
    transition: background 0.15s;

    &:hover {
      background: #f8f9fa;
    }
  }

  tr:nth-child(even) {
    background: #fafbfc;

    &:hover {
      background: #f1f3f5;
    }
  }
}

.attendance-td-player {
  position: sticky;
  left: 0;
  z-index: 1;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 180px;
  white-space: nowrap;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.06);
}

tr:nth-child(even) .attendance-td-player {
  background: #fafbfc;
}

tr:hover .attendance-td-player {
  background: #f1f3f5;
}

.attendance-player-img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.attendance-player-name {
  font-weight: 500;
  color: #212529;
}

.attendance-td-avg {
  text-align: center;
}

.attendance-avg-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.8rem;
  min-width: 46px;
  text-align: center;

  &.avg-high {
    background: #d3f9d8;
    color: #087f23;
  }

  &.avg-mid {
    background: #fff3bf;
    color: #945a00;
  }

  &.avg-low {
    background: #ffe0e0;
    color: #c62828;
  }
}

.attendance-td-status {
  text-align: center;
  width: 44px;
  min-width: 44px;
  max-width: 44px;
}

.attendance-icon {
  font-size: 1.1rem;

  &.attended {
    color: #2b8a3e;
  }

  &.not-attended {
    color: #c92a2a;
  }

  &.no-response {
    color: #ced4da;
  }
}

.attendance-empty {
  text-align: center;
  padding: 4rem 2rem;
  color: #868e96;

  i {
    font-size: 3rem;
    display: block;
    margin-bottom: 1rem;
  }

  p {
    font-size: 0.95rem;
  }
}

.documents-tab {
  display: flex;
  flex-wrap: wrap;

  .documents-wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .document {
    max-width: 14rem;
    text-align: center;
    padding: 1rem;
    margin: 1rem;
    border-radius: 4px;
    box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
    border: 1px solid transparent;

    &:hover,
    &:focus {
      border: 1px solid $secondary-color;
    }

    h3 {
      margin-top: 1rem;
      font-size: 1rem;
      overflow: hidden;
      white-space: nowrap;
      text-transform: inherit;
    }

    img {
      width: 40%;
    }
  }
}

.performance-bar span {
  font-weight: bold;
  border-radius: 100px;
}

.past-games-performance {
  width: 100%;

  .main-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    div {
      border: 1px solid #e1e5e9;
      padding: 0.5rem;
      min-width: 10rem;

      h3 {
        font-size: 0.8rem;
      }

      span {
        font-size: 2rem;
        font-weight: 700;
      }
    }
  }
}

.past-games-performance-analysis {
  margin-top: 2rem;
}

.games-performance-analysis-stats {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;

  .stats-overview {
    border: 1px solid #e1e5e9;
    border-top: 3px solid;
    padding: 1rem;
    min-width: 100%;

    h3 {
      font-size: 1rem;
    }

    .stats-items {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      p {
        min-width: 14rem;
      }
    }
  }
}

.padding-left {
  padding-left: 2.3rem;
}

.venue-text {
  position: relative;
  margin-left: 2.3rem;
  display: block;
  margin-bottom: 1rem;
}

.venue-text .b-icon {
  position: absolute;
  left: -37px;
  top: 0;
}

.team-chat-wrapper {
  padding: 1rem;
}

.season_info {
  margin-top: 1rem;

  p {
    font-size: 1.3rem;
    margin: 0;
  }
}

.player-photo {
  border-radius: 100px;
  border: 1px solid #c3cdd5;
  width: 50px;
  height: 50px;
}

.injury-table-style {
  border: 1px solid red;
  border-left: 3px solid red;
}

.team-content {
  display: flex;
  flex-wrap: wrap;
}

.player-game-numbers {
  ul.tabs {
    margin-bottom: 1rem;
  }
}

.filter-small {
  height: 2.5rem;
  border: transparent;
  color: #9ea7b0;

  &:hover,
  &:focus {
    background: transparent;
    color: #7c838a;
    border: transparent;
    outline: transparent;
    box-shadow: 0 0 0 0rem;
  }
}

.remove-icon-button {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
}

.very-small-two-numbers {
  width: 5rem;
}

.w-a-style {
  .centre-icon {
    text-align: center;
  }

  .green-success {
    color: #08a10f;
    border: 1px solid #08a10f;
    text-align: center;
    border-radius: 100px;
    display: block;
    width: 3rem;
    height: 3rem;
    line-height: 1rem;
    margin: 1rem auto 0 auto;
    background: #d5f1d6;
  }
}

.red-warning {
  color: white;
  background: #d28d9e;
}

.members-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.members-table {
  width: 100%;
  table-layout: auto;

  th,
  td {
    white-space: nowrap;
    vertical-align: middle;
  }
}

.rpe-badge {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #fff;
}

.mins-source-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
  cursor: help;

  &.mins-source-eyeball {
    background: #4caf50;
  }

  &.mins-source-coach {
    background: #2196f3;
  }

  &.mins-source-manual {
    background: #2196f3;
  }

  &.mins-source-auto {
    background: #bdbdbd;
  }
}

.rpe-low {
  background: #4caf50;
}

.rpe-medium {
  background: #ff9800;
}

.rpe-high {
  background: #f44336;
}

.attacting-options,
.defending-options {
  border: 1px solid #ced4da;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
}

.game-analysis-details {
  margin-bottom: 1rem;

  p {
    margin: 0;
  }
}

.team-chat-wrapper {
  width: 100%;

  .team-chat-list-item {
    padding: 2rem;
    margin-bottom: 2rem;
    padding: 1rem;
    background: white;
    padding: 1rem;
    border-radius: 4px;
    cursor: pointer;
    max-width: 43rem;
    -webkit-box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
    box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
    border: 1px solid transparent;
    margin-bottom: 2rem;

    &:hover,
    &:focus {
      border: 1px solid $secondary-color;
      cursor: pointer;
    }

    .chat-item {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;

      p {
        margin: 0;
      }

      img {
        width: 6rem;
      }
    }

    .player-game-responce {
      button {
        margin: 0;
      }
    }
  }
}

.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.emoji-invoker {
  position: absolute;
  top: 2rem;
  right: 15%;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}

.emoji-invoker:hover {
  transform: scale(1.1);
}

.emoji-invoker > svg {
  fill: #b1c6d0;
}

/* Emoji picker wrapper styles */
.emoji-picker-wrapper {
  position: relative;
  display: inline-block;
}

.emoji-picker-popup {
  position: absolute;
  z-index: 1000;
  top: 100%;
  left: 0;
  margin-top: 5px;
  box-shadow: 1px 1px 8px #c7dbe6;
  border-radius: 0.5rem;
  max-width: 300px;
}

.chat-messages {
  overflow-y: scroll;
  min-height: 30rem;
  max-height: 100rem;
  padding: 1rem;
  position: relative;
  background: #fafafa;

  .chat-details {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    img {
      height: 2rem;
      border-radius: 100px;
      border: 1px solid;
    }

    .chat-wrapper {
      background: #ece9e9;
      margin: 0 1rem 1rem 0;
      padding: 1rem;
      border-radius: 10px;
      color: #13519d;
      max-width: 90%;

      .chat-name-time-wrapper {
        display: flex;
        align-items: baseline;

        span.chat-name {
          display: block;
          font-size: 0.9rem;
          color: #2a8ce2;
        }

        span.chat-time {
          font-size: 0.8rem;
        }
      }
    }
  }

  .chat-details.receiver {
    justify-content: flex-end;

    .chat-wrapper {
      background: #c9ffe0;
    }
  }
}

.message-input {
  position: sticky;
  width: 100%;
  background: white;
  padding: 1rem;
  left: 0;
  bottom: 0;

  .form__item {
    input.form__input,
    #textarea-default {
      width: 90%;
      margin-right: 1rem;
      font-weight: normal !important;
    }

    #save_chat_maeesage {
      position: absolute;
      right: 0%;
      top: 16px;
    }
  }
}

.user-select-wrapper {
  height: 20rem;
}

.player-list {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  display: block;
  justify-content: space-between;

  img {
    width: 50px;
    margin-right: 0.5rem;
    border-radius: 100px;
    height: 50px;
    margin-bottom: 0.5rem;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    background: #f8f8f8;
  }
}

.form__input.full-size {
  width: 98%;
}

.teams {
  span {
    display: inline-block;
    font-size: 1.1rem;
    line-height: 0.6rem;
    margin-bottom: 0.5rem;
    color: $text-primary;
  }
}

.eyeballGame {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: top;
  align-items: top;
  gap: 2rem;
  flex-wrap: wrap;

  .eyeballGameDetails {
    .teamLines {
      .starting-xi {
        img {
          width: 50px;
          height: 50px;
          border-radius: 100px;
        }
      }

      .tabs-wrapper {
        padding: 1rem;
      }
    }
  }
}

.cas-buttons {
  display: flex;
  gap: 1rem;
  padding: 0 0 1rem 1rem;

  button {
    background: #019e53;
  }
}

@media screen and (min-width: 1024px) {
  .games-performance-analysis-stats {
    .stats-overview {
      border: 1px solid #e1e5e9;
      border-top: 3px solid;
      padding: 1rem;
      min-width: 30.8rem;
    }
  }

  .eyeballGameVideo {
    width: 1019px;
    height: 573px;

    video {
      width: 100%;
      height: auto;
    }
  }
}

/* Homework Section Styles */
.homework-container {
  padding: 1rem;
}

.homework-section-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8ecef;
  overflow: hidden;
}

.homework-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #e8f4fd 0%, #d4e8f7 100%);
  border-bottom: 1px solid #c5ddf0;

  .section-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    i {
      font-size: 1.25rem;
      color: #1976d2;
    }

    h3 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #1565c0;
    }

    .badge-count {
      background: #1976d2;
      color: white;
      padding: 0.2rem 0.6rem;
      border-radius: 12px;
      font-size: 0.75rem;
      font-weight: 600;
    }
  }
}

.add-homework-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1565c0;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
  }
}

.homework-section-content {
  padding: 0;
}

.homework-table-wrapper {
  overflow-x: auto;

  .desktop-only {
    display: table;
  }

  .mobile-only {
    display: none;
  }
}

.homework-table-modern {
  width: 100%;
  border-collapse: collapse;

  thead {
    th {
      background: #f8fafb;
      padding: 0.875rem 1rem;
      font-size: 0.8rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #6c757d;
      letter-spacing: 0.5px;
      border-bottom: 2px solid #e8ecef;
      text-align: left;
      white-space: nowrap;
    }
  }

  tbody {
    tr {
      transition: background 0.2s ease;

      &:hover {
        background: #f8fafb;
      }

      &:not(:last-child) td {
        border-bottom: 1px solid #f0f3f5;
      }
    }

    td {
      padding: 0.875rem 1rem;
      vertical-align: middle;
    }
  }

  .date-cell {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #495057;
    font-size: 0.9rem;

    i {
      color: #6c757d;
    }
  }

  .title-cell {
    font-weight: 500;
    color: #212529;
  }

  .action-buttons {
    display: flex;
    gap: 0.5rem;

    .action-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;

      &.view {
        background: #e3f2fd;
        color: #1976d2;

        &:hover {
          background: #1976d2;
          color: white;
        }
      }

      &.edit {
        background: #fff3e0;
        color: #f57c00;

        &:hover {
          background: #f57c00;
          color: white;
        }
      }

      &.delete {
        background: #ffebee;
        color: #d32f2f;

        &:hover {
          background: #d32f2f;
          color: white;
        }
      }
    }
  }
}

/* Mobile Card View for Homework */
.homework-cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
}

.homework-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e8ecef;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.homework-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f8fafb;
  border-bottom: 1px solid #e8ecef;
}

.homework-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #495057;

  i {
    color: #6c757d;
  }
}

.homework-card-body {
  padding: 0.875rem 1rem;
}

.homework-title {
  font-weight: 600;
  color: #212529;
  font-size: 0.95rem;
}

.homework-card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-top: 1px solid #f0f3f5;
  background: #fafbfc;

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;

    &.view {
      background: #e3f2fd;
      color: #1976d2;

      &:hover {
        background: #1976d2;
        color: white;
      }
    }

    &.edit {
      background: #fff3e0;
      color: #f57c00;

      &:hover {
        background: #f57c00;
        color: white;
      }
    }

    &.delete {
      background: #ffebee;
      color: #d32f2f;

      &:hover {
        background: #d32f2f;
        color: white;
      }
    }
  }

  .action-btns-right {
    display: flex;
    gap: 0.5rem;
  }
}

.empty-state-modern {
  text-align: center;
  padding: 3rem 2rem;

  .empty-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 1rem;
    background: #e3f2fd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 1.75rem;
      color: #1976d2;
    }
  }

  h4 {
    margin: 0 0 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
  }

  p {
    margin: 0 0 0.25rem;
    color: #6c757d;
    font-size: 0.9rem;
  }

  .empty-hint {
    color: #1976d2;
    font-size: 0.85rem;
    font-style: italic;
  }
}

/* Responsive Styles for Homework */
@media (max-width: 768px) {
  .homework-container {
    padding: 0.75rem;
  }

  .homework-section-header {
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
    padding: 1rem;

    .section-title {
      justify-content: center;
    }

    .section-actions {
      width: 100%;

      .add-homework-btn {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .homework-table-wrapper {
    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: flex !important;
    }
  }
}

@media (max-width: 480px) {
  .homework-container {
    padding: 0.5rem;
  }

  .homework-section-header {
    padding: 0.75rem;

    .section-title {
      h3 {
        font-size: 1rem;
      }

      i {
        font-size: 1.1rem;
      }
    }
  }

  .add-homework-btn {
    font-size: 0.85rem;
    padding: 0.5rem 0.75rem;
  }

  .homework-cards {
    padding: 0.75rem;
    gap: 0.6rem;
  }

  .homework-card-header,
  .homework-card-body,
  .homework-card-actions {
    padding: 0.6rem 0.75rem;
  }

  .homework-title {
    font-size: 0.9rem;
  }

  .homework-card-actions {
    flex-direction: column;
    gap: 0.5rem;

    .action-btn.view {
      width: 100%;
      justify-content: center;
    }

    .action-btns-right {
      width: 100%;
      justify-content: flex-end;
    }
  }

  .empty-state-modern {
    padding: 2rem 1rem;

    .empty-icon {
      width: 52px;
      height: 52px;

      i {
        font-size: 1.5rem;
      }
    }

    h4 {
      font-size: 1rem;
    }

    p {
      font-size: 0.85rem;
    }
  }
}

/* Bulk Training Session Management Styles */
.bulk-actions-bar {
  // Same flex-parent fix as .lead-tabs-filters: claim a full row so the
  // games sections below stack underneath instead of wrapping beside it.
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-radius: 12px;
  margin-bottom: 1.25rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .bulk-mode-toggle {
    .custom-switch {
      .custom-control-label {
        font-weight: 600;
        cursor: pointer;
        color: #334155;
      }
    }
  }

  .bulk-actions-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;

    .selected-count {
      font-weight: 600;
      color: #0284c7;
      padding: 0.35rem 0.85rem;
      background: #e0f2fe;
      border-radius: 20px;
      font-size: 0.85rem;
    }

    .btn {
      display: flex;
      align-items: center;
      gap: 0.3rem;
      font-size: 0.85rem;
      font-weight: 500;
      border-radius: 8px;
      padding: 0.4rem 0.75rem;
      transition: all 0.15s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.game.selected-training {
  background: linear-gradient(135deg, #e0f2fe, #f0f9ff) !important;
  border-color: #38bdf8 !important;
  box-shadow:
    0 0 0 3px rgba(56, 189, 248, 0.2),
    0 4px 12px rgba(56, 189, 248, 0.15);
}

.bulk-checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  min-width: 40px;

  .bulk-select-checkbox {
    transform: scale(1.4);
    cursor: pointer;
  }
}

.game {
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  &:hover {
    border-color: #d1d5db;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }

  .game-wrapper {
    width: 100%;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f8fafc;
    }

    .match-details {
      > span {
        display: inline-block;
        font-size: 0.7rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        border-radius: 20px;
      }

      .teams {
        font-size: 1rem;
        font-weight: 600;
        color: #1f2937;
        line-height: 1.4;

        span {
          color: #6b7280;
          font-weight: 400;
          margin: 0 0.3rem;
        }

        .small-text {
          display: block;
          font-size: 0.8rem;
          font-weight: 400;
          color: #6b7280;
          margin-top: 0.2rem;
        }

        .goal-number {
          margin: 0 0.3rem;
          font-weight: bold;
        }
      }

      .game-info {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin-top: 0.5rem;

        span {
          display: inline-flex;
          align-items: center;
          font-size: 0.8rem;
          color: #6b7280;

          i {
            margin-right: 0.4rem;
            color: #9ca3af;
          }
        }
      }
    }
  }

  .player-game-responce {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    width: 100%;
    padding-top: 0.75rem;
    margin-top: 0.75rem;
    border-top: 1px solid #e5e7eb;

    button {
      flex: 1;
      max-width: 60px;
      padding: 0.5rem 0.6rem;
      font-size: 0.85rem;
      border-radius: 6px;
      transition: all 0.15s ease;

      &:hover {
        transform: scale(1.05);
      }
    }

    .recurring-event-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      background: #f0f9ff;
      border-radius: 6px;
      color: #0284c7;

      i {
        font-size: 1rem;
      }
    }
  }
}

/* Training-specific card variant with bulk checkbox */
.game:has(.bulk-checkbox-wrapper) {
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 0.5rem;

  .bulk-checkbox-wrapper {
    flex-shrink: 0;
  }

  .game-wrapper {
    flex: 1;
  }

  .player-game-responce {
    width: 100%;
    flex-basis: 100%;
  }
}

/* Games container styling */
.games {
  margin-bottom: 1.5rem;

  > p {
    font-size: 0.9rem;
    font-weight: 600;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e5e7eb;
  }

  .empty-state {
    text-align: center;
    padding: 3rem 1rem;
    background: #f9fafb;
    border-radius: 12px;
    border: 2px dashed #e5e7eb;

    img {
      width: 120px;
      opacity: 0.7;
      margin-bottom: 1rem;
    }

    p {
      color: #6b7280;
      font-size: 0.95rem;
      margin: 0;
    }
  }
}

/* Results styling for past games */
.with-results {
  .teams {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .goal-and-game-events {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
  }
}

/* Bulk Delete Modal Styles */
.bulk-delete-modal-content {
  .warning-message {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.25rem;
    background: linear-gradient(135deg, #fef3c7, #fef9c3);
    border-radius: 12px;
    margin-bottom: 1.5rem;
    border: 1px solid #fde68a;

    i {
      font-size: 1.5rem;
      flex-shrink: 0;
      color: #d97706;
    }

    p {
      margin: 0;
      color: #92400e;
      line-height: 1.5;
    }
  }

  .sessions-to-delete {
    margin-bottom: 1.5rem;

    h5 {
      font-size: 0.9rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
      color: #374151;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }
}

/* Bulk Edit Modal Styles */
.bulk-edit-modal-content {
  .info-message {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.25rem;
    background: linear-gradient(135deg, #dbeafe, #e0f2fe);
    border-radius: 12px;
    margin-bottom: 1.5rem;
    border: 1px solid #93c5fd;

    i {
      font-size: 1.5rem;
      flex-shrink: 0;
      color: #2563eb;
    }

    p {
      margin: 0;
      color: #1e40af;
      line-height: 1.5;
    }
  }

  .bulk-edit-form {
    .form-row {
      display: flex;
      gap: 1rem;
      margin-bottom: 1rem;

      .form__item {
        flex: 1;
      }
    }

    .form__item {
      margin-bottom: 1rem;

      label {
        font-weight: 500;
        color: #374151;
        margin-bottom: 0.35rem;
      }
    }

    .form-text {
      font-size: 0.75rem;
      display: block;
      margin-top: 0.25rem;
      color: #6b7280;
    }
  }

  .sessions-to-edit {
    margin: 1.5rem 0;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;

    h5 {
      font-size: 0.9rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
      color: #374151;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }
}

/* Shared Training List Styles */
.training-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.04);

  li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    padding: 0.85rem 1rem;
    border-bottom: 1px solid #f3f4f6;
    transition: background-color 0.15s ease;

    &:last-child {
      border-bottom: none;
    }

    &:nth-child(even) {
      background: #f9fafb;
    }

    &:hover {
      background: #f0f9ff;
    }

    .session-date,
    .session-time {
      display: flex;
      align-items: center;
      gap: 0.35rem;
      font-size: 0.85rem;
      color: #374151;
      font-weight: 500;

      i {
        color: #9ca3af;
      }
    }

    .recurring-badge {
      display: inline-flex;
      align-items: center;
      gap: 0.3rem;
      padding: 0.2rem 0.6rem;
      background: linear-gradient(135deg, #e0f2fe, #dbeafe);
      border-radius: 20px;
      font-size: 0.7rem;
      font-weight: 500;
      color: #0369a1;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }
  }
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
  margin-top: 1rem;
}

/* Responsive styles for bulk actions */
@media (max-width: 768px) {
  .bulk-actions-bar {
    flex-direction: column;
    align-items: stretch;

    .bulk-actions-buttons {
      justify-content: center;
    }
  }

  .bulk-edit-modal-content {
    .bulk-edit-form {
      .form-row {
        flex-direction: column;
        gap: 0;
      }
    }
  }

  .training-list {
    li {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
  }

  .modal-actions {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }
}

.eyeball-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  background: #0d6efd;
  color: #fff;
  border: none;
  border-radius: 0.375rem;
  box-shadow:
    0 1px 2px rgba(13, 110, 253, 0.15),
    0 2px 6px rgba(13, 110, 253, 0.1);
  cursor: pointer;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease,
    background 0.12s ease;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.25;
  white-space: nowrap;
  flex-shrink: 0;

  > i {
    font-size: 0.9375rem;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background: #0b5ed7;
    box-shadow:
      0 2px 4px rgba(13, 110, 253, 0.18),
      0 4px 10px rgba(13, 110, 253, 0.16);
    transform: translateY(-1px);
    color: #fff;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(13, 110, 253, 0.15);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
}

.eyeball-import-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.875rem 1.25rem;
  background: #0d6efd;
  color: #fff;
  border: none;
  border-radius: 0.5rem;
  box-shadow:
    0 1px 2px rgba(13, 110, 253, 0.15),
    0 2px 8px rgba(13, 110, 253, 0.12);
  cursor: pointer;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease,
    background 0.12s ease;
  font-family: inherit;
  text-align: left;
  line-height: 1.25;

  > i,
  > .spinner-border {
    font-size: 1.125rem;
    flex-shrink: 0;
  }

  .btn-text {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }

  .btn-title {
    font-size: 0.9375rem;
    font-weight: 600;
    letter-spacing: -0.01em;
  }

  .btn-subtitle {
    font-size: 0.75rem;
    font-weight: 400;
    opacity: 0.85;
    letter-spacing: 0;
  }

  &:hover:not(:disabled) {
    background: #0b5ed7;
    box-shadow:
      0 2px 4px rgba(13, 110, 253, 0.18),
      0 4px 12px rgba(13, 110, 253, 0.18);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(13, 110, 253, 0.15);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
}
</style>
